webpackJsonp([5],{

/***/ 1528:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SettingsAlarms_vue__ = __webpack_require__(1883);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72394d82_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SettingsAlarms_vue__ = __webpack_require__(2238);
function injectStyle (ssrContext) {
  __webpack_require__(2236)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-72394d82"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SettingsAlarms_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72394d82_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SettingsAlarms_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1545:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Otwarte modale w kolejności otwierania. Esc zamyka tylko ostatni, żeby przy
// zagnieżdżonych modalach (np. wykres otwierany z modala szczegółów alarmów)
// nie zamykały się wszystkie naraz.
var openModals = [];

// Esc w otwartej liście vue-select / vue-multiselect zamyka samą listę; przy
// otwartym kalendarzu vue2-datepicker też nie ruszamy modala, żeby jednym
// klawiszem nie stracić wypełnionego formularza.
var OPEN_DROPDOWN = '.vs--open, .multiselect--active';
var OPEN_DATEPICKER = '.mx-datepicker-popup';

// Faza capture: sprawdzamy listy, zanim ich własna obsługa Esc je zamknie.
function onDocumentKeydown(event) {
    if (event.key !== 'Escape' && event.key !== 'Esc') return;

    var topModal = openModals[openModals.length - 1];
    if (topModal == null) return;

    var target = event.target;
    if (target instanceof Element && target.closest(OPEN_DROPDOWN) != null) return;
    if (document.querySelector(OPEN_DATEPICKER) != null) return;

    topModal.$emit('close');
}

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Modal',
    props: {
        showDialog: {
            type: Boolean,
            required: false,
            default: false
        },
        maxWidth: {
            type: String,
            required: false,
            default: ''
        },
        title: {
            type: String,
            required: false,
            default: ''
        }
    },
    watch: {
        showDialog: {
            immediate: true,
            handler: function handler(isOpen) {
                isOpen ? this.registerOpen() : this.unregisterOpen();
            }
        }
    },
    beforeDestroy: function beforeDestroy() {
        this.unregisterOpen();
    },

    computed: {
        style: function style() {
            return 'max-width: ' + this.maxWidth;
        }
    },
    methods: {
        registerOpen: function registerOpen() {
            if (openModals.includes(this)) return;
            openModals.push(this);
            if (openModals.length === 1) {
                document.addEventListener('keydown', onDocumentKeydown, true);
            }
        },
        unregisterOpen: function unregisterOpen() {
            var index = openModals.indexOf(this);
            if (index === -1) return;
            openModals.splice(index, 1);
            if (openModals.length === 0) {
                document.removeEventListener('keydown', onDocumentKeydown, true);
            }
        }
    }
});

/***/ }),

/***/ 1547:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Modal_vue__ = __webpack_require__(1545);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_330662f6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__ = __webpack_require__(1551);
function injectStyle (ssrContext) {
  __webpack_require__(1549)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-330662f6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Modal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_330662f6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1548:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(1558);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),

/***/ 1549:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1550);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("6de141c4", content, true, {});

/***/ }),

/***/ 1550:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".modal[data-v-330662f6]{position:fixed;z-index:110;left:0;top:0;width:100%;height:100%;overflow:auto;display:block;background-color:rgba(0,0,0,.4)}.flex-container[data-v-330662f6]{height:100%;padding:0;margin:0;display:-webkit-box;display:-ms-flexbox;display:flex}.modal-content[data-v-330662f6]{margin:auto;background-color:#fefefe;border:unset;width:auto;z-index:1000;border-radius:5px;-webkit-box-shadow:0 4px 10px rgba(0,0,0,.2);box-shadow:0 4px 10px rgba(0,0,0,.2)}.modal-header[data-v-330662f6]{background-color:#34758e;width:100%;font-family:SourceSansProBold,sans-serif;font-size:16px;font-style:normal;font-weight:600;color:#fff}.close[data-v-330662f6]{color:#fff;float:right;font-size:28px;font-weight:700}.close[data-v-330662f6]:focus,.close[data-v-330662f6]:hover{color:#000;text-decoration:none;cursor:pointer}.widthClass[data-v-330662f6]{max-width:30%}#mdiv[data-v-330662f6]{width:25px;height:25px;cursor:pointer}.mdiv[data-v-330662f6]{height:25px;width:2px;margin-left:12px;background-color:#fff;-webkit-transform:rotate(45deg);transform:rotate(45deg);Z-index:1}.md[data-v-330662f6]{height:25px;width:2px;background-color:#fff;-webkit-transform:rotate(90deg);transform:rotate(90deg);Z-index:2}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/Modal.vue"],"names":[],"mappings":"AACA,wBACI,eAAgB,AAGhB,YAAa,AACb,OAAQ,AACR,MAAO,AACP,WAAY,AACZ,YAAa,AACb,cAAe,AACf,cAAe,AACf,+BAAkC,CACrC,AACD,iCACI,YAAa,AACb,UAAW,AACX,SAAU,AACV,oBAAqB,AACrB,oBAAqB,AACrB,YAAc,CACjB,AAKD,gCACI,YAAa,AACb,yBAA0B,AAC1B,aAAc,AACd,WAAY,AACZ,aAAc,AACd,kBAAmB,AACnB,6CAAiD,AACzC,oCAAyC,CACpD,AACD,+BACI,yBAA2B,AAC3B,WAAY,AACZ,yCAA6C,AAC7C,eAAgB,AAChB,kBAAmB,AACnB,gBAAiB,AACjB,UAAa,CAChB,AACD,wBACI,WAAa,AACb,YAAa,AACb,eAAgB,AAChB,eAAkB,CACrB,AACD,4DAEI,WAAa,AACb,qBAAsB,AACtB,cAAgB,CACnB,AACD,6BACI,aAAe,CAClB,AAKD,uBACE,WAAY,AACZ,YAAa,AACb,cAAgB,CACjB,AACD,uBACE,YAAa,AACb,UAAW,AACX,iBAAkB,AAClB,sBAAwB,AACxB,gCAAiC,AACzB,wBAAyB,AACjC,SAAW,CACZ,AACD,qBACE,YAAa,AACb,UAAW,AACX,sBAAwB,AACxB,gCAAiC,AACzB,wBAAyB,AACjC,SAAW,CACZ","file":"Modal.vue","sourcesContent":["\n.modal[data-v-330662f6] {\n    position: fixed;\n    /* Nad paskiem górnym (.app-header, z-index 20) i mobilnym menu (99/100),\n       ale pod popupami doklejanymi do body (Syncfusion 1000, datepicker 2001). */\n    z-index: 110;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    overflow: auto;\n    display: block;\n    background-color: rgba(0,0,0,0.4);\n}\n.flex-container[data-v-330662f6] {\n    height: 100%;\n    padding: 0;\n    margin: 0;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n\n/* margin: auto zamiast align-items/justify-content: center — modal wyższy od\n   ekranu zaczyna się od góry i da się go przewinąć do nagłówka z krzyżykiem\n   (przy centrowaniu flexem jego górna część wystawała poza ekran). */\n.modal-content[data-v-330662f6] {\n    margin: auto;\n    background-color: #fefefe;\n    border: unset;\n    width: auto;\n    z-index: 1000;\n    border-radius: 5px;\n    -webkit-box-shadow: 0px 4px 10px rgba(0,0,0,0.2);\n            box-shadow: 0px 4px 10px rgba(0,0,0,0.2);\n}\n.modal-header[data-v-330662f6] {\n    background-color:  #34758E;\n    width: 100%;\n    font-family: \"SourceSansProBold\", sans-serif;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 600;\n    color: white;\n}\n.close[data-v-330662f6] {\n    color: white;\n    float: right;\n    font-size: 28px;\n    font-weight: bold;\n}\n.close[data-v-330662f6]:hover,\n.close[data-v-330662f6]:focus {\n    color: black;\n    text-decoration: none;\n    cursor: pointer;\n}\n.widthClass[data-v-330662f6] {\n    max-width: 30%;\n}\n.modal-slot[data-v-330662f6] {\n    /* margin-right: 10px;\n    margin-left: 10px; */\n}\n#mdiv[data-v-330662f6] {\n  width: 25px;\n  height: 25px;\n  cursor: pointer;\n}\n.mdiv[data-v-330662f6] {\n  height: 25px;\n  width: 2px;\n  margin-left: 12px;\n  background-color: white;\n  -webkit-transform: rotate(45deg);\n          transform: rotate(45deg);\n  Z-index: 1;\n}\n.md[data-v-330662f6] {\n  height: 25px;\n  width: 2px;\n  background-color: white;\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n  Z-index: 2;\n}\n\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1551:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showDialog)?_c('div',{staticClass:"modal flex-container"},[_c('div',{staticClass:"modal-content vertical",style:(_vm.style)},[_c('div',{staticClass:"modal-header"},[(_vm.title != undefined)?_c('p',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.title != null ? _vm.title : '')+" ")]):_vm._e(),_vm._v(" "),_c('div',{attrs:{"id":"mdiv"},on:{"click":function($event){return _vm.$emit('close')}}},[_vm._m(0)])]),_vm._v(" "),_c('div',{staticClass:"modal-slot"},[_vm._t("default")],2)])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mdiv"},[_c('div',{staticClass:"md"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1552:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isDate */
/* harmony export (immutable) */ __webpack_exports__["d"] = toDate;
/* harmony export (immutable) */ __webpack_exports__["b"] = isValidDate;
/* unused harmony export startOfWeek */
/* harmony export (immutable) */ __webpack_exports__["c"] = startOfWeekYear;
/* harmony export (immutable) */ __webpack_exports__["a"] = getWeek;
function isDate(value) {
  return value instanceof Date || Object.prototype.toString.call(value) === '[object Date]';
}
function toDate(value) {
  if (isDate(value)) {
    return new Date(value.getTime());
  }

  if (value == null) {
    return new Date(NaN);
  }

  return new Date(value);
}
function isValidDate(value) {
  return isDate(value) && !isNaN(value.getTime());
}
function startOfWeek(value) {
  var firstDayOfWeek = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  if (!(firstDayOfWeek >= 0 && firstDayOfWeek <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6');
  }

  var date = toDate(value);
  var day = date.getDay();
  var diff = (day + 7 - firstDayOfWeek) % 7;
  date.setDate(date.getDate() - diff);
  date.setHours(0, 0, 0, 0);
  return date;
}
function startOfWeekYear(value) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$firstDayOfWeek = _ref.firstDayOfWeek,
      firstDayOfWeek = _ref$firstDayOfWeek === void 0 ? 0 : _ref$firstDayOfWeek,
      _ref$firstWeekContain = _ref.firstWeekContainsDate,
      firstWeekContainsDate = _ref$firstWeekContain === void 0 ? 1 : _ref$firstWeekContain;

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7');
  }

  var date = toDate(value);
  var year = date.getFullYear();
  var firstDateOfFirstWeek = new Date(0);

  for (var i = year + 1; i >= year - 1; i--) {
    firstDateOfFirstWeek.setFullYear(i, 0, firstWeekContainsDate);
    firstDateOfFirstWeek.setHours(0, 0, 0, 0);
    firstDateOfFirstWeek = startOfWeek(firstDateOfFirstWeek, firstDayOfWeek);

    if (date.getTime() >= firstDateOfFirstWeek.getTime()) {
      break;
    }
  }

  return firstDateOfFirstWeek;
}
function getWeek(value) {
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref2$firstDayOfWeek = _ref2.firstDayOfWeek,
      firstDayOfWeek = _ref2$firstDayOfWeek === void 0 ? 0 : _ref2$firstDayOfWeek,
      _ref2$firstWeekContai = _ref2.firstWeekContainsDate,
      firstWeekContainsDate = _ref2$firstWeekContai === void 0 ? 1 : _ref2$firstWeekContai;

  var date = toDate(value);
  var firstDateOfThisWeek = startOfWeek(date, firstDayOfWeek);
  var firstDateOfFirstWeek = startOfWeekYear(date, {
    firstDayOfWeek: firstDayOfWeek,
    firstWeekContainsDate: firstWeekContainsDate
  });
  var diff = firstDateOfThisWeek.getTime() - firstDateOfFirstWeek.getTime();
  return Math.round(diff / (7 * 24 * 3600 * 1000)) + 1;
}

/***/ }),

/***/ 1556:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createChartTheme */
/* unused harmony export chartTooltipColors */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return chartThemeMixin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_scichart_Charting_Themes_SciChartJSLightTheme__ = __webpack_require__(971);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_scichart_Charting_Themes_SciChartJSLightTheme___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_scichart_Charting_Themes_SciChartJSLightTheme__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_scichart_Charting_Themes_SciChartJSDarkv2Theme__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_scichart_Charting_Themes_SciChartJSDarkv2Theme___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_scichart_Charting_Themes_SciChartJSDarkv2Theme__);



// Wykresy rysują na canvasie, więc tokeny CSS z theme.css do nich nie sięgają —
// motyw SciChart dobieramy osobno, z tego samego rozwiązanego motywu aplikacji.

// Tło jak --surface ciemnego motywu, zamiast grafitowego gradientu paczki,
// żeby wykres nie odcinał się od karty, w której stoi.
var DARK_BACKGROUND = "#172124";

function createChartTheme(resolvedTheme) {
    if (resolvedTheme !== "dark") return new __WEBPACK_IMPORTED_MODULE_0_scichart_Charting_Themes_SciChartJSLightTheme__["SciChartJSLightTheme"]();

    var theme = new __WEBPACK_IMPORTED_MODULE_1_scichart_Charting_Themes_SciChartJSDarkv2Theme__["SciChartJSDarkv2Theme"]();
    theme.sciChartBackground = DARK_BACKGROUND;
    theme.loadingAnimationBackground = DARK_BACKGROUND;
    return theme;
}

// Dymki rollovera rysowane własnym szablonem SVG mają kolory wpisane w SVG,
// więc applyTheme ich nie zmienia. Jasne to dotychczasowy biały dymek z czarnym
// tekstem, ciemne — kolory wysuwanych paneli z theme.css (--popover-*).
var TOOLTIP_COLORS = {
    light: { background: "#ffffff", border: "#000000", text: "#000000" },
    dark: { background: "#1b2629", border: "#50676d", text: "#e8f1f3" }
};

function chartTooltipColors(resolvedTheme) {
    return resolvedTheme === "dark" ? TOOLTIP_COLORS.dark : TOOLTIP_COLORS.light;
}

// Wykres woła this.chartTheme() przy tworzeniu powierzchni, a mixin
// przemalowuje już narysowane wykresy, gdy użytkownik zmieni motyw.
// Wymaga, żeby komponent trzymał powierzchnię w this.sciChartSurface.
var chartThemeMixin = {
    watch: {
        "$store.getters.resolvedTheme": function $storeGettersResolvedTheme() {
            if (this.sciChartSurface) this.sciChartSurface.applyTheme(this.chartTheme());
        }
    },
    methods: {
        chartTheme: function chartTheme() {
            return createChartTheme(this.$store.getters.resolvedTheme);
        },

        // Szablon dymka woła to przy każdym rysowaniu, więc zmiana motywu działa od razu.
        tooltipColors: function tooltipColors() {
            return chartTooltipColors(this.$store.getters.resolvedTheme);
        }
    }
};

/***/ }),

/***/ 1557:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var locale = {
  months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
  monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  weekdays: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
  weekdaysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  weekdaysMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  firstDayOfWeek: 0,
  firstWeekContainsDate: 1
};
/* harmony default export */ __webpack_exports__["a"] = (locale);

/***/ }),

/***/ 1558:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1559), __esModule: true };

/***/ }),

/***/ 1559:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(960);
__webpack_require__(1560);
module.exports = __webpack_require__(105).Array.from;


/***/ }),

/***/ 1560:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(222);
var $export = __webpack_require__(183);
var toObject = __webpack_require__(954);
var call = __webpack_require__(966);
var isArrayIter = __webpack_require__(967);
var toLength = __webpack_require__(446);
var createProperty = __webpack_require__(1561);
var getIterFn = __webpack_require__(962);

$export($export.S + $export.F * !__webpack_require__(968)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),

/***/ 1561:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(184);
var createDesc = __webpack_require__(447);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),

/***/ 1566:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTUiIHZpZXdCb3g9IjAgMCAxNSAxNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTcuNSAxLjVDNC4xODYyOSAxLjUgMS41IDQuMTg2MjkgMS41IDcuNUMxLjUgMTAuODEzNyA0LjE4NjI5IDEzLjUgNy41IDEzLjVDMTAuODEzNyAxMy41IDEzLjUgMTAuODEzNyAxMy41IDcuNUMxMy41IDQuMTg2MjkgMTAuODEzNyAxLjUgNy41IDEuNVpNMCA3LjVDMCAzLjM1Nzg2IDMuMzU3ODYgMCA3LjUgMEMxMS42NDIxIDAgMTUgMy4zNTc4NiAxNSA3LjVDMTUgMTEuNjQyMSAxMS42NDIxIDE1IDcuNSAxNUMzLjM1Nzg2IDE1IDAgMTEuNjQyMSAwIDcuNVpNMTAuOTk4MyA1LjA2NDQ0QzExLjMwNzkgNS4zMzk2MyAxMS4zMzU3IDUuODEzNjkgMTEuMDYwNiA2LjEyMzI3TDcuMDYwNTYgMTAuNjIzM0M2LjkxODIzIDEwLjc4MzQgNi43MTQyMyAxMC44NzUgNi41IDEwLjg3NUM2LjI4NTc3IDEwLjg3NSA2LjA4MTc3IDEwLjc4MzQgNS45Mzk0NCAxMC42MjMzTDMuOTM5NDQgOC4zNzMyN0MzLjY2NDI1IDguMDYzNjkgMy42OTIxNCA3LjU4OTYzIDQuMDAxNzMgNy4zMTQ0NEM0LjMxMTMxIDcuMDM5MjUgNC43ODUzNyA3LjA2NzE0IDUuMDYwNTYgNy4zNzY3M0w2LjUgOC45OTYxTDkuOTM5NDQgNS4xMjY3M0MxMC4yMTQ2IDQuODE3MTQgMTAuNjg4NyA0Ljc4OTI1IDEwLjk5ODMgNS4wNjQ0NFoiIGZpbGw9IiMxRUNENzQiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ 1567:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNSAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTcuNSA4LjM1ODUxQzcuMDk5NjUgOC4zNTg1MSA2Ljc3NTExIDguMDQyNzkgNi43NzUxMSA3LjY1MzMyVjUuNTM3NzZDNi43NzUxMSA1LjE0ODMgNy4wOTk2NSA0LjgzMjU4IDcuNSA0LjgzMjU4QzcuOTAwMzUgNC44MzI1OCA4LjIyNDg5IDUuMTQ4MyA4LjIyNDg5IDUuNTM3NzZWNy42NTMzMkM4LjIyNDg5IDguMDQyNzkgNy45MDAzNSA4LjM1ODUxIDcuNSA4LjM1ODUxWiIgZmlsbD0iI0ZGQjgwMCIvPgo8cGF0aCBkPSJNNi40MTI2NiAxMC4xMjE1QzYuNDEyNjYgOS41MzcyOCA2Ljg5OTQ4IDkuMDYzNjkgNy41IDkuMDYzNjlDOC4xMDA1MiA5LjA2MzY5IDguNTg3MzQgOS41MzcyOCA4LjU4NzM0IDEwLjEyMTVDOC41ODczNCAxMC43MDU3IDguMTAwNTIgMTEuMTc5MyA3LjUgMTEuMTc5M0M2Ljg5OTQ4IDExLjE3OTMgNi40MTI2NiAxMC43MDU3IDYuNDEyNjYgMTAuMTIxNVoiIGZpbGw9IiNGRkI4MDAiLz4KPHBhdGggZD0iTTYuMjE3MDYgMC43NTM0OTdDNi43NjA2IC0wLjI1MTE2MiA4LjIzOTQgLTAuMjUxMTY5IDguNzgyOTQgMC43NTM0OTZMMTQuODMxMiAxMS45MzI3QzE1LjMzOTMgMTIuODcxOSAxNC42MzkyIDE0IDEzLjU0ODIgMTRIMS40NTE3NkMwLjM2MDc4MyAxNCAtMC4zMzkzIDEyLjg3MTkgMC4xNjg4MTkgMTEuOTMyOEw2LjIxNzA2IDAuNzUzNDk3Wk0xMy41NDgyIDEyLjU4OTZMNy41IDEuNDEwMzdMMS40NTE3NiAxMi41ODk2TDEzLjU0ODIgMTIuNTg5NloiIGZpbGw9IiNGRkI4MDAiLz4KPC9zdmc+Cg=="

/***/ }),

/***/ 1568:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTUiIHZpZXdCb3g9IjAgMCAxNSAxNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTcuNSAxLjVDNC4xODYyOSAxLjUgMS41IDQuMTg2MjkgMS41IDcuNUMxLjUgMTAuODEzNyA0LjE4NjI5IDEzLjUgNy41IDEzLjVDMTAuODEzNyAxMy41IDEzLjUgMTAuODEzNyAxMy41IDcuNUMxMy41IDQuMTg2MjkgMTAuODEzNyAxLjUgNy41IDEuNVpNMCA3LjVDMCAzLjM1Nzg2IDMuMzU3ODYgMCA3LjUgMEMxMS42NDIxIDAgMTUgMy4zNTc4NiAxNSA3LjVDMTUgMTEuNjQyMSAxMS42NDIxIDE1IDcuNSAxNUMzLjM1Nzg2IDE1IDAgMTEuNjQyMSAwIDcuNVpNNC4zNDQ2NyA0LjM0NDY3QzQuNjM3NTYgNC4wNTE3OCA1LjExMjQ0IDQuMDUxNzggNS40MDUzMyA0LjM0NDY3TDcuNSA2LjQzOTM0TDkuNTk0NjcgNC4zNDQ2N0M5Ljg4NzU2IDQuMDUxNzggMTAuMzYyNCA0LjA1MTc4IDEwLjY1NTMgNC4zNDQ2N0MxMC45NDgyIDQuNjM3NTYgMTAuOTQ4MiA1LjExMjQ0IDEwLjY1NTMgNS40MDUzM0w4LjU2MDY2IDcuNUwxMC42NTUzIDkuNTk0NjdDMTAuOTQ4MiA5Ljg4NzU2IDEwLjk0ODIgMTAuMzYyNCAxMC42NTUzIDEwLjY1NTNDMTAuMzYyNCAxMC45NDgyIDkuODg3NTYgMTAuOTQ4MiA5LjU5NDY3IDEwLjY1NTNMNy41IDguNTYwNjZMNS40MDUzMyAxMC42NTUzQzUuMTEyNDQgMTAuOTQ4MiA0LjYzNzU2IDEwLjk0ODIgNC4zNDQ2NyAxMC42NTUzQzQuMDUxNzggMTAuMzYyNCA0LjA1MTc4IDkuODg3NTYgNC4zNDQ2NyA5LjU5NDY3TDYuNDM5MzQgNy41TDQuMzQ0NjcgNS40MDUzM0M0LjA1MTc4IDUuMTEyNDQgNC4wNTE3OCA0LjYzNzU2IDQuMzQ0NjcgNC4zNDQ2N1oiIGZpbGw9IiNGRjM3MzciLz4KPC9zdmc+Cg=="

/***/ }),

/***/ 1572:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_format_parse__ = __webpack_require__(1573);


function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _extends$1() {
  return _extends$1 = Object.assign || function (a) {
    for (var b, c = 1; c < arguments.length; c++) {
      for (var d in b = arguments[c], b) {
        Object.prototype.hasOwnProperty.call(b, d) && (a[d] = b[d]);
      }
    }

    return a;
  }, _extends$1.apply(this, arguments);
}

var normalMerge = ["attrs", "props", "domProps"],
    toArrayMerge = ["class", "style", "directives"],
    functionalMerge = ["on", "nativeOn"],
    mergeJsxProps = function mergeJsxProps(a) {
  return a.reduce(function (c, a) {
    for (var b in a) {
      if (!c[b]) c[b] = a[b];else if (-1 !== normalMerge.indexOf(b)) c[b] = _extends$1({}, c[b], a[b]);else if (-1 !== toArrayMerge.indexOf(b)) {
        var d = c[b] instanceof Array ? c[b] : [c[b]],
            e = a[b] instanceof Array ? a[b] : [a[b]];
        c[b] = d.concat(e);
      } else if (-1 !== functionalMerge.indexOf(b)) {
        for (var f in a[b]) {
          if (c[b][f]) {
            var g = c[b][f] instanceof Array ? c[b][f] : [c[b][f]],
                h = a[b][f] instanceof Array ? a[b][f] : [a[b][f]];
            c[b][f] = g.concat(h);
          } else c[b][f] = a[b][f];
        }
      } else if ("hook" == b) for (var i in a[b]) {
        c[b][i] = c[b][i] ? mergeFn(c[b][i], a[b][i]) : a[b][i];
      } else c[b] = a[b];
    }

    return c;
  }, {});
},
    mergeFn = function mergeFn(a, b) {
  return function () {
    a && a.apply(this, arguments), b && b.apply(this, arguments);
  };
};

var helper = mergeJsxProps;

// new Date(10, 0, 1) The year from 0 to 99 will be incremented by 1900 automatically.
function createDate(y) {
  var M = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var d = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var h = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  var m = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
  var s = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
  var ms = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
  var date = new Date(y, M, d, h, m, s, ms);

  if (y < 100 && y >= 0) {
    date.setFullYear(y);
  }

  return date;
}
function isValidDate(date) {
  return date instanceof Date && !isNaN(date);
}
function isValidRangeDate(date) {
  return Array.isArray(date) && date.length === 2 && date.every(isValidDate) && date[0] <= date[1];
}
function isValidDates(dates) {
  return Array.isArray(dates) && dates.every(isValidDate);
}
function getValidDate(value) {
  var date = new Date(value);

  if (isValidDate(date)) {
    return date;
  }

  for (var _len = arguments.length, backup = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    backup[_key - 1] = arguments[_key];
  }

  if (backup.length) {
    return getValidDate.apply(void 0, backup);
  }

  return new Date();
}
function startOfYear(value) {
  var date = new Date(value);
  date.setMonth(0, 1);
  date.setHours(0, 0, 0, 0);
  return date;
}
function startOfMonth(value) {
  var date = new Date(value);
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
  return date;
}
function startOfDay(value) {
  var date = new Date(value);
  date.setHours(0, 0, 0, 0);
  return date;
}
function getCalendar(_ref) {
  var firstDayOfWeek = _ref.firstDayOfWeek,
      year = _ref.year,
      month = _ref.month;
  var arr = []; // change to the last day of the last month

  var calendar = createDate(year, month, 0);
  var lastDayInLastMonth = calendar.getDate(); // getDay() 0 is Sunday, 1 is Monday

  var firstDayInLastMonth = lastDayInLastMonth - (calendar.getDay() + 7 - firstDayOfWeek) % 7;

  for (var i = firstDayInLastMonth; i <= lastDayInLastMonth; i++) {
    arr.push(createDate(year, month, i - lastDayInLastMonth));
  } // change to the last day of the current month


  calendar.setMonth(month + 1, 0);
  var lastDayInCurrentMonth = calendar.getDate();

  for (var _i = 1; _i <= lastDayInCurrentMonth; _i++) {
    arr.push(createDate(year, month, _i));
  }

  var lastMonthLength = lastDayInLastMonth - firstDayInLastMonth + 1;
  var nextMonthLength = 6 * 7 - lastMonthLength - lastDayInCurrentMonth;

  for (var _i2 = 1; _i2 <= nextMonthLength; _i2++) {
    arr.push(createDate(year, month, lastDayInCurrentMonth + _i2));
  }

  return arr;
}
function setMonth(dirtyDate, dirtyMonth) {
  var date = new Date(dirtyDate);
  var month = typeof dirtyMonth === 'function' ? dirtyMonth(date.getMonth()) : Number(dirtyMonth);
  var year = date.getFullYear();
  var daysInMonth = createDate(year, month + 1, 0).getDate();
  var day = date.getDate();
  date.setMonth(month, Math.min(day, daysInMonth));
  return date;
}
function setYear(dirtyDate, dirtyYear) {
  var date = new Date(dirtyDate);
  var year = typeof dirtyYear === 'function' ? dirtyYear(date.getFullYear()) : dirtyYear;
  date.setFullYear(year);
  return date;
}
function assignTime(target, source) {
  var date = new Date(target);
  var time = new Date(source);
  date.setHours(time.getHours(), time.getMinutes(), time.getSeconds());
  return date;
}

/**
 * chunk the array
 * @param {Array} arr
 * @param {Number} size
 */
function chunk(arr, size) {
  if (!Array.isArray(arr)) {
    return [];
  }

  var result = [];
  var len = arr.length;
  var i = 0;
  size = size || len;

  while (i < len) {
    result.push(arr.slice(i, i += size));
  }

  return result;
}
/**
 * isObject
 * @param {*} obj
 * @returns {Boolean}
 */

function isObject(obj) {
  return Object.prototype.toString.call(obj) === '[object Object]';
}
/**
 * pick object
 * @param {Object} obj
 * @param {Array|String} props
 */

function pick(obj, props) {
  if (!isObject(obj)) return {};

  if (!Array.isArray(props)) {
    props = [props];
  }

  var res = {};
  props.forEach(function (prop) {
    if (prop in obj) {
      res[prop] = obj[prop];
    }
  });
  return res;
}
/**
 * deep merge two object without merging array
 * @param {object} target
 * @param {object} source
 */

function mergeDeep(target, source) {
  if (!isObject(target)) {
    return {};
  }

  var result = target;

  if (isObject(source)) {
    Object.keys(source).forEach(function (key) {
      var value = source[key];

      if (isObject(value) && isObject(target[key])) {
        value = mergeDeep(target[key], value);
      }

      result = _objectSpread2({}, result, _defineProperty({}, key, value));
    });
  }

  return result;
}

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var en = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var locale = {
  months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
  monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  weekdays: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
  weekdaysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  weekdaysMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  firstDayOfWeek: 0,
  firstWeekContainsDate: 1
};
var _default = locale;
exports["default"] = _default;
module.exports = exports.default;
});

var en$1 = unwrapExports(en);

var lang = {
  formatLocale: en$1,
  yearFormat: 'YYYY',
  monthFormat: 'MMM',
  monthBeforeYear: true
};

var defaultLocale = 'en';
var locales = {};
locales[defaultLocale] = lang;
function locale(name, object, isLocal) {
  if (typeof name !== 'string') return locales[defaultLocale];
  var l = defaultLocale;

  if (locales[name]) {
    l = name;
  }

  if (object) {
    locales[name] = object;
    l = name;
  }

  if (!isLocal) {
    defaultLocale = l;
  }

  return locales[name] || locales[defaultLocale];
}
/**
 * get locale object
 * @param {string} name lang
 */

function getLocale(name) {
  return locale(name, null, true);
}

/* istanbul ignore file */
function rafThrottle(fn) {
  var isRunning = false;
  return function fnBinfRaf() {
    var _this = this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (isRunning) return;
    isRunning = true;
    requestAnimationFrame(function () {
      isRunning = false;
      fn.apply(_this, args);
    });
  };
}

/**
 * get the hidden element width, height
 * @param {HTMLElement} element dom
 */
function getPopupElementSize(element) {
  var originalDisplay = element.style.display;
  var originalVisibility = element.style.visibility;
  element.style.display = 'block';
  element.style.visibility = 'hidden';
  var styles = window.getComputedStyle(element);
  var width = element.offsetWidth + parseInt(styles.marginLeft, 10) + parseInt(styles.marginRight, 10);
  var height = element.offsetHeight + parseInt(styles.marginTop, 10) + parseInt(styles.marginBottom, 10);
  element.style.display = originalDisplay;
  element.style.visibility = originalVisibility;
  return {
    width: width,
    height: height
  };
}
/**
 * get the popup position
 * @param {HTMLElement} el relative element
 * @param {Number} targetWidth target element's width
 * @param {Number} targetHeight target element's height
 * @param {Boolean} fixed
 */

function getRelativePosition(el, targetWidth, targetHeight, fixed) {
  var left = 0;
  var top = 0;
  var offsetX = 0;
  var offsetY = 0;
  var relativeRect = el.getBoundingClientRect();
  var dw = document.documentElement.clientWidth;
  var dh = document.documentElement.clientHeight;

  if (fixed) {
    offsetX = window.pageXOffset + relativeRect.left;
    offsetY = window.pageYOffset + relativeRect.top;
  }

  if (dw - relativeRect.left < targetWidth && relativeRect.right < targetWidth) {
    left = offsetX - relativeRect.left + 1;
  } else if (relativeRect.left + relativeRect.width / 2 <= dw / 2) {
    left = offsetX;
  } else {
    left = offsetX + relativeRect.width - targetWidth;
  }

  if (relativeRect.top <= targetHeight && dh - relativeRect.bottom <= targetHeight) {
    top = offsetY + dh - relativeRect.top - targetHeight;
  } else if (relativeRect.top + relativeRect.height / 2 <= dh / 2) {
    top = offsetY + relativeRect.height;
  } else {
    top = offsetY - targetHeight;
  }

  return {
    left: "".concat(left, "px"),
    top: "".concat(top, "px")
  };
}
function getScrollParent(node) {
  var until = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document.body;

  if (!node || node === until) {
    return null;
  }

  var style = function style(value, prop) {
    return getComputedStyle(value, null).getPropertyValue(prop);
  };

  var regex = /(auto|scroll)/;
  var scroll = regex.test(style(node, 'overflow') + style(node, 'overflow-y') + style(node, 'overflow-x'));
  return scroll ? node : getScrollParent(node.parentNode, until);
}

//
var script = {
  name: 'Popup',
  inject: {
    prefixClass: {
      default: 'mx'
    }
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    appendToBody: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      top: '',
      left: ''
    };
  },
  watch: {
    visible: {
      immediate: true,
      handler: function handler(val) {
        var _this = this;

        this.$nextTick(function () {
          if (val) {
            _this.displayPopup();
          }
        });
      }
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    if (this.appendToBody) {
      document.body.appendChild(this.$el);
    }

    this._clickoutEvent = 'ontouchend' in document ? 'touchstart' : 'mousedown';
    document.addEventListener(this._clickoutEvent, this.handleClickOutside); // change the popup position when resize or scroll

    var relativeElement = this.$parent.$el;
    this._displayPopup = rafThrottle(function () {
      return _this2.displayPopup();
    });
    this._scrollParent = getScrollParent(relativeElement) || window;

    this._scrollParent.addEventListener('scroll', this._displayPopup);

    window.addEventListener('resize', this._displayPopup);
  },
  beforeDestroy: function beforeDestroy() {
    if (this.appendToBody && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }

    document.removeEventListener(this._clickoutEvent, this.handleClickOutside);

    this._scrollParent.removeEventListener('scroll', this._displayPopup);

    window.removeEventListener('resize', this._displayPopup);
  },
  methods: {
    handleClickOutside: function handleClickOutside(evt) {
      if (!this.visible) return;
      var target = evt.target;
      var el = this.$el;

      if (el && !el.contains(target)) {
        this.$emit('clickoutside', evt);
      }
    },
    displayPopup: function displayPopup() {
      if (!this.visible) return;
      var popup = this.$el;
      var relativeElement = this.$parent.$el;
      var appendToBody = this.appendToBody;

      if (!this._popupRect) {
        this._popupRect = getPopupElementSize(popup);
      }

      var _this$_popupRect = this._popupRect,
          width = _this$_popupRect.width,
          height = _this$_popupRect.height;

      var _getRelativePosition = getRelativePosition(relativeElement, width, height, appendToBody),
          left = _getRelativePosition.left,
          top = _getRelativePosition.top;

      this.left = left;
      this.top = top;
    }
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
/* server only */
, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== 'boolean') {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  } // Vue.extend constructor export interop.


  var options = typeof script === 'function' ? script.options : script; // render functions

  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true; // functional template

    if (isFunctionalTemplate) {
      options.functional = true;
    }
  } // scopedId


  if (scopeId) {
    options._scopeId = scopeId;
  }

  var hook;

  if (moduleIdentifier) {
    // server build
    hook = function hook(context) {
      // 2.3 injection
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
      // 2.2 with runInNewContext: true

      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
      } // inject component styles


      if (style) {
        style.call(this, createInjectorSSR(context));
      } // register component module identifier for async chunk inference


      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    }; // used by ssr in case component is cached and beforeCreate
    // never gets called


    options._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode ? function (context) {
      style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
    } : function (context) {
      style.call(this, createInjector(context));
    };
  }

  if (hook) {
    if (options.functional) {
      // register for functional component in vue file
      var originalRender = options.render;

      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }

  return script;
}

/* script */
var __vue_script__ = script;
/* template */

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('transition', {
    attrs: {
      "name": _vm.prefixClass + "-zoom-in-down"
    }
  }, [_vm.visible ? _c('div', {
    class: _vm.prefixClass + "-datepicker-main " + _vm.prefixClass + "-datepicker-popup",
    style: {
      top: _vm.top,
      left: _vm.left,
      position: 'absolute'
    }
  }, [_vm._t("default")], 2) : _vm._e()]);
};

var __vue_staticRenderFns__ = [];
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__ = normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);

/* script */

/* template */
var __vue_render__$1 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 1024 1024",
      "width": "1em",
      "height": "1em"
    }
  }, [_c('path', {
    attrs: {
      "d": "M940.218182 107.054545h-209.454546V46.545455h-65.163636v60.50909H363.054545V46.545455H297.890909v60.50909H83.781818c-18.618182 0-32.581818 13.963636-32.581818 32.581819v805.236363c0 18.618182 13.963636 32.581818 32.581818 32.581818h861.090909c18.618182 0 32.581818-13.963636 32.581818-32.581818V139.636364c-4.654545-18.618182-18.618182-32.581818-37.236363-32.581819zM297.890909 172.218182V232.727273h65.163636V172.218182h307.2V232.727273h65.163637V172.218182h176.872727v204.8H116.363636V172.218182h181.527273zM116.363636 912.290909V442.181818h795.927273v470.109091H116.363636z"
    }
  })]);
};

var __vue_staticRenderFns__$1 = [];
/* style */

var __vue_inject_styles__$1 = undefined;
/* scoped */

var __vue_scope_id__$1 = undefined;
/* module identifier */

var __vue_module_identifier__$1 = undefined;
/* functional template */

var __vue_is_functional_template__$1 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$1 = normalizeComponent({
  render: __vue_render__$1,
  staticRenderFns: __vue_staticRenderFns__$1
}, __vue_inject_styles__$1, {}, __vue_scope_id__$1, __vue_is_functional_template__$1, __vue_module_identifier__$1, false, undefined, undefined, undefined);

/* script */

/* template */
var __vue_render__$2 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 24 24",
      "width": "1em",
      "height": "1em"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
    }
  })]);
};

var __vue_staticRenderFns__$2 = [];
/* style */

var __vue_inject_styles__$2 = undefined;
/* scoped */

var __vue_scope_id__$2 = undefined;
/* module identifier */

var __vue_module_identifier__$2 = undefined;
/* functional template */

var __vue_is_functional_template__$2 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$2 = normalizeComponent({
  render: __vue_render__$2,
  staticRenderFns: __vue_staticRenderFns__$2
}, __vue_inject_styles__$2, {}, __vue_scope_id__$2, __vue_is_functional_template__$2, __vue_module_identifier__$2, false, undefined, undefined, undefined);

/* script */

/* template */
var __vue_render__$3 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 1024 1024",
      "width": "1em",
      "height": "1em"
    }
  }, [_c('path', {
    attrs: {
      "d": "M810.005333 274.005333l-237.994667 237.994667 237.994667 237.994667-60.010667 60.010667-237.994667-237.994667-237.994667 237.994667-60.010667-60.010667 237.994667-237.994667-237.994667-237.994667 60.010667-60.010667 237.994667 237.994667 237.994667-237.994667z"
    }
  })]);
};

var __vue_staticRenderFns__$3 = [];
/* style */

var __vue_inject_styles__$3 = undefined;
/* scoped */

var __vue_scope_id__$3 = undefined;
/* module identifier */

var __vue_module_identifier__$3 = undefined;
/* functional template */

var __vue_is_functional_template__$3 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$3 = normalizeComponent({
  render: __vue_render__$3,
  staticRenderFns: __vue_staticRenderFns__$3
}, __vue_inject_styles__$3, {}, __vue_scope_id__$3, __vue_is_functional_template__$3, __vue_module_identifier__$3, false, undefined, undefined, undefined);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$1 = {
  props: {
    type: String,
    disabled: Boolean
  },
  inject: {
    prefixClass: {
      default: 'mx'
    }
  }
};

/* script */
var __vue_script__$1 = script$1;
/* template */

var __vue_render__$4 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('button', _vm._g({
    class: [_vm.prefixClass + "-btn " + _vm.prefixClass + "-btn-text " + _vm.prefixClass + "-btn-icon-" + _vm.type, {
      disabled: _vm.disabled
    }],
    attrs: {
      "type": "button",
      "disabled": _vm.disabled
    }
  }, _vm.$listeners), [_c('i', {
    class: _vm.prefixClass + "-icon-" + _vm.type
  })]);
};

var __vue_staticRenderFns__$4 = [];
/* style */

var __vue_inject_styles__$4 = undefined;
/* scoped */

var __vue_scope_id__$4 = undefined;
/* module identifier */

var __vue_module_identifier__$4 = undefined;
/* functional template */

var __vue_is_functional_template__$4 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$4 = normalizeComponent({
  render: __vue_render__$4,
  staticRenderFns: __vue_staticRenderFns__$4
}, __vue_inject_styles__$4, __vue_script__$1, __vue_scope_id__$4, __vue_is_functional_template__$4, __vue_module_identifier__$4, false, undefined, undefined, undefined);

var script$2 = {
  name: 'TableDate',
  components: {
    IconButton: __vue_component__$4
  },
  inject: {
    getLocale: {
      default: function _default() {
        return getLocale;
      }
    },
    getWeek: {
      default: function _default() {
        return __WEBPACK_IMPORTED_MODULE_0_date_format_parse__["b" /* getWeek */];
      }
    },
    prefixClass: {
      default: 'mx'
    },
    onDateMouseEnter: {
      default: undefined
    },
    onDateMouseLeave: {
      default: undefined
    }
  },
  props: {
    disabledCalendarChanger: {
      type: Function,
      default: function _default() {
        return false;
      }
    },
    calendar: {
      type: Date,
      default: function _default() {
        return new Date();
      }
    },
    showWeekNumber: {
      type: Boolean,
      default: false
    },
    titleFormat: {
      type: String,
      default: 'YYYY-MM-DD'
    },
    getRowClasses: {
      type: Function,
      default: function _default() {
        return [];
      }
    },
    getCellClasses: {
      type: Function,
      default: function _default() {
        return [];
      }
    }
  },
  computed: {
    firstDayOfWeek: function firstDayOfWeek() {
      return this.getLocale().formatLocale.firstDayOfWeek || 0;
    },
    yearMonth: function yearMonth() {
      var _this$getLocale = this.getLocale(),
          yearFormat = _this$getLocale.yearFormat,
          monthBeforeYear = _this$getLocale.monthBeforeYear,
          _this$getLocale$month = _this$getLocale.monthFormat,
          monthFormat = _this$getLocale$month === void 0 ? 'MMM' : _this$getLocale$month;

      var yearLabel = {
        panel: 'year',
        label: this.formatDate(this.calendar, yearFormat)
      };
      var monthLabel = {
        panel: 'month',
        label: this.formatDate(this.calendar, monthFormat)
      };
      return monthBeforeYear ? [monthLabel, yearLabel] : [yearLabel, monthLabel];
    },
    days: function days() {
      var locale = this.getLocale();
      var days = locale.days || locale.formatLocale.weekdaysMin;
      return days.concat(days).slice(this.firstDayOfWeek, this.firstDayOfWeek + 7);
    },
    dates: function dates() {
      var year = this.calendar.getFullYear();
      var month = this.calendar.getMonth();
      var arr = getCalendar({
        firstDayOfWeek: this.firstDayOfWeek,
        year: year,
        month: month
      });
      return chunk(arr, 7);
    }
  },
  methods: {
    isDisabledArrows: function isDisabledArrows(type) {
      var date = new Date(this.calendar);

      switch (type) {
        case 'last-year':
          date.setFullYear(date.getFullYear() - 1, date.getMonth() + 1, 0);
          date.setHours(23, 59, 59, 999);
          break;

        case 'next-year':
          date.setFullYear(date.getFullYear() + 1);
          break;

        case 'last-month':
          date.setMonth(date.getMonth(), 0);
          date.setHours(23, 59, 59, 999);
          break;

        case 'next-month':
          date.setMonth(date.getMonth() + 1);
          break;
      }

      return this.disabledCalendarChanger(date, type);
    },
    handleIconLeftClick: function handleIconLeftClick() {
      this.$emit('changecalendar', setMonth(this.calendar, function (v) {
        return v - 1;
      }), 'last-month');
    },
    handleIconRightClick: function handleIconRightClick() {
      this.$emit('changecalendar', setMonth(this.calendar, function (v) {
        return v + 1;
      }), 'next-month');
    },
    handleIconDoubleLeftClick: function handleIconDoubleLeftClick() {
      this.$emit('changecalendar', setYear(this.calendar, function (v) {
        return v - 1;
      }), 'last-year');
    },
    handleIconDoubleRightClick: function handleIconDoubleRightClick() {
      this.$emit('changecalendar', setYear(this.calendar, function (v) {
        return v + 1;
      }), 'next-year');
    },
    handlePanelChange: function handlePanelChange(panel) {
      this.$emit('changepanel', panel);
    },
    handleMouseEnter: function handleMouseEnter(cell) {
      if (typeof this.onDateMouseEnter === 'function') {
        this.onDateMouseEnter(cell);
      }
    },
    handleMouseLeave: function handleMouseLeave(cell) {
      if (typeof this.onDateMouseLeave === 'function') {
        this.onDateMouseLeave(cell);
      }
    },
    handleCellClick: function handleCellClick(evt) {
      var target = evt.target;

      if (target.tagName.toUpperCase() === 'DIV') {
        target = target.parentNode;
      }

      var index = target.getAttribute('data-row-col');

      if (index) {
        var _index$split$map = index.split(',').map(function (v) {
          return parseInt(v, 10);
        }),
            _index$split$map2 = _slicedToArray(_index$split$map, 2),
            row = _index$split$map2[0],
            col = _index$split$map2[1];

        var date = this.dates[row][col];
        this.$emit('select', new Date(date));
      }
    },
    formatDate: function formatDate(date, fmt) {
      return Object(__WEBPACK_IMPORTED_MODULE_0_date_format_parse__["a" /* format */])(date, fmt, {
        locale: this.getLocale().formatLocale
      });
    },
    getCellTitle: function getCellTitle(date) {
      var fmt = this.titleFormat;
      return this.formatDate(date, fmt);
    },
    getWeekNumber: function getWeekNumber(date) {
      return this.getWeek(date, this.getLocale().formatLocale);
    }
  }
};

/* script */
var __vue_script__$2 = script$2;
/* template */

var __vue_render__$5 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: _vm.prefixClass + "-calendar " + _vm.prefixClass + "-calendar-panel-date"
  }, [_c('div', {
    class: _vm.prefixClass + "-calendar-header"
  }, [_c('icon-button', {
    attrs: {
      "type": "double-left",
      "disabled": _vm.isDisabledArrows('last-year')
    },
    on: {
      "click": _vm.handleIconDoubleLeftClick
    }
  }), _vm._v(" "), _c('icon-button', {
    attrs: {
      "type": "left",
      "disabled": _vm.isDisabledArrows('last-month')
    },
    on: {
      "click": _vm.handleIconLeftClick
    }
  }), _vm._v(" "), _c('icon-button', {
    attrs: {
      "type": "double-right",
      "disabled": _vm.isDisabledArrows('next-year')
    },
    on: {
      "click": _vm.handleIconDoubleRightClick
    }
  }), _vm._v(" "), _c('icon-button', {
    attrs: {
      "type": "right",
      "disabled": _vm.isDisabledArrows('next-month')
    },
    on: {
      "click": _vm.handleIconRightClick
    }
  }), _vm._v(" "), _c('span', {
    class: _vm.prefixClass + "-calendar-header-label"
  }, _vm._l(_vm.yearMonth, function (item) {
    return _c('button', {
      key: item.panel,
      class: _vm.prefixClass + "-btn " + _vm.prefixClass + "-btn-text " + _vm.prefixClass + "-btn-current-" + item.panel,
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.handlePanelChange(item.panel);
        }
      }
    }, [_vm._v("\n        " + _vm._s(item.label) + "\n      ")]);
  }), 0)], 1), _vm._v(" "), _c('div', {
    class: _vm.prefixClass + "-calendar-content"
  }, [_c('table', {
    class: _vm.prefixClass + "-table " + _vm.prefixClass + "-table-date"
  }, [_c('thead', [_c('tr', [_vm.showWeekNumber ? _c('th', {
    class: _vm.prefixClass + "-week-number-header"
  }) : _vm._e(), _vm._v(" "), _vm._l(_vm.days, function (day) {
    return _c('th', {
      key: day
    }, [_vm._v(_vm._s(day))]);
  })], 2)]), _vm._v(" "), _c('tbody', {
    on: {
      "click": _vm.handleCellClick
    }
  }, _vm._l(_vm.dates, function (row, i) {
    return _c('tr', {
      key: i,
      class: [_vm.prefixClass + "-date-row", _vm.getRowClasses(row)]
    }, [_vm.showWeekNumber ? _c('td', {
      class: _vm.prefixClass + "-week-number",
      attrs: {
        "data-row-col": i + ",0"
      }
    }, [_vm._v("\n            " + _vm._s(_vm.getWeekNumber(row[0])) + "\n          ")]) : _vm._e(), _vm._v(" "), _vm._l(row, function (cell, j) {
      return _c('td', {
        key: j,
        staticClass: "cell",
        class: _vm.getCellClasses(cell),
        attrs: {
          "data-row-col": i + "," + j,
          "title": _vm.getCellTitle(cell)
        },
        on: {
          "mouseenter": function mouseenter($event) {
            return _vm.handleMouseEnter(cell);
          },
          "mouseleave": function mouseleave($event) {
            return _vm.handleMouseLeave(cell);
          }
        }
      }, [_c('div', [_vm._v(_vm._s(cell.getDate()))])]);
    })], 2);
  }), 0)])])]);
};

var __vue_staticRenderFns__$5 = [];
/* style */

var __vue_inject_styles__$5 = undefined;
/* scoped */

var __vue_scope_id__$5 = undefined;
/* module identifier */

var __vue_module_identifier__$5 = undefined;
/* functional template */

var __vue_is_functional_template__$5 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$5 = normalizeComponent({
  render: __vue_render__$5,
  staticRenderFns: __vue_staticRenderFns__$5
}, __vue_inject_styles__$5, __vue_script__$2, __vue_scope_id__$5, __vue_is_functional_template__$5, __vue_module_identifier__$5, false, undefined, undefined, undefined);

//
var script$3 = {
  name: 'TableMonth',
  components: {
    IconButton: __vue_component__$4
  },
  inject: {
    getLocale: {
      default: function _default() {
        return getLocale;
      }
    },
    prefixClass: {
      default: 'mx'
    }
  },
  props: {
    disabledCalendarChanger: {
      type: Function,
      default: function _default() {
        return false;
      }
    },
    calendar: {
      type: Date,
      default: function _default() {
        return new Date();
      }
    },
    getCellClasses: {
      type: Function,
      default: function _default() {
        return [];
      }
    }
  },
  computed: {
    calendarYear: function calendarYear() {
      return this.calendar.getFullYear();
    },
    months: function months() {
      var locale = this.getLocale();
      var monthsLocale = locale.months || locale.formatLocale.monthsShort;
      var months = monthsLocale.map(function (text, month) {
        return {
          text: text,
          month: month
        };
      });
      return chunk(months, 3);
    }
  },
  methods: {
    isDisabledArrows: function isDisabledArrows(type) {
      var date = new Date(this.calendar);

      switch (type) {
        case 'last-year':
          date.setFullYear(date.getFullYear() - 1, 11, 31);
          date.setHours(23, 59, 59, 999);
          break;

        case 'next-year':
          date.setFullYear(date.getFullYear() + 1, 0, 1);
          break;
      }

      return this.disabledCalendarChanger(date, type);
    },
    handleIconDoubleLeftClick: function handleIconDoubleLeftClick() {
      this.$emit('changecalendar', setYear(this.calendar, function (v) {
        return v - 1;
      }), 'last-year');
    },
    handleIconDoubleRightClick: function handleIconDoubleRightClick() {
      this.$emit('changecalendar', setYear(this.calendar, function (v) {
        return v + 1;
      }), 'next-year');
    },
    handlePanelChange: function handlePanelChange() {
      this.$emit('changepanel', 'year');
    },
    handleClick: function handleClick(evt) {
      var target = evt.target;

      if (target.tagName.toUpperCase() === 'DIV') {
        target = target.parentNode;
      }

      var month = target.getAttribute('data-month');

      if (month && !target.classList.contains('disabled')) {
        this.$emit('select', parseInt(month, 10));
      }
    }
  }
};

/* script */
var __vue_script__$3 = script$3;
/* template */

var __vue_render__$6 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: _vm.prefixClass + "-calendar " + _vm.prefixClass + "-calendar-panel-month"
  }, [_c('div', {
    class: _vm.prefixClass + "-calendar-header"
  }, [_c('icon-button', {
    attrs: {
      "type": "double-left",
      "disabled": _vm.isDisabledArrows('last-year')
    },
    on: {
      "click": _vm.handleIconDoubleLeftClick
    }
  }), _vm._v(" "), _c('icon-button', {
    attrs: {
      "type": "double-right",
      "disabled": _vm.isDisabledArrows('next-year')
    },
    on: {
      "click": _vm.handleIconDoubleRightClick
    }
  }), _vm._v(" "), _c('span', {
    class: _vm.prefixClass + "-calendar-header-label"
  }, [_c('button', {
    class: _vm.prefixClass + "-btn " + _vm.prefixClass + "-btn-text",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.handlePanelChange
    }
  }, [_vm._v("\n        " + _vm._s(_vm.calendarYear) + "\n      ")])])], 1), _vm._v(" "), _c('div', {
    class: _vm.prefixClass + "-calendar-content"
  }, [_c('table', {
    class: _vm.prefixClass + "-table " + _vm.prefixClass + "-table-month",
    on: {
      "click": _vm.handleClick
    }
  }, _vm._l(_vm.months, function (row, i) {
    return _c('tr', {
      key: i
    }, _vm._l(row, function (cell, j) {
      return _c('td', {
        key: j,
        staticClass: "cell",
        class: _vm.getCellClasses(cell.month),
        attrs: {
          "data-month": cell.month
        }
      }, [_c('div', [_vm._v(_vm._s(cell.text))])]);
    }), 0);
  }), 0)])]);
};

var __vue_staticRenderFns__$6 = [];
/* style */

var __vue_inject_styles__$6 = undefined;
/* scoped */

var __vue_scope_id__$6 = undefined;
/* module identifier */

var __vue_module_identifier__$6 = undefined;
/* functional template */

var __vue_is_functional_template__$6 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$6 = normalizeComponent({
  render: __vue_render__$6,
  staticRenderFns: __vue_staticRenderFns__$6
}, __vue_inject_styles__$6, __vue_script__$3, __vue_scope_id__$6, __vue_is_functional_template__$6, __vue_module_identifier__$6, false, undefined, undefined, undefined);

//
var script$4 = {
  name: 'TableYear',
  components: {
    IconButton: __vue_component__$4
  },
  inject: {
    prefixClass: {
      default: 'mx'
    }
  },
  props: {
    disabledCalendarChanger: {
      type: Function,
      default: function _default() {
        return false;
      }
    },
    calendar: {
      type: Date,
      default: function _default() {
        return new Date();
      }
    },
    getCellClasses: {
      type: Function,
      default: function _default() {
        return [];
      }
    },
    getYearPanel: {
      type: Function
    }
  },
  computed: {
    years: function years() {
      var calendar = new Date(this.calendar);

      if (typeof this.getYearPanel === 'function') {
        return this.getYearPanel(calendar);
      }

      return this.getYears(calendar);
    },
    firstYear: function firstYear() {
      return this.years[0][0];
    },
    lastYear: function lastYear() {
      var last = function last(arr) {
        return arr[arr.length - 1];
      };

      return last(last(this.years));
    }
  },
  methods: {
    isDisabledArrows: function isDisabledArrows(type) {
      var date = new Date(this.calendar);

      switch (type) {
        case 'last-decade':
          date.setFullYear(this.firstYear - 1, 11, 31);
          date.setHours(23, 59, 59, 999);
          break;

        case 'next-decade':
          date.setFullYear(this.lastYear + 1, 0, 1);
          break;
      }

      return this.disabledCalendarChanger(date, type);
    },
    getYears: function getYears(calendar) {
      var firstYear = Math.floor(calendar.getFullYear() / 10) * 10;
      var years = [];

      for (var i = 0; i < 10; i++) {
        years.push(firstYear + i);
      }

      return chunk(years, 2);
    },
    handleIconDoubleLeftClick: function handleIconDoubleLeftClick() {
      this.$emit('changecalendar', setYear(this.calendar, function (v) {
        return v - 10;
      }), 'last-decade');
    },
    handleIconDoubleRightClick: function handleIconDoubleRightClick() {
      this.$emit('changecalendar', setYear(this.calendar, function (v) {
        return v + 10;
      }), 'next-decade');
    },
    handleClick: function handleClick(evt) {
      var target = evt.target;

      if (target.tagName.toUpperCase() === 'DIV') {
        target = target.parentNode;
      }

      var year = target.getAttribute('data-year');

      if (year && !target.classList.contains('disabled')) {
        this.$emit('select', parseInt(year, 10));
      }
    }
  }
};

/* script */
var __vue_script__$4 = script$4;
/* template */

var __vue_render__$7 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: _vm.prefixClass + "-calendar " + _vm.prefixClass + "-calendar-panel-year"
  }, [_c('div', {
    class: _vm.prefixClass + "-calendar-header"
  }, [_c('icon-button', {
    attrs: {
      "type": "double-left",
      "disabled": _vm.isDisabledArrows('last-decade')
    },
    on: {
      "click": _vm.handleIconDoubleLeftClick
    }
  }), _vm._v(" "), _c('icon-button', {
    attrs: {
      "type": "double-right",
      "disabled": _vm.isDisabledArrows('next-decade')
    },
    on: {
      "click": _vm.handleIconDoubleRightClick
    }
  }), _vm._v(" "), _c('span', {
    class: _vm.prefixClass + "-calendar-header-label"
  }, [_c('span', [_vm._v(_vm._s(_vm.firstYear))]), _vm._v(" "), _c('span', {
    class: _vm.prefixClass + "-calendar-decade-separator"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.lastYear))])])], 1), _vm._v(" "), _c('div', {
    class: _vm.prefixClass + "-calendar-content"
  }, [_c('table', {
    class: _vm.prefixClass + "-table " + _vm.prefixClass + "-table-year",
    on: {
      "click": _vm.handleClick
    }
  }, _vm._l(_vm.years, function (row, i) {
    return _c('tr', {
      key: i
    }, _vm._l(row, function (cell, j) {
      return _c('td', {
        key: j,
        staticClass: "cell",
        class: _vm.getCellClasses(cell),
        attrs: {
          "data-year": cell
        }
      }, [_c('div', [_vm._v(_vm._s(cell))])]);
    }), 0);
  }), 0)])]);
};

var __vue_staticRenderFns__$7 = [];
/* style */

var __vue_inject_styles__$7 = undefined;
/* scoped */

var __vue_scope_id__$7 = undefined;
/* module identifier */

var __vue_module_identifier__$7 = undefined;
/* functional template */

var __vue_is_functional_template__$7 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$7 = normalizeComponent({
  render: __vue_render__$7,
  staticRenderFns: __vue_staticRenderFns__$7
}, __vue_inject_styles__$7, __vue_script__$4, __vue_scope_id__$7, __vue_is_functional_template__$7, __vue_module_identifier__$7, false, undefined, undefined, undefined);

var CalendarPanel = {
  name: 'CalendarPanel',
  inject: {
    prefixClass: {
      default: 'mx'
    },
    dispatchDatePicker: {
      default: function _default() {
        return function () {};
      }
    }
  },
  props: {
    value: {},
    defaultValue: {
      default: function _default() {
        var date = new Date();
        date.setHours(0, 0, 0, 0);
        return date;
      }
    },
    defaultPanel: {
      type: String
    },
    disabledCalendarChanger: {
      type: Function,
      default: function _default() {
        return false;
      }
    },
    disabledDate: {
      type: Function,
      default: function _default() {
        return false;
      }
    },
    type: {
      type: String,
      default: 'date'
    },
    getClasses: {
      type: Function,
      default: function _default() {
        return [];
      }
    },
    showWeekNumber: {
      type: Boolean,
      default: undefined
    },
    getYearPanel: {
      type: Function
    },
    titleFormat: {
      type: String,
      default: 'YYYY-MM-DD'
    },
    calendar: Date,
    // update date when select year or month
    partialUpdate: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    var panels = ['date', 'month', 'year'];
    var index = Math.max(panels.indexOf(this.type), panels.indexOf(this.defaultPanel));
    var panel = index !== -1 ? panels[index] : 'date';
    return {
      panel: panel,
      innerCalendar: new Date()
    };
  },
  computed: {
    innerValue: function innerValue() {
      var value = Array.isArray(this.value) ? this.value : [this.value];
      var map = {
        year: startOfYear,
        month: startOfMonth,
        date: startOfDay
      };
      var start = map[this.type] || map.date;
      return value.filter(isValidDate).map(function (v) {
        return start(v);
      });
    },
    calendarYear: function calendarYear() {
      return this.innerCalendar.getFullYear();
    },
    calendarMonth: function calendarMonth() {
      return this.innerCalendar.getMonth();
    }
  },
  watch: {
    value: {
      immediate: true,
      handler: 'initCalendar'
    },
    calendar: {
      handler: 'initCalendar'
    },
    defaultValue: {
      handler: 'initCalendar'
    }
  },
  methods: {
    initCalendar: function initCalendar() {
      var calendarDate = this.calendar;

      if (!isValidDate(calendarDate)) {
        var length = this.innerValue.length;
        calendarDate = getValidDate(length > 0 ? this.innerValue[length - 1] : this.defaultValue);
      }

      this.innerCalendar = startOfMonth(calendarDate);
    },
    isDisabled: function isDisabled(date) {
      return this.disabledDate(new Date(date), this.innerValue);
    },
    emitDate: function emitDate(date, type) {
      if (!this.isDisabled(date)) {
        this.$emit('select', date, type, this.innerValue); // someone need get the first selected date to set range value. (#429)

        this.dispatchDatePicker('pick', date, type);
      }
    },
    handleCalendarChange: function handleCalendarChange(calendar, type) {
      var oldCalendar = new Date(this.innerCalendar);
      this.innerCalendar = calendar;
      this.$emit('update:calendar', calendar);
      this.dispatchDatePicker('calendar-change', calendar, oldCalendar, type);
    },
    handelPanelChange: function handelPanelChange(panel) {
      var oldPanel = this.panel;
      this.panel = panel;
      this.dispatchDatePicker('panel-change', panel, oldPanel);
    },
    handleSelectYear: function handleSelectYear(year) {
      if (this.type === 'year') {
        var date = this.getYearCellDate(year);
        this.emitDate(date, 'year');
      } else {
        this.handleCalendarChange(createDate(year, this.calendarMonth), 'year');
        this.handelPanelChange('month');

        if (this.partialUpdate && this.innerValue.length === 1) {
          var _date = new Date(this.innerValue[0]);

          _date.setFullYear(year);

          this.emitDate(_date, 'year');
        }
      }
    },
    handleSelectMonth: function handleSelectMonth(month) {
      if (this.type === 'month') {
        var date = this.getMonthCellDate(month);
        this.emitDate(date, 'month');
      } else {
        this.handleCalendarChange(createDate(this.calendarYear, month), 'month');
        this.handelPanelChange('date');

        if (this.partialUpdate && this.innerValue.length === 1) {
          var _date2 = new Date(this.innerValue[0]);

          _date2.setFullYear(this.calendarYear);

          this.emitDate(setMonth(_date2, month), 'month');
        }
      }
    },
    handleSelectDate: function handleSelectDate(date) {
      this.emitDate(date, this.type === 'week' ? 'week' : 'date');
    },
    getMonthCellDate: function getMonthCellDate(month) {
      return createDate(this.calendarYear, month);
    },
    getYearCellDate: function getYearCellDate(year) {
      return createDate(year, 0);
    },
    getDateClasses: function getDateClasses(cellDate) {
      var notCurrentMonth = cellDate.getMonth() !== this.calendarMonth;
      var classes = [];

      if (cellDate.getTime() === new Date().setHours(0, 0, 0, 0)) {
        classes.push('today');
      }

      if (notCurrentMonth) {
        classes.push('not-current-month');
      }

      var state = this.getStateClass(cellDate);

      if (!(state === 'active' && notCurrentMonth)) {
        classes.push(state);
      }

      return classes.concat(this.getClasses(cellDate, this.innerValue, classes.join(' ')));
    },
    getMonthClasses: function getMonthClasses(month) {
      var classes = [];

      if (this.type !== 'month') {
        if (this.calendarMonth === month) {
          classes.push('active');
        }

        var _cellDate = this.getMonthCellDate(month);

        if (this.disabledCalendarChanger(_cellDate, 'month')) {
          classes.push('disabled');
        }

        return classes;
      }

      var cellDate = this.getMonthCellDate(month);
      classes.push(this.getStateClass(cellDate));
      return classes.concat(this.getClasses(cellDate, this.innerValue, classes.join(' ')));
    },
    getYearClasses: function getYearClasses(year) {
      var classes = [];

      if (this.type !== 'year') {
        if (this.calendarYear === year) {
          classes.push('active');
        }

        var _cellDate2 = this.getYearCellDate(year);

        if (this.disabledCalendarChanger(_cellDate2, 'year')) {
          classes.push('disabled');
        }

        return classes;
      }

      var cellDate = this.getYearCellDate(year);
      classes.push(this.getStateClass(cellDate));
      return classes.concat(this.getClasses(cellDate, this.innerValue, classes.join(' ')));
    },
    getStateClass: function getStateClass(cellDate) {
      if (this.isDisabled(cellDate)) {
        return 'disabled';
      }

      if (this.innerValue.some(function (v) {
        return v.getTime() === cellDate.getTime();
      })) {
        return 'active';
      }

      return '';
    },
    getWeekState: function getWeekState(row) {
      if (this.type !== 'week') return '';
      var start = row[0].getTime();
      var end = row[6].getTime();
      var active = this.innerValue.some(function (v) {
        var time = v.getTime();
        return time >= start && time <= end;
      });
      return active ? "".concat(this.prefixClass, "-active-week") : '';
    }
  },
  render: function render() {
    var h = arguments[0];
    var panel = this.panel,
        innerCalendar = this.innerCalendar;

    if (panel === 'year') {
      return h(__vue_component__$7, {
        "attrs": {
          "disabledCalendarChanger": this.disabledCalendarChanger,
          "calendar": innerCalendar,
          "getCellClasses": this.getYearClasses,
          "getYearPanel": this.getYearPanel
        },
        "on": {
          "select": this.handleSelectYear,
          "changecalendar": this.handleCalendarChange
        }
      });
    }

    if (panel === 'month') {
      return h(__vue_component__$6, {
        "attrs": {
          "disabledCalendarChanger": this.disabledCalendarChanger,
          "calendar": innerCalendar,
          "getCellClasses": this.getMonthClasses
        },
        "on": {
          "select": this.handleSelectMonth,
          "changepanel": this.handelPanelChange,
          "changecalendar": this.handleCalendarChange
        }
      });
    }

    return h(__vue_component__$5, {
      "attrs": {
        "disabledCalendarChanger": this.disabledCalendarChanger,
        "calendar": innerCalendar,
        "getCellClasses": this.getDateClasses,
        "getRowClasses": this.getWeekState,
        "titleFormat": this.titleFormat,
        "showWeekNumber": typeof this.showWeekNumber === 'boolean' ? this.showWeekNumber : this.type === 'week'
      },
      "class": _defineProperty({}, "".concat(this.prefixClass, "-calendar-week-mode"), this.type === 'week'),
      "on": {
        "select": this.handleSelectDate,
        "changepanel": this.handelPanelChange,
        "changecalendar": this.handleCalendarChange
      }
    });
  }
};

var CalendarRange = {
  name: 'CalendarRange',
  components: {
    CalendarPanel: CalendarPanel
  },
  provide: function provide() {
    return {
      onDateMouseEnter: this.onDateMouseEnter,
      onDateMouseLeave: this.onDateMouseLeave
    };
  },
  inject: {
    prefixClass: {
      default: 'mx'
    }
  },
  props: _objectSpread2({}, CalendarPanel.props),
  data: function data() {
    return {
      innerValue: [],
      calendars: [],
      hoveredValue: null
    };
  },
  computed: {
    // Minimum difference between start and end calendars
    calendarMinDiff: function calendarMinDiff() {
      var map = {
        date: 1,
        // type:date  min 1 month
        month: 1 * 12,
        // type:month min 1 year
        year: 10 * 12 // type:year  min 10 year

      };
      return map[this.type] || map.date;
    },
    calendarMaxDiff: function calendarMaxDiff() {
      return Infinity;
    },
    defaultValues: function defaultValues() {
      return Array.isArray(this.defaultValue) ? this.defaultValue : [this.defaultValue, this.defaultValue];
    }
  },
  watch: {
    value: {
      immediate: true,
      handler: function handler() {
        var _this = this;

        this.innerValue = isValidRangeDate(this.value) ? this.value : [new Date(NaN), new Date(NaN)];
        var calendars = this.innerValue.map(function (v, i) {
          return startOfMonth(getValidDate(v, _this.defaultValues[i]));
        });
        this.updateCalendars(calendars);
      }
    }
  },
  methods: {
    handleSelect: function handleSelect(date, type) {
      var _this$innerValue = _slicedToArray(this.innerValue, 2),
          startValue = _this$innerValue[0],
          endValue = _this$innerValue[1];

      if (isValidDate(startValue) && !isValidDate(endValue)) {
        if (startValue.getTime() > date.getTime()) {
          this.innerValue = [date, startValue];
        } else {
          this.innerValue = [startValue, date];
        }

        this.emitDate(this.innerValue, type);
      } else {
        this.innerValue = [date, new Date(NaN)];
      }
    },
    onDateMouseEnter: function onDateMouseEnter(cell) {
      this.hoveredValue = cell;
    },
    onDateMouseLeave: function onDateMouseLeave() {
      this.hoveredValue = null;
    },
    emitDate: function emitDate(dates, type) {
      this.$emit('select', dates, type);
    },
    updateStartCalendar: function updateStartCalendar(value) {
      this.updateCalendars([value, this.calendars[1]], 1);
    },
    updateEndCalendar: function updateEndCalendar(value) {
      this.updateCalendars([this.calendars[0], value], 0);
    },
    updateCalendars: function updateCalendars(calendars) {
      var adjustIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      var gap = this.getCalendarGap(calendars);

      if (gap) {
        var calendar = new Date(calendars[adjustIndex]);
        calendar.setMonth(calendar.getMonth() + (adjustIndex === 0 ? -gap : gap));
        calendars[adjustIndex] = calendar;
      }

      this.calendars = calendars;
    },
    getCalendarGap: function getCalendarGap(calendars) {
      var _calendars = _slicedToArray(calendars, 2),
          calendarLeft = _calendars[0],
          calendarRight = _calendars[1];

      var yearDiff = calendarRight.getFullYear() - calendarLeft.getFullYear();
      var monthDiff = calendarRight.getMonth() - calendarLeft.getMonth();
      var diff = yearDiff * 12 + monthDiff;
      var min = this.calendarMinDiff;
      var max = this.calendarMaxDiff;

      if (diff < min) {
        return min - diff;
      }

      if (diff > max) {
        return max - diff;
      }

      return 0;
    },
    getRangeClasses: function getRangeClasses(cellDate, currentDates, classnames) {
      var classes = [].concat(this.getClasses(cellDate, currentDates, classnames));
      if (/disabled|active/.test(classnames)) return classes;

      var inRange = function inRange(data, range) {
        var fn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (v) {
          return v.getTime();
        };
        var value = fn(data);

        var _range$map = range.map(fn),
            _range$map2 = _slicedToArray(_range$map, 2),
            min = _range$map2[0],
            max = _range$map2[1];

        if (min > max) {
          var _ref = [max, min];
          min = _ref[0];
          max = _ref[1];
        }

        return value > min && value < max;
      };

      if (currentDates.length === 2 && inRange(cellDate, currentDates)) {
        return classes.concat('in-range');
      }

      if (currentDates.length === 1 && this.hoveredValue && inRange(cellDate, [currentDates[0], this.hoveredValue])) {
        return classes.concat('hover-in-range');
      }

      return classes;
    }
  },
  render: function render() {
    var _this2 = this;

    var h = arguments[0];
    var calendarRange = this.calendars.map(function (calendar, index) {
      var props = _objectSpread2({}, _this2.$props, {
        calendar: calendar,
        value: _this2.innerValue,
        defaultValue: _this2.defaultValues[index],
        getClasses: _this2.getRangeClasses,
        // don't update when range is true
        partialUpdate: false
      });

      var on = {
        select: _this2.handleSelect,
        'update:calendar': index === 0 ? _this2.updateStartCalendar : _this2.updateEndCalendar
      };
      return h("calendar-panel", {
        "props": _objectSpread2({}, props),
        "on": _objectSpread2({}, on)
      });
    });
    var prefixClass = this.prefixClass;
    return h("div", {
      "class": "".concat(prefixClass, "-range-wrapper")
    }, [calendarRange]);
  }
};

var scrollBarWidth;
function getScrollbarWidth () {
  if (typeof window === 'undefined') return 0;
  if (scrollBarWidth !== undefined) return scrollBarWidth;
  var outer = document.createElement('div');
  outer.style.visibility = 'hidden';
  outer.style.overflow = 'scroll';
  outer.style.width = '100px';
  outer.style.position = 'absolute';
  outer.style.top = '-9999px';
  document.body.appendChild(outer);
  var inner = document.createElement('div');
  inner.style.width = '100%';
  outer.appendChild(inner);
  scrollBarWidth = outer.offsetWidth - inner.offsetWidth;
  outer.parentNode.removeChild(outer);
  return scrollBarWidth;
}

//
var script$5 = {
  inject: {
    prefixClass: {
      default: 'mx'
    }
  },
  data: function data() {
    return {
      scrollbarWidth: 0,
      thumbTop: '',
      thumbHeight: ''
    };
  },
  created: function created() {
    this.scrollbarWidth = getScrollbarWidth();
    document.addEventListener('mouseup', this.handleDragend);
  },
  beforeDestroy: function beforeDestroy() {
    document.addEventListener('mouseup', this.handleDragend);
  },
  mounted: function mounted() {
    this.$nextTick(this.getThumbSize);
  },
  methods: {
    getThumbSize: function getThumbSize() {
      var wrap = this.$refs.wrap;
      if (!wrap) return;
      var heightPercentage = wrap.clientHeight * 100 / wrap.scrollHeight;
      this.thumbHeight = heightPercentage < 100 ? "".concat(heightPercentage, "%") : '';
    },
    handleScroll: function handleScroll(evt) {
      var el = evt.currentTarget;
      var scrollHeight = el.scrollHeight,
          scrollTop = el.scrollTop;
      this.thumbTop = "".concat(scrollTop * 100 / scrollHeight, "%");
    },
    handleDragstart: function handleDragstart(evt) {
      evt.stopImmediatePropagation();
      this._draggable = true;
      var offsetTop = this.$refs.thumb.offsetTop;
      this._prevY = evt.clientY - offsetTop;
      document.addEventListener('mousemove', this.handleDraging);
    },
    handleDraging: function handleDraging(evt) {
      if (!this._draggable) return;
      var clientY = evt.clientY;
      var wrap = this.$refs.wrap;
      var scrollHeight = wrap.scrollHeight,
          clientHeight = wrap.clientHeight;
      var offsetY = clientY - this._prevY;
      var top = offsetY * scrollHeight / clientHeight;
      wrap.scrollTop = top;
    },
    handleDragend: function handleDragend() {
      if (this._draggable) {
        this._draggable = false;
        document.removeEventListener('mousemove', this.handleDraging);
      }
    }
  }
};

/* script */
var __vue_script__$5 = script$5;
/* template */

var __vue_render__$8 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: _vm.prefixClass + "-scrollbar",
    style: {
      position: 'relative',
      overflow: 'hidden'
    }
  }, [_c('div', {
    ref: "wrap",
    class: _vm.prefixClass + "-scrollbar-wrap",
    style: {
      marginRight: "-" + _vm.scrollbarWidth + "px"
    },
    on: {
      "scroll": _vm.handleScroll
    }
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    class: _vm.prefixClass + "-scrollbar-track"
  }, [_c('div', {
    ref: "thumb",
    class: _vm.prefixClass + "-scrollbar-thumb",
    style: {
      height: _vm.thumbHeight,
      top: _vm.thumbTop
    },
    on: {
      "mousedown": _vm.handleDragstart
    }
  })])]);
};

var __vue_staticRenderFns__$8 = [];
/* style */

var __vue_inject_styles__$8 = undefined;
/* scoped */

var __vue_scope_id__$8 = undefined;
/* module identifier */

var __vue_module_identifier__$8 = undefined;
/* functional template */

var __vue_is_functional_template__$8 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$8 = normalizeComponent({
  render: __vue_render__$8,
  staticRenderFns: __vue_staticRenderFns__$8
}, __vue_inject_styles__$8, __vue_script__$5, __vue_scope_id__$8, __vue_is_functional_template__$8, __vue_module_identifier__$8, false, undefined, undefined, undefined);

//

var padNumber = function padNumber(value) {
  value = parseInt(value, 10);
  return value < 10 ? "0".concat(value) : "".concat(value);
};

var generateOptions = function generateOptions(length, step, options) {
  if (Array.isArray(options)) {
    return options.filter(function (v) {
      return v >= 0 && v < length;
    });
  }

  if (step <= 0) {
    step = 1;
  }

  var arr = [];

  for (var i = 0; i < length; i += step) {
    arr.push(i);
  }

  return arr;
};

var scrollTo = function scrollTo(element, to) {
  var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

  // jump to target if duration zero
  if (duration <= 0) {
    requestAnimationFrame(function () {
      element.scrollTop = to;
    });
    return;
  }

  var difference = to - element.scrollTop;
  var tick = difference / duration * 10;
  requestAnimationFrame(function () {
    var scrollTop = element.scrollTop + tick;

    if (scrollTop >= to) {
      element.scrollTop = to;
      return;
    }

    element.scrollTop = scrollTop;
    scrollTo(element, to, duration - 10);
  });
};

var script$6 = {
  name: 'ListColumns',
  components: {
    ScrollbarVertical: __vue_component__$8
  },
  inject: {
    prefixClass: {
      default: 'mx'
    }
  },
  props: {
    date: Date,
    scrollDuration: {
      type: Number,
      default: 100
    },
    getClasses: {
      type: Function,
      default: function _default() {
        return [];
      }
    },
    hourOptions: Array,
    minuteOptions: Array,
    secondOptions: Array,
    showHour: {
      type: Boolean,
      default: true
    },
    showMinute: {
      type: Boolean,
      default: true
    },
    showSecond: {
      type: Boolean,
      default: true
    },
    hourStep: {
      type: Number,
      default: 1
    },
    minuteStep: {
      type: Number,
      default: 1
    },
    secondStep: {
      type: Number,
      default: 1
    },
    use12h: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    columns: function columns() {
      var cols = [];
      if (this.showHour) cols.push({
        type: 'hour',
        list: this.getHoursList()
      });
      if (this.showMinute) cols.push({
        type: 'minute',
        list: this.getMinutesList()
      });
      if (this.showSecond) cols.push({
        type: 'second',
        list: this.getSecondsList()
      });
      if (this.use12h) cols.push({
        type: 'ampm',
        list: this.getAMPMList()
      });
      return cols.filter(function (v) {
        return v.list.length > 0;
      });
    }
  },
  watch: {
    date: {
      handler: function handler() {
        var _this = this;

        this.$nextTick(function () {
          _this.scrollToSelected(_this.scrollDuration);
        });
      }
    }
  },
  mounted: function mounted() {
    this.scrollToSelected(0);
  },
  methods: {
    getHoursList: function getHoursList() {
      var _this2 = this;

      return generateOptions(this.use12h ? 12 : 24, this.hourStep, this.hourOptions).map(function (num) {
        var date = new Date(_this2.date);
        var text = padNumber(num);

        if (_this2.use12h) {
          if (num === 0) {
            text = '12';
          }

          if (date.getHours() >= 12) {
            num += 12;
          }
        }

        var value = date.setHours(num);
        return {
          value: value,
          text: text
        };
      });
    },
    getMinutesList: function getMinutesList() {
      var _this3 = this;

      return generateOptions(60, this.minuteStep, this.minuteOptions).map(function (num) {
        var value = new Date(_this3.date).setMinutes(num);
        return {
          value: value,
          text: padNumber(num)
        };
      });
    },
    getSecondsList: function getSecondsList() {
      var _this4 = this;

      return generateOptions(60, this.secondStep, this.secondOptions).map(function (num) {
        var value = new Date(_this4.date).setSeconds(num);
        return {
          value: value,
          text: padNumber(num)
        };
      });
    },
    getAMPMList: function getAMPMList() {
      var _this5 = this;

      return ['AM', 'PM'].map(function (text, i) {
        var date = new Date(_this5.date);
        var value = date.setHours(date.getHours() % 12 + i * 12);
        return {
          text: text,
          value: value
        };
      });
    },
    scrollToSelected: function scrollToSelected(duration) {
      var elements = this.$el.querySelectorAll('.active');

      for (var i = 0; i < elements.length; i++) {
        var element = elements[i];
        var scrollElement = getScrollParent(element, this.$el);

        if (scrollElement) {
          var to = element.offsetTop;
          scrollTo(scrollElement, to, duration);
        }
      }
    },
    handleSelect: function handleSelect(evt) {
      var target = evt.target,
          currentTarget = evt.currentTarget;
      if (target.tagName.toUpperCase() !== 'LI') return;
      var type = currentTarget.getAttribute('data-type');
      var colIndex = parseInt(currentTarget.getAttribute('data-index'), 10);
      var cellIndex = parseInt(target.getAttribute('data-index'), 10);
      var value = this.columns[colIndex].list[cellIndex].value;
      this.$emit('select', value, type);
    }
  }
};

/* script */
var __vue_script__$6 = script$6;
/* template */

var __vue_render__$9 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: _vm.prefixClass + "-time-columns"
  }, _vm._l(_vm.columns, function (col, i) {
    return _c('scrollbar-vertical', {
      key: i,
      class: _vm.prefixClass + "-time-column"
    }, [_c('ul', {
      class: _vm.prefixClass + "-time-list",
      attrs: {
        "data-type": col.type,
        "data-index": i
      },
      on: {
        "click": _vm.handleSelect
      }
    }, _vm._l(col.list, function (item, j) {
      return _c('li', {
        key: item.value,
        class: [_vm.prefixClass + "-time-item", _vm.getClasses(item.value, col.type)],
        attrs: {
          "data-index": j
        }
      }, [_vm._v("\n        " + _vm._s(item.text) + "\n      ")]);
    }), 0)]);
  }), 1);
};

var __vue_staticRenderFns__$9 = [];
/* style */

var __vue_inject_styles__$9 = undefined;
/* scoped */

var __vue_scope_id__$9 = undefined;
/* module identifier */

var __vue_module_identifier__$9 = undefined;
/* functional template */

var __vue_is_functional_template__$9 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$9 = normalizeComponent({
  render: __vue_render__$9,
  staticRenderFns: __vue_staticRenderFns__$9
}, __vue_inject_styles__$9, __vue_script__$6, __vue_scope_id__$9, __vue_is_functional_template__$9, __vue_module_identifier__$9, false, undefined, undefined, undefined);

//

function parseOption() {
  var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var values = time.split(':');

  if (values.length >= 2) {
    var hours = parseInt(values[0], 10);
    var minutes = parseInt(values[1], 10);
    return {
      hours: hours,
      minutes: minutes
    };
  }

  return null;
}

var scrollTo$1 = function scrollTo(element, to) {
  if (element) {
    element.scrollTop = to;
  }
};

var script$7 = {
  name: 'ListOptions',
  components: {
    ScrollbarVertical: __vue_component__$8
  },
  inject: {
    getLocale: {
      default: function _default() {
        return getLocale;
      }
    },
    prefixClass: {
      default: 'mx'
    }
  },
  props: {
    date: Date,
    options: {
      type: [Object, Function],
      default: function _default() {
        return [];
      }
    },
    format: {
      type: String,
      default: 'HH:mm:ss'
    },
    getClasses: {
      type: Function,
      default: function _default() {
        return [];
      }
    }
  },
  computed: {
    list: function list() {
      var result = [];
      var options = this.options;

      if (typeof options === 'function') {
        return options() || [];
      }

      var start = parseOption(options.start);
      var end = parseOption(options.end);
      var step = parseOption(options.step);
      var fmt = options.format || this.format;

      if (start && end && step) {
        var startMinutes = start.minutes + start.hours * 60;
        var endMinutes = end.minutes + end.hours * 60;
        var stepMinutes = step.minutes + step.hours * 60;
        var len = Math.floor((endMinutes - startMinutes) / stepMinutes);

        for (var i = 0; i <= len; i++) {
          var timeMinutes = startMinutes + i * stepMinutes;
          var hours = Math.floor(timeMinutes / 60);
          var minutes = timeMinutes % 60;
          var value = new Date(this.date).setHours(hours, minutes, 0);
          result.push({
            value: value,
            text: this.formatDate(value, fmt)
          });
        }
      }

      return result;
    }
  },
  mounted: function mounted() {
    this.scrollToSelected();
  },
  methods: {
    formatDate: function formatDate(date, fmt) {
      return Object(__WEBPACK_IMPORTED_MODULE_0_date_format_parse__["a" /* format */])(date, fmt, {
        locale: this.getLocale().formatLocale
      });
    },
    scrollToSelected: function scrollToSelected() {
      var element = this.$el.querySelector('.active');
      if (!element) return;
      var scrollElement = getScrollParent(element, this.$el);
      if (!scrollElement) return;
      var to = element.offsetTop;
      scrollTo$1(scrollElement, to);
    },
    handleSelect: function handleSelect(value) {
      this.$emit('select', value, 'time');
    }
  }
};

/* script */
var __vue_script__$7 = script$7;
/* template */

var __vue_render__$a = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('scrollbar-vertical', _vm._l(_vm.list, function (item) {
    return _c('div', {
      key: item.value,
      class: [_vm.prefixClass + "-time-option", _vm.getClasses(item.value)],
      on: {
        "click": function click($event) {
          return _vm.handleSelect(item.value);
        }
      }
    }, [_vm._v("\n    " + _vm._s(item.text) + "\n  ")]);
  }), 0);
};

var __vue_staticRenderFns__$a = [];
/* style */

var __vue_inject_styles__$a = undefined;
/* scoped */

var __vue_scope_id__$a = undefined;
/* module identifier */

var __vue_module_identifier__$a = undefined;
/* functional template */

var __vue_is_functional_template__$a = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$a = normalizeComponent({
  render: __vue_render__$a,
  staticRenderFns: __vue_staticRenderFns__$a
}, __vue_inject_styles__$a, __vue_script__$7, __vue_scope_id__$a, __vue_is_functional_template__$a, __vue_module_identifier__$a, false, undefined, undefined, undefined);

//
var script$8 = {
  name: 'TimePanel',
  components: {
    ListColumns: __vue_component__$9,
    ListOptions: __vue_component__$a
  },
  inject: {
    getLocale: {
      default: function _default() {
        return getLocale;
      }
    },
    prefixClass: {
      default: 'mx'
    }
  },
  props: {
    value: {},
    defaultValue: {
      default: function _default() {
        var date = new Date();
        date.setHours(0, 0, 0, 0);
        return date;
      }
    },
    format: {
      default: 'HH:mm:ss'
    },
    timeTitleFormat: {
      type: String,
      default: 'YYYY-MM-DD'
    },
    showTimeHeader: {
      type: Boolean,
      default: false
    },
    disabledTime: {
      type: Function,
      default: function _default() {
        return false;
      }
    },
    timePickerOptions: {
      type: [Object, Function],
      default: function _default() {
        return null;
      }
    },
    hourOptions: Array,
    minuteOptions: Array,
    secondOptions: Array,
    hourStep: {
      type: Number,
      default: 1
    },
    minuteStep: {
      type: Number,
      default: 1
    },
    secondStep: {
      type: Number,
      default: 1
    },
    showHour: {
      type: Boolean,
      default: undefined
    },
    showMinute: {
      type: Boolean,
      default: undefined
    },
    showSecond: {
      type: Boolean,
      default: undefined
    },
    use12h: {
      type: Boolean,
      default: undefined
    },
    scrollDuration: {
      type: Number,
      default: 100
    }
  },
  data: function data() {
    return {
      innerValue: getValidDate(this.value, this.defaultValue)
    };
  },
  computed: {
    title: function title() {
      var titleFormat = this.timeTitleFormat;
      var date = new Date(this.innerValue);
      return this.formatDate(date, titleFormat);
    },
    innerForamt: function innerForamt() {
      return typeof this.format === 'string' ? this.format : 'HH:mm:ss';
    },
    ShowHourMinuteSecondAMPM: function ShowHourMinuteSecondAMPM() {
      var _this = this;

      var fmt = this.innerForamt;
      var defaultProps = {
        showHour: /[HhKk]/.test(fmt),
        showMinute: /m/.test(fmt),
        showSecond: /s/.test(fmt),
        use12h: /a/i.test(fmt)
      };
      var obj = {};
      Object.keys(defaultProps).forEach(function (key) {
        obj[key] = typeof _this[key] === 'boolean' ? _this[key] : defaultProps[key];
      });
      return obj;
    }
  },
  watch: {
    value: {
      immediate: true,
      handler: function handler() {
        this.innerValue = getValidDate(this.value, this.defaultValue);
      }
    }
  },
  methods: {
    formatDate: function formatDate(date, fmt) {
      return Object(__WEBPACK_IMPORTED_MODULE_0_date_format_parse__["a" /* format */])(date, fmt, {
        locale: this.getLocale().formatLocale
      });
    },
    isDisabledTime: function isDisabledTime(value) {
      return this.disabledTime(new Date(value));
    },
    isDisabledHour: function isDisabledHour(date) {
      var value = new Date(date);
      return this.isDisabledTime(value) && this.isDisabledTime(value.setMinutes(0, 0, 0)) && this.isDisabledTime(value.setMinutes(59, 59, 999));
    },
    isDisabledMinute: function isDisabledMinute(date) {
      var value = new Date(date);
      return this.isDisabledTime(value) && this.isDisabledTime(value.setSeconds(0, 0)) && this.isDisabledTime(value.setSeconds(59, 999));
    },
    isDisabledAMPM: function isDisabledAMPM(date) {
      var value = new Date(date);
      var minHour = value.getHours() < 12 ? 0 : 12;
      var maxHour = minHour + 11;
      return this.isDisabledTime(value) && this.isDisabledTime(value.setHours(minHour, 0, 0, 0)) && this.isDisabledTime(value.setHours(maxHour, 59, 59, 999));
    },
    isDisabled: function isDisabled(date, type) {
      if (type === 'hour') {
        return this.isDisabledHour(date);
      }

      if (type === 'minute') {
        return this.isDisabledMinute(date);
      }

      if (type === 'ampm') {
        return this.isDisabledAMPM(date);
      }

      return this.isDisabledTime(date);
    },
    handleSelect: function handleSelect(value, type) {
      var date = new Date(value);

      if (!this.isDisabled(value, type)) {
        this.innerValue = date;

        if (!this.isDisabledTime(date)) {
          this.$emit('select', date, type);
        }
      }
    },
    handleClickTitle: function handleClickTitle() {
      this.$emit('clicktitle');
    },
    getClasses: function getClasses(value, type) {
      var cellDate = new Date(value);

      if (this.isDisabled(value, type)) {
        return 'disabled';
      }

      if (cellDate.getTime() === this.innerValue.getTime()) {
        return 'active';
      }

      return '';
    }
  }
};

/* script */
var __vue_script__$8 = script$8;
/* template */

var __vue_render__$b = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: _vm.prefixClass + "-time"
  }, [_vm.showTimeHeader ? _c('div', {
    class: _vm.prefixClass + "-time-header"
  }, [_c('button', {
    class: _vm.prefixClass + "-btn " + _vm.prefixClass + "-btn-text " + _vm.prefixClass + "-time-header-title",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.handleClickTitle
    }
  }, [_vm._v("\n      " + _vm._s(_vm.title) + "\n    ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    class: _vm.prefixClass + "-time-content"
  }, [_vm.timePickerOptions ? _c('list-options', {
    attrs: {
      "date": _vm.innerValue,
      "get-classes": _vm.getClasses,
      "options": _vm.timePickerOptions,
      "format": _vm.innerForamt
    },
    on: {
      "select": _vm.handleSelect
    }
  }) : _c('list-columns', _vm._b({
    attrs: {
      "date": _vm.innerValue,
      "get-classes": _vm.getClasses,
      "hour-options": _vm.hourOptions,
      "minute-options": _vm.minuteOptions,
      "second-options": _vm.secondOptions,
      "hour-step": _vm.hourStep,
      "minute-step": _vm.minuteStep,
      "second-step": _vm.secondStep,
      "scroll-duration": _vm.scrollDuration
    },
    on: {
      "select": _vm.handleSelect
    }
  }, 'list-columns', _vm.ShowHourMinuteSecondAMPM, false))], 1)]);
};

var __vue_staticRenderFns__$b = [];
/* style */

var __vue_inject_styles__$b = undefined;
/* scoped */

var __vue_scope_id__$b = undefined;
/* module identifier */

var __vue_module_identifier__$b = undefined;
/* functional template */

var __vue_is_functional_template__$b = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$b = normalizeComponent({
  render: __vue_render__$b,
  staticRenderFns: __vue_staticRenderFns__$b
}, __vue_inject_styles__$b, __vue_script__$8, __vue_scope_id__$b, __vue_is_functional_template__$b, __vue_module_identifier__$b, false, undefined, undefined, undefined);

var TimeRange = {
  name: 'TimeRange',
  inject: {
    prefixClass: {
      default: 'mx'
    }
  },
  props: _objectSpread2({}, __vue_component__$b.props),
  data: function data() {
    return {
      startValue: new Date(NaN),
      endValue: new Date(NaN)
    };
  },
  watch: {
    value: {
      immediate: true,
      handler: function handler() {
        if (isValidRangeDate(this.value)) {
          var _this$value = _slicedToArray(this.value, 2),
              startValue = _this$value[0],
              endValue = _this$value[1];

          this.startValue = startValue;
          this.endValue = endValue;
        } else {
          this.startValue = new Date(NaN);
          this.endValue = new Date(NaN);
        }
      }
    }
  },
  methods: {
    emitChange: function emitChange(type, index) {
      var date = [this.startValue, this.endValue];
      this.$emit('select', date, type === 'time' ? 'time-range' : type, index);
    },
    handleSelectStart: function handleSelectStart(date, type) {
      this.startValue = date; // check the NaN

      if (!(this.endValue.getTime() >= date.getTime())) {
        this.endValue = date;
      }

      this.emitChange(type, 0);
    },
    handleSelectEnd: function handleSelectEnd(date, type) {
      // check the NaN
      this.endValue = date;

      if (!(this.startValue.getTime() <= date.getTime())) {
        this.startValue = date;
      }

      this.emitChange(type, 1);
    },
    disabledStartTime: function disabledStartTime(date) {
      return this.disabledTime(date, 0);
    },
    disabledEndTime: function disabledEndTime(date) {
      return date.getTime() < this.startValue.getTime() || this.disabledTime(date, 1);
    }
  },
  render: function render() {
    var h = arguments[0];
    var defaultValues = Array.isArray(this.defaultValue) ? this.defaultValue : [this.defaultValue, this.defaultValue];
    var prefixClass = this.prefixClass;
    return h("div", {
      "class": "".concat(prefixClass, "-range-wrapper")
    }, [h(__vue_component__$b, {
      "props": _objectSpread2({}, _objectSpread2({}, this.$props, {
        value: this.startValue,
        defaultValue: defaultValues[0],
        disabledTime: this.disabledStartTime
      })),
      "on": _objectSpread2({}, _objectSpread2({}, this.$listeners, {
        select: this.handleSelectStart
      }))
    }), h(__vue_component__$b, {
      "props": _objectSpread2({}, _objectSpread2({}, this.$props, {
        value: this.endValue,
        defaultValue: defaultValues[1],
        disabledTime: this.disabledEndTime
      })),
      "on": _objectSpread2({}, _objectSpread2({}, this.$listeners, {
        select: this.handleSelectEnd
      }))
    })]);
  }
};

var DatetimePanel = {
  name: 'DatetimePanel',
  inject: {
    prefixClass: {
      default: 'mx'
    }
  },
  emits: ['select', 'update:show-time-panel'],
  props: _objectSpread2({}, CalendarPanel.props, {}, __vue_component__$b.props, {
    showTimePanel: {
      type: Boolean,
      default: undefined
    }
  }),
  data: function data() {
    return {
      defaultTimeVisible: false,
      currentValue: this.value
    };
  },
  computed: {
    timeVisible: function timeVisible() {
      return typeof this.showTimePanel === 'boolean' ? this.showTimePanel : this.defaultTimeVisible;
    }
  },
  watch: {
    value: function value(val) {
      this.currentValue = val;
    }
  },
  methods: {
    closeTimePanel: function closeTimePanel() {
      this.defaultTimeVisible = false;
      this.$emit('update:show-time-panel', false);
    },
    openTimePanel: function openTimePanel() {
      this.defaultTimeVisible = true;
      this.$emit('update:show-time-panel', true);
    },
    emitDate: function emitDate(date, type) {
      this.$emit('select', date, type);
    },
    handleSelect: function handleSelect(date, type) {
      if (type === 'date') {
        this.openTimePanel();
      }

      var datetime = assignTime(date, getValidDate(this.value, this.defaultValue));

      if (this.disabledTime(new Date(datetime))) {
        // set the time of defalutValue;
        datetime = assignTime(date, this.defaultValue);

        if (this.disabledTime(new Date(datetime))) {
          // if disabled don't emit date
          this.currentValue = datetime;
          return;
        }
      }

      this.emitDate(datetime, type);
    }
  },
  render: function render() {
    var h = arguments[0];
    var calendarProps = {
      props: _objectSpread2({}, pick(this.$props, Object.keys(CalendarPanel.props)), {
        type: 'date',
        value: this.currentValue
      }),
      on: {
        select: this.handleSelect
      }
    };
    var timeProps = {
      props: _objectSpread2({}, pick(this.$props, Object.keys(__vue_component__$b.props)), {
        showTimeHeader: true,
        value: this.currentValue
      }),
      on: {
        select: this.emitDate,
        clicktitle: this.closeTimePanel
      }
    };
    var prefixClass = this.prefixClass;
    return h("div", [h(CalendarPanel, helper([{}, calendarProps])), this.timeVisible && h(__vue_component__$b, helper([{
      "class": "".concat(prefixClass, "-calendar-time")
    }, timeProps]))]);
  }
};

var DatetimeRange = {
  name: 'DatetimeRange',
  inject: {
    prefixClass: {
      default: 'mx'
    }
  },
  emits: ['select', 'update:show-time-panel'],
  props: _objectSpread2({}, CalendarRange.props, {}, TimeRange.props, {
    showTimePanel: {
      type: Boolean,
      default: undefined
    }
  }),
  data: function data() {
    return {
      defaultTimeVisible: false,
      currentValue: this.value
    };
  },
  computed: {
    timeVisible: function timeVisible() {
      return typeof this.showTimePanel === 'boolean' ? this.showTimePanel : this.defaultTimeVisible;
    }
  },
  watch: {
    value: function value(val) {
      this.currentValue = val;
    }
  },
  methods: {
    closeTimePanel: function closeTimePanel() {
      this.defaultTimeVisible = false;
      this.$emit('update:show-time-panel', false);
    },
    openTimePanel: function openTimePanel() {
      this.defaultTimeVisible = true;
      this.$emit('update:show-time-panel', true);
    },
    emitDate: function emitDate(dates, type) {
      this.$emit('select', dates, type);
    },
    handleSelect: function handleSelect(dates, type) {
      var _this = this;

      if (type === 'date') {
        this.openTimePanel();
      }

      var defaultValues = Array.isArray(this.defaultValue) ? this.defaultValue : [this.defaultValue, this.defaultValue];
      var datetimes = dates.map(function (date, i) {
        var time = isValidRangeDate(_this.value) ? _this.value[i] : defaultValues[i];
        return assignTime(date, time);
      });

      if (datetimes[1].getTime() < datetimes[0].getTime()) {
        datetimes = [datetimes[0], datetimes[0]];
      }

      if (datetimes.some(this.disabledTime)) {
        datetimes = dates.map(function (date, i) {
          return assignTime(date, defaultValues[i]);
        });

        if (datetimes.some(this.disabledTime)) {
          this.currentValue = datetimes;
          return;
        }
      }

      this.emitDate(datetimes, type);
    }
  },
  render: function render() {
    var h = arguments[0];
    var calendarProps = {
      props: _objectSpread2({}, pick(this.$props, Object.keys(CalendarRange.props)), {
        type: 'date',
        value: this.currentValue
      }),
      on: {
        select: this.handleSelect
      }
    };
    var timeProps = {
      props: _objectSpread2({}, pick(this.$props, Object.keys(TimeRange.props)), {
        value: this.currentValue,
        showTimeHeader: true
      }),
      on: {
        select: this.emitDate,
        clicktitle: this.closeTimePanel
      }
    };
    var prefixClass = this.prefixClass;
    return h("div", [h(CalendarRange, helper([{}, calendarProps])), this.timeVisible && h(TimeRange, helper([{
      "class": "".concat(prefixClass, "-calendar-time")
    }, timeProps]))]);
  }
};

var componentMap = {
  default: CalendarPanel,
  time: __vue_component__$b,
  datetime: DatetimePanel
};
var componentRangeMap = {
  default: CalendarRange,
  time: TimeRange,
  datetime: DatetimeRange
};
var DatePicker = {
  name: 'DatePicker',
  provide: function provide() {
    var _this = this;

    return {
      // make locale reactive
      getLocale: function getLocale() {
        return _this.locale;
      },
      getWeek: this.getWeek,
      prefixClass: this.prefixClass,
      dispatchDatePicker: this.$emit.bind(this)
    };
  },
  props: _objectSpread2({}, DatetimePanel.props, {
    value: {},
    valueType: {
      type: String,
      default: 'date' // date, format, timestamp, or token like 'YYYY-MM-DD'

    },
    type: {
      type: String,
      // ['date', 'datetime', 'time', 'year', 'month', 'week']
      default: 'date'
    },
    format: {
      type: String
    },
    formatter: {
      type: Object
    },
    range: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    rangeSeparator: {
      type: String
    },
    lang: {
      type: [String, Object]
    },
    placeholder: {
      type: String,
      default: ''
    },
    editable: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    },
    prefixClass: {
      type: String,
      default: 'mx'
    },
    inputClass: {},
    inputAttr: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    appendToBody: {
      type: Boolean,
      default: true
    },
    open: {
      type: Boolean,
      default: undefined
    },
    popupClass: {},
    popupStyle: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    inline: {
      type: Boolean,
      default: false
    },
    confirm: {
      type: Boolean,
      default: false
    },
    confirmText: {
      type: String,
      default: 'OK'
    },
    renderInputText: {
      type: Function
    },
    shortcuts: {
      type: Array,
      validator: function validator(value) {
        return Array.isArray(value) && value.every(function (v) {
          return isObject(v) && typeof v.text === 'string' && typeof v.onClick === 'function';
        });
      },
      default: function _default() {
        return [];
      }
    }
  }),
  data: function data() {
    return {
      // cache the innervalue, wait to confirm
      currentValue: null,
      userInput: null,
      defaultOpen: false,
      mouseInInput: false
    };
  },
  computed: {
    popupVisible: function popupVisible() {
      return !this.disabled && (typeof this.open === 'boolean' ? this.open : this.defaultOpen);
    },
    innerRangeSeparator: function innerRangeSeparator() {
      return this.rangeSeparator || (this.multiple ? ',' : ' ~ ');
    },
    innerFormat: function innerFormat() {
      var map = {
        date: 'YYYY-MM-DD',
        datetime: 'YYYY-MM-DD HH:mm:ss',
        year: 'YYYY',
        month: 'YYYY-MM',
        time: 'HH:mm:ss',
        week: 'w'
      };
      return this.format || map[this.type] || map.date;
    },
    innerValue: function innerValue() {
      var value = this.value;

      if (this.validMultipleType) {
        value = Array.isArray(value) ? value : [];
        return value.map(this.value2date);
      }

      if (this.range) {
        value = Array.isArray(value) ? value.slice(0, 2) : [null, null];
        return value.map(this.value2date);
      }

      return this.value2date(value);
    },
    text: function text() {
      var _this2 = this;

      if (this.userInput !== null) {
        return this.userInput;
      }

      if (typeof this.renderInputText === 'function') {
        return this.renderInputText(this.innerValue);
      }

      if (!this.isValidValue(this.innerValue)) {
        return '';
      }

      if (Array.isArray(this.innerValue)) {
        return this.innerValue.map(function (v) {
          return _this2.formatDate(v);
        }).join(this.innerRangeSeparator);
      }

      return this.formatDate(this.innerValue);
    },
    showClearIcon: function showClearIcon() {
      return !this.disabled && this.clearable && this.text && this.mouseInInput;
    },
    locale: function locale() {
      if (isObject(this.lang)) {
        return mergeDeep(getLocale(), this.lang);
      }

      return getLocale(this.lang);
    },
    validMultipleType: function validMultipleType() {
      var types = ['date', 'month', 'year'];
      return this.multiple && !this.range && types.indexOf(this.type) !== -1;
    }
  },
  watch: {
    innerValue: {
      immediate: true,
      handler: function handler(val) {
        this.currentValue = val;
      }
    },
    popupVisible: {
      handler: function handler(val) {
        if (val) {
          this.currentValue = this.innerValue;
        }
      }
    }
  },
  created: function created() {
    if (_typeof(this.format) === 'object') {
      console.warn("[vue2-datepicker]: The prop `format` don't support Object any more. You can use the new prop `formatter` to replace it");
    }
  },
  methods: {
    handleMouseEnter: function handleMouseEnter() {
      this.mouseInInput = true;
    },
    handleMouseLeave: function handleMouseLeave() {
      this.mouseInInput = false;
    },
    handleClickOutSide: function handleClickOutSide(evt) {
      var target = evt.target;

      if (!this.$el.contains(target)) {
        this.closePopup();
      }
    },
    getFormatter: function getFormatter(key) {
      return isObject(this.formatter) && this.formatter[key] || isObject(this.format) && this.format[key];
    },
    getWeek: function getWeek$1(date, options) {
      if (typeof this.getFormatter('getWeek') === 'function') {
        return this.getFormatter('getWeek')(date, options);
      }

      return Object(__WEBPACK_IMPORTED_MODULE_0_date_format_parse__["b" /* getWeek */])(date, options);
    },
    parseDate: function parseDate(value, fmt) {
      fmt = fmt || this.innerFormat;

      if (typeof this.getFormatter('parse') === 'function') {
        return this.getFormatter('parse')(value, fmt);
      }

      var backupDate = new Date();
      return Object(__WEBPACK_IMPORTED_MODULE_0_date_format_parse__["c" /* parse */])(value, fmt, {
        locale: this.locale.formatLocale,
        backupDate: backupDate
      });
    },
    formatDate: function formatDate(date, fmt) {
      fmt = fmt || this.innerFormat;

      if (typeof this.getFormatter('stringify') === 'function') {
        return this.getFormatter('stringify')(date, fmt);
      }

      return Object(__WEBPACK_IMPORTED_MODULE_0_date_format_parse__["a" /* format */])(date, fmt, {
        locale: this.locale.formatLocale
      });
    },
    // transform the outer value to inner date
    value2date: function value2date(value) {
      switch (this.valueType) {
        case 'date':
          return value instanceof Date ? new Date(value.getTime()) : new Date(NaN);

        case 'timestamp':
          return typeof value === 'number' ? new Date(value) : new Date(NaN);

        case 'format':
          return typeof value === 'string' ? this.parseDate(value) : new Date(NaN);

        default:
          return typeof value === 'string' ? this.parseDate(value, this.valueType) : new Date(NaN);
      }
    },
    // transform the inner date to outer value
    date2value: function date2value(date) {
      if (!isValidDate(date)) return null;

      switch (this.valueType) {
        case 'date':
          return date;

        case 'timestamp':
          return date.getTime();

        case 'format':
          return this.formatDate(date);

        default:
          return this.formatDate(date, this.valueType);
      }
    },
    emitValue: function emitValue(date, type) {
      var close = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      // fix IE11/10 trigger input event when input is focused. (placeholder !== '')
      this.userInput = null;
      var value = Array.isArray(date) ? date.map(this.date2value) : this.date2value(date);
      this.$emit('input', value);
      this.$emit('change', value, type);

      if (close) {
        this.closePopup();
      }

      return value;
    },
    isValidValue: function isValidValue(value) {
      if (this.validMultipleType) {
        return isValidDates(value);
      }

      if (this.range) {
        return isValidRangeDate(value);
      }

      return isValidDate(value);
    },
    isValidValueAndNotDisabled: function isValidValueAndNotDisabled(value) {
      if (!this.isValidValue(value)) {
        return false;
      }

      var disabledDate = typeof this.disabledDate === 'function' ? this.disabledDate : function () {
        return false;
      };
      var disabledTime = typeof this.disabledTime === 'function' ? this.disabledTime : function () {
        return false;
      };

      if (!Array.isArray(value)) {
        value = [value];
      }

      return value.every(function (v) {
        return !disabledDate(v) && !disabledTime(v);
      });
    },
    handleMultipleDates: function handleMultipleDates(date, dates) {
      if (this.validMultipleType && dates) {
        var nextDates = dates.filter(function (v) {
          return v.getTime() !== date.getTime();
        });

        if (nextDates.length === dates.length) {
          nextDates.push(date);
        }

        return nextDates;
      }

      return date;
    },
    handleSelectDate: function handleSelectDate(val, type, dates) {
      val = this.handleMultipleDates(val, dates);

      if (this.confirm) {
        this.currentValue = val;
      } else {
        this.emitValue(val, type, // this.type === 'datetime', click the time should close popup
        !this.validMultipleType && (type === this.type || type === 'time'));
      }
    },
    clear: function clear() {
      this.emitValue(this.range ? [null, null] : null);
      this.$emit('clear');
    },
    handleClear: function handleClear(evt) {
      evt.stopPropagation();
      this.clear();
    },
    handleConfirmDate: function handleConfirmDate() {
      var value = this.emitValue(this.currentValue);
      this.$emit('confirm', value);
    },
    handleSelectShortcut: function handleSelectShortcut(evt) {
      var index = evt.currentTarget.getAttribute('data-index');
      var item = this.shortcuts[parseInt(index, 10)];

      if (isObject(item) && typeof item.onClick === 'function') {
        var date = item.onClick(this);

        if (date) {
          this.emitValue(date);
        }
      }
    },
    openPopup: function openPopup(evt) {
      if (this.popupVisible || this.disabled) return;
      this.defaultOpen = true;
      this.$emit('open', evt);
      this.$emit('update:open', true);
    },
    closePopup: function closePopup() {
      if (!this.popupVisible) return;
      this.defaultOpen = false;
      this.$emit('close');
      this.$emit('update:open', false);
    },
    blur: function blur() {
      // when use slot input
      if (this.$refs.input) {
        this.$refs.input.blur();
      }
    },
    focus: function focus() {
      if (this.$refs.input) {
        this.$refs.input.focus();
      }
    },
    handleInputChange: function handleInputChange() {
      var _this3 = this;

      if (!this.editable || this.userInput === null) return;
      var text = this.userInput.trim();
      this.userInput = null;

      if (text === '') {
        this.clear();
        return;
      }

      var date;

      if (this.validMultipleType) {
        date = text.split(this.innerRangeSeparator).map(function (v) {
          return _this3.parseDate(v.trim());
        });
      } else if (this.range) {
        var arr = text.split(this.innerRangeSeparator);

        if (arr.length !== 2) {
          // Maybe the separator during the day is the same as the separator for the date
          // eg: 2019-10-09-2020-01-02
          arr = text.split(this.innerRangeSeparator.trim());
        }

        date = arr.map(function (v) {
          return _this3.parseDate(v.trim());
        });
      } else {
        date = this.parseDate(text);
      }

      if (this.isValidValueAndNotDisabled(date)) {
        this.emitValue(date);
        this.blur();
      } else {
        this.$emit('input-error', text);
      }
    },
    handleInputInput: function handleInputInput(evt) {
      // slot input v-model
      this.userInput = typeof evt === 'string' ? evt : evt.target.value;
    },
    handleInputKeydown: function handleInputKeydown(evt) {
      var keyCode = evt.keyCode; // Tab 9 or Enter 13

      if (keyCode === 9) {
        this.closePopup();
      } else if (keyCode === 13) {
        this.handleInputChange();
      }
    },
    handleInputBlur: function handleInputBlur(evt) {
      // tab close
      this.$emit('blur', evt);
    },
    handleInputFocus: function handleInputFocus(evt) {
      this.openPopup(evt);
      this.$emit('focus', evt);
    },
    hasSlot: function hasSlot(name) {
      return !!(this.$slots[name] || this.$scopedSlots[name]);
    },
    renderSlot: function renderSlot(name, fallback, props) {
      var slotFn = this.$scopedSlots[name];

      if (slotFn) {
        return slotFn(props) || fallback;
      }

      return this.$slots[name] || fallback;
    },
    renderInput: function renderInput() {
      var h = this.$createElement;
      var prefixClass = this.prefixClass;

      var props = _objectSpread2({
        name: 'date',
        type: 'text',
        autocomplete: 'off',
        value: this.text,
        class: this.inputClass || "".concat(this.prefixClass, "-input"),
        readonly: !this.editable,
        disabled: this.disabled,
        placeholder: this.placeholder
      }, this.inputAttr);

      var value = props.value,
          className = props.class,
          attrs = _objectWithoutProperties(props, ["value", "class"]);

      var events = {
        keydown: this.handleInputKeydown,
        focus: this.handleInputFocus,
        blur: this.handleInputBlur,
        input: this.handleInputInput,
        change: this.handleInputChange
      };
      var input = this.renderSlot('input', h("input", {
        "domProps": {
          "value": value
        },
        "class": className,
        "attrs": _objectSpread2({}, attrs),
        "on": _objectSpread2({}, events),
        "ref": "input"
      }), {
        props: props,
        events: events
      });
      var calendarIcon = this.type === 'time' ? h(__vue_component__$2) : h(__vue_component__$1); // remove touchstart event to avoid opens the popup while scrolling in mobile #469

      return h("div", {
        "class": "".concat(prefixClass, "-input-wrapper"),
        "on": {
          "mouseenter": this.handleMouseEnter,
          "mouseleave": this.handleMouseLeave,
          "click": this.openPopup
        },
        "ref": "inputWrapper"
      }, [input, this.showClearIcon ? h("i", {
        "class": "".concat(prefixClass, "-icon-clear"),
        "on": {
          "click": this.handleClear
        }
      }, [this.renderSlot('icon-clear', h(__vue_component__$3))]) : h("i", {
        "class": "".concat(prefixClass, "-icon-calendar")
      }, [this.renderSlot('icon-calendar', calendarIcon)])]);
    },
    renderContent: function renderContent() {
      var h = this.$createElement;
      var map = this.range ? componentRangeMap : componentMap;
      var Component = map[this.type] || map.default;

      var props = _objectSpread2({}, pick(this.$props, Object.keys(Component.props)), {
        value: this.currentValue
      });

      var on = _objectSpread2({}, pick(this.$listeners, Component.emits || []), {
        select: this.handleSelectDate
      });

      var content = h(Component, helper([{}, {
        props: props,
        on: on,
        ref: 'picker'
      }]));
      return h("div", {
        "class": "".concat(this.prefixClass, "-datepicker-body")
      }, [this.renderSlot('content', content, {
        value: this.currentValue,
        emit: this.handleSelectDate
      })]);
    },
    renderSidebar: function renderSidebar() {
      var _this4 = this;

      var h = this.$createElement;
      var prefixClass = this.prefixClass;
      return h("div", {
        "class": "".concat(prefixClass, "-datepicker-sidebar")
      }, [this.renderSlot('sidebar', null, {
        value: this.currentValue,
        emit: this.handleSelectDate
      }), this.shortcuts.map(function (v, i) {
        return h("button", {
          "key": i,
          "attrs": {
            "data-index": i,
            "type": "button"
          },
          "class": "".concat(prefixClass, "-btn ").concat(prefixClass, "-btn-text ").concat(prefixClass, "-btn-shortcut"),
          "on": {
            "click": _this4.handleSelectShortcut
          }
        }, [v.text]);
      })]);
    },
    renderHeader: function renderHeader() {
      var h = this.$createElement;
      return h("div", {
        "class": "".concat(this.prefixClass, "-datepicker-header")
      }, [this.renderSlot('header', null, {
        value: this.currentValue,
        emit: this.handleSelectDate
      })]);
    },
    renderFooter: function renderFooter() {
      var h = this.$createElement;
      var prefixClass = this.prefixClass;
      return h("div", {
        "class": "".concat(prefixClass, "-datepicker-footer")
      }, [this.renderSlot('footer', null, {
        value: this.currentValue,
        emit: this.handleSelectDate
      }), this.confirm ? h("button", {
        "attrs": {
          "type": "button"
        },
        "class": "".concat(prefixClass, "-btn ").concat(prefixClass, "-datepicker-btn-confirm"),
        "on": {
          "click": this.handleConfirmDate
        }
      }, [this.confirmText]) : null]);
    }
  },
  render: function render() {
    var _class;

    var h = arguments[0];
    var prefixClass = this.prefixClass,
        inline = this.inline,
        disabled = this.disabled;
    var sidedar = this.hasSlot('sidebar') || this.shortcuts.length ? this.renderSidebar() : null;
    var content = h("div", {
      "class": "".concat(prefixClass, "-datepicker-content")
    }, [this.hasSlot('header') ? this.renderHeader() : null, this.renderContent(), this.hasSlot('footer') || this.confirm ? this.renderFooter() : null]);
    return h("div", {
      "class": (_class = {}, _defineProperty(_class, "".concat(prefixClass, "-datepicker"), true), _defineProperty(_class, "".concat(prefixClass, "-datepicker-range"), this.range), _defineProperty(_class, "".concat(prefixClass, "-datepicker-inline"), inline), _defineProperty(_class, "disabled", disabled), _class)
    }, [!inline ? this.renderInput() : null, !inline ? h(__vue_component__, {
      "ref": "popup",
      "class": this.popupClass,
      "style": this.popupStyle,
      "attrs": {
        "visible": this.popupVisible,
        "appendToBody": this.appendToBody
      },
      "on": {
        "clickoutside": this.handleClickOutSide
      }
    }, [sidedar, content]) : h("div", {
      "class": "".concat(prefixClass, "-datepicker-main")
    }, [sidedar, content])]);
  }
};

DatePicker.locale = locale;

DatePicker.install = function install(Vue) {
  Vue.component(DatePicker.name, DatePicker);
};

if (typeof window !== 'undefined' && window.Vue) {
  DatePicker.install(window.Vue);
}

_extends(DatePicker, {
  CalendarPanel: CalendarPanel,
  CalendarRange: CalendarRange,
  TimePanel: __vue_component__$b,
  TimeRange: TimeRange,
  DatetimePanel: DatetimePanel,
  DatetimeRange: DatetimeRange
});

/* harmony default export */ __webpack_exports__["a"] = (DatePicker);


/***/ }),

/***/ 1573:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__format__ = __webpack_require__(1574);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__format__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__parse__ = __webpack_require__(1575);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__parse__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__(1552);
/* unused harmony reexport isDate */
/* unused harmony reexport toDate */
/* unused harmony reexport isValidDate */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__util__["a"]; });




/***/ }),

/***/ 1574:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = format;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(1552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__locale_en__ = __webpack_require__(1557);


var REGEX_FORMAT = /\[([^\]]+)]|YYYY|YY?|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|m{1,2}|s{1,2}|Z{1,2}|S{1,3}|w{1,2}|x|X|a|A/g;

function pad(val) {
  var len = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  var output = "".concat(Math.abs(val));
  var sign = val < 0 ? '-' : '';

  while (output.length < len) {
    output = "0".concat(output);
  }

  return sign + output;
}

function getOffset(date) {
  return Math.round(date.getTimezoneOffset() / 15) * 15;
}

function formatTimezone(offset) {
  var delimeter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;
  return sign + pad(hours, 2) + delimeter + pad(minutes, 2);
}

var meridiem = function meridiem(h, _, isLowercase) {
  var word = h < 12 ? 'AM' : 'PM';
  return isLowercase ? word.toLocaleLowerCase() : word;
};

var formatFlags = {
  Y: function Y(date) {
    var y = date.getFullYear();
    return y <= 9999 ? "".concat(y) : "+".concat(y);
  },
  // Year: 00, 01, ..., 99
  YY: function YY(date) {
    return pad(date.getFullYear(), 4).substr(2);
  },
  // Year: 1900, 1901, ..., 2099
  YYYY: function YYYY(date) {
    return pad(date.getFullYear(), 4);
  },
  // Month: 1, 2, ..., 12
  M: function M(date) {
    return date.getMonth() + 1;
  },
  // Month: 01, 02, ..., 12
  MM: function MM(date) {
    return pad(date.getMonth() + 1, 2);
  },
  MMM: function MMM(date, locale) {
    return locale.monthsShort[date.getMonth()];
  },
  MMMM: function MMMM(date, locale) {
    return locale.months[date.getMonth()];
  },
  // Day of month: 1, 2, ..., 31
  D: function D(date) {
    return date.getDate();
  },
  // Day of month: 01, 02, ..., 31
  DD: function DD(date) {
    return pad(date.getDate(), 2);
  },
  // Hour: 0, 1, ... 23
  H: function H(date) {
    return date.getHours();
  },
  // Hour: 00, 01, ..., 23
  HH: function HH(date) {
    return pad(date.getHours(), 2);
  },
  // Hour: 1, 2, ..., 12
  h: function h(date) {
    var hours = date.getHours();

    if (hours === 0) {
      return 12;
    }

    if (hours > 12) {
      return hours % 12;
    }

    return hours;
  },
  // Hour: 01, 02, ..., 12
  hh: function hh() {
    var hours = formatFlags.h.apply(formatFlags, arguments);
    return pad(hours, 2);
  },
  // Minute: 0, 1, ..., 59
  m: function m(date) {
    return date.getMinutes();
  },
  // Minute: 00, 01, ..., 59
  mm: function mm(date) {
    return pad(date.getMinutes(), 2);
  },
  // Second: 0, 1, ..., 59
  s: function s(date) {
    return date.getSeconds();
  },
  // Second: 00, 01, ..., 59
  ss: function ss(date) {
    return pad(date.getSeconds(), 2);
  },
  // 1/10 of second: 0, 1, ..., 9
  S: function S(date) {
    return Math.floor(date.getMilliseconds() / 100);
  },
  // 1/100 of second: 00, 01, ..., 99
  SS: function SS(date) {
    return pad(Math.floor(date.getMilliseconds() / 10), 2);
  },
  // Millisecond: 000, 001, ..., 999
  SSS: function SSS(date) {
    return pad(date.getMilliseconds(), 3);
  },
  // Day of week: 0, 1, ..., 6
  d: function d(date) {
    return date.getDay();
  },
  // Day of week: 'Su', 'Mo', ..., 'Sa'
  dd: function dd(date, locale) {
    return locale.weekdaysMin[date.getDay()];
  },
  // Day of week: 'Sun', 'Mon',..., 'Sat'
  ddd: function ddd(date, locale) {
    return locale.weekdaysShort[date.getDay()];
  },
  // Day of week: 'Sunday', 'Monday', ...,'Saturday'
  dddd: function dddd(date, locale) {
    return locale.weekdays[date.getDay()];
  },
  // AM, PM
  A: function A(date, locale) {
    var meridiemFunc = locale.meridiem || meridiem;
    return meridiemFunc(date.getHours(), date.getMinutes(), false);
  },
  // am, pm
  a: function a(date, locale) {
    var meridiemFunc = locale.meridiem || meridiem;
    return meridiemFunc(date.getHours(), date.getMinutes(), true);
  },
  // Timezone: -01:00, +00:00, ... +12:00
  Z: function Z(date) {
    return formatTimezone(getOffset(date), ':');
  },
  // Timezone: -0100, +0000, ... +1200
  ZZ: function ZZ(date) {
    return formatTimezone(getOffset(date));
  },
  // Seconds timestamp: 512969520
  X: function X(date) {
    return Math.floor(date.getTime() / 1000);
  },
  // Milliseconds timestamp: 512969520900
  x: function x(date) {
    return date.getTime();
  },
  w: function w(date, locale) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__util__["a" /* getWeek */])(date, {
      firstDayOfWeek: locale.firstDayOfWeek,
      firstWeekContainsDate: locale.firstWeekContainsDate
    });
  },
  ww: function ww(date, locale) {
    return pad(formatFlags.w(date, locale), 2);
  }
};
function format(val, str) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var formatStr = str ? String(str) : 'YYYY-MM-DDTHH:mm:ss.SSSZ';
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__util__["d" /* toDate */])(val);

  if (!Object(__WEBPACK_IMPORTED_MODULE_0__util__["b" /* isValidDate */])(date)) {
    return 'Invalid Date';
  }

  var locale = options.locale || __WEBPACK_IMPORTED_MODULE_1__locale_en__["a" /* default */];
  return formatStr.replace(REGEX_FORMAT, function (match, p1) {
    if (p1) {
      return p1;
    }

    if (typeof formatFlags[match] === 'function') {
      return "".concat(formatFlags[match](date, locale));
    }

    return match;
  });
}

/***/ }),

/***/ 1575:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parse;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale_en__ = __webpack_require__(1557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(1552);
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var formattingTokens = /(\[[^\[]*\])|(MM?M?M?|Do|DD?|ddd?d?|w[o|w]?|YYYY|YY|a|A|hh?|HH?|mm?|ss?|S{1,3}|x|X|ZZ?|.)/g;
var match1 = /\d/; // 0 - 9

var match2 = /\d\d/; // 00 - 99

var match3 = /\d{3}/; // 000 - 999

var match4 = /\d{4}/; // 0000 - 9999

var match1to2 = /\d\d?/; // 0 - 99

var matchShortOffset = /[+-]\d\d:?\d\d/; // +00:00 -00:00 +0000 or -0000

var matchSigned = /[+-]?\d+/; // -inf - inf

var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
// const matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i; // Word

var YEAR = 'year';
var MONTH = 'month';
var DAY = 'day';
var HOUR = 'hour';
var MINUTE = 'minute';
var SECOND = 'second';
var MILLISECOND = 'millisecond';
var parseFlags = {};

var addParseFlag = function addParseFlag(token, regex, callback) {
  var tokens = Array.isArray(token) ? token : [token];
  var func;

  if (typeof callback === 'string') {
    func = function func(input) {
      var value = parseInt(input, 10);
      return _defineProperty({}, callback, value);
    };
  } else {
    func = callback;
  }

  tokens.forEach(function (key) {
    parseFlags[key] = [regex, func];
  });
};

var escapeStringRegExp = function escapeStringRegExp(str) {
  return str.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&');
};

var matchWordRegExp = function matchWordRegExp(localeKey) {
  return function (locale) {
    var array = locale[localeKey];

    if (!Array.isArray(array)) {
      throw new Error("Locale[".concat(localeKey, "] need an array"));
    }

    return new RegExp(array.map(escapeStringRegExp).join('|'));
  };
};

var matchWordCallback = function matchWordCallback(localeKey, key) {
  return function (input, locale) {
    var array = locale[localeKey];

    if (!Array.isArray(array)) {
      throw new Error("Locale[".concat(localeKey, "] need an array"));
    }

    var index = array.indexOf(input);

    if (index < 0) {
      throw new Error('Invalid Word');
    }

    return _defineProperty({}, key, index);
  };
};

addParseFlag('Y', matchSigned, YEAR);
addParseFlag('YY', match2, function (input) {
  var year = new Date().getFullYear();
  var cent = Math.floor(year / 100);
  var value = parseInt(input, 10);
  value = (value > 68 ? cent - 1 : cent) * 100 + value;
  return _defineProperty({}, YEAR, value);
});
addParseFlag('YYYY', match4, YEAR);
addParseFlag('M', match1to2, function (input) {
  return _defineProperty({}, MONTH, parseInt(input, 10) - 1);
});
addParseFlag('MM', match2, function (input) {
  return _defineProperty({}, MONTH, parseInt(input, 10) - 1);
});
addParseFlag('MMM', matchWordRegExp('monthsShort'), matchWordCallback('monthsShort', MONTH));
addParseFlag('MMMM', matchWordRegExp('months'), matchWordCallback('months', MONTH));
addParseFlag('D', match1to2, DAY);
addParseFlag('DD', match2, DAY);
addParseFlag(['H', 'h'], match1to2, HOUR);
addParseFlag(['HH', 'hh'], match2, HOUR);
addParseFlag('m', match1to2, MINUTE);
addParseFlag('mm', match2, MINUTE);
addParseFlag('s', match1to2, SECOND);
addParseFlag('ss', match2, SECOND);
addParseFlag('S', match1, function (input) {
  return _defineProperty({}, MILLISECOND, parseInt(input, 10) * 100);
});
addParseFlag('SS', match2, function (input) {
  return _defineProperty({}, MILLISECOND, parseInt(input, 10) * 10);
});
addParseFlag('SSS', match3, MILLISECOND);

function matchMeridiem(locale) {
  return locale.meridiemParse || /[ap]\.?m?\.?/i;
}

function defaultIsPM(input) {
  return "".concat(input).toLowerCase().charAt(0) === 'p';
}

addParseFlag(['A', 'a'], matchMeridiem, function (input, locale) {
  var isPM = typeof locale.isPM === 'function' ? locale.isPM(input) : defaultIsPM(input);
  return {
    isPM: isPM
  };
});

function offsetFromString(str) {
  var _ref8 = str.match(/([+-]|\d\d)/g) || ['-', '0', '0'],
      _ref9 = _slicedToArray(_ref8, 3),
      symbol = _ref9[0],
      hour = _ref9[1],
      minute = _ref9[2];

  var minutes = parseInt(hour, 10) * 60 + parseInt(minute, 10);

  if (minutes === 0) {
    return 0;
  }

  return symbol === '+' ? -minutes : +minutes;
}

addParseFlag(['Z', 'ZZ'], matchShortOffset, function (input) {
  return {
    offset: offsetFromString(input)
  };
});
addParseFlag('x', matchSigned, function (input) {
  return {
    date: new Date(parseInt(input, 10))
  };
});
addParseFlag('X', matchTimestamp, function (input) {
  return {
    date: new Date(parseFloat(input) * 1000)
  };
});
addParseFlag('d', match1, 'weekday');
addParseFlag('dd', matchWordRegExp('weekdaysMin'), matchWordCallback('weekdaysMin', 'weekday'));
addParseFlag('ddd', matchWordRegExp('weekdaysShort'), matchWordCallback('weekdaysShort', 'weekday'));
addParseFlag('dddd', matchWordRegExp('weekdays'), matchWordCallback('weekdays', 'weekday'));
addParseFlag('w', match1to2, 'week');
addParseFlag('ww', match2, 'week');

function to24hour(hour, isPM) {
  if (hour !== undefined && isPM !== undefined) {
    if (isPM) {
      if (hour < 12) {
        return hour + 12;
      }
    } else if (hour === 12) {
      return 0;
    }
  }

  return hour;
}

function getFullInputArray(input) {
  var backupDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date();
  var result = [0, 0, 1, 0, 0, 0, 0];
  var backupArr = [backupDate.getFullYear(), backupDate.getMonth(), backupDate.getDate(), backupDate.getHours(), backupDate.getMinutes(), backupDate.getSeconds(), backupDate.getMilliseconds()];
  var useBackup = true;

  for (var i = 0; i < 7; i++) {
    if (input[i] === undefined) {
      result[i] = useBackup ? backupArr[i] : result[i];
    } else {
      result[i] = input[i];
      useBackup = false;
    }
  }

  return result;
}

function createDate(y, m, d, h, M, s, ms) {
  var date;

  if (y < 100 && y >= 0) {
    date = new Date(y + 400, m, d, h, M, s, ms);

    if (isFinite(date.getFullYear())) {
      date.setFullYear(y);
    }
  } else {
    date = new Date(y, m, d, h, M, s, ms);
  }

  return date;
}

function createUTCDate() {
  var date;

  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var y = args[0];

  if (y < 100 && y >= 0) {
    args[0] += 400;
    date = new Date(Date.UTC.apply(Date, args)); // eslint-disable-next-line no-restricted-globals

    if (isFinite(date.getUTCFullYear())) {
      date.setUTCFullYear(y);
    }
  } else {
    date = new Date(Date.UTC.apply(Date, args));
  }

  return date;
}

function makeParser(dateString, format, locale) {
  var tokens = format.match(formattingTokens);

  if (!tokens) {
    throw new Error();
  }

  var length = tokens.length;
  var mark = {};

  for (var i = 0; i < length; i += 1) {
    var token = tokens[i];
    var parseTo = parseFlags[token];

    if (!parseTo) {
      var word = token.replace(/^\[|\]$/g, '');

      if (dateString.indexOf(word) === 0) {
        dateString = dateString.substr(word.length);
      } else {
        throw new Error('not match');
      }
    } else {
      var regex = typeof parseTo[0] === 'function' ? parseTo[0](locale) : parseTo[0];
      var parser = parseTo[1];
      var value = (regex.exec(dateString) || [])[0];
      var obj = parser(value, locale);
      mark = _objectSpread({}, mark, {}, obj);
      dateString = dateString.replace(value, '');
    }
  }

  return mark;
}

function parse(str, format) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  try {
    var _options$locale = options.locale,
        _locale = _options$locale === void 0 ? __WEBPACK_IMPORTED_MODULE_0__locale_en__["a" /* default */] : _options$locale,
        _options$backupDate = options.backupDate,
        backupDate = _options$backupDate === void 0 ? new Date() : _options$backupDate;

    var parseResult = makeParser(str, format, _locale);
    var year = parseResult.year,
        month = parseResult.month,
        day = parseResult.day,
        hour = parseResult.hour,
        minute = parseResult.minute,
        second = parseResult.second,
        millisecond = parseResult.millisecond,
        isPM = parseResult.isPM,
        date = parseResult.date,
        offset = parseResult.offset,
        weekday = parseResult.weekday,
        week = parseResult.week;

    if (date) {
      return date;
    }

    var inputArray = [year, month, day, hour, minute, second, millisecond];
    inputArray[3] = to24hour(inputArray[3], isPM); // check week

    if (week !== undefined && month === undefined && day === undefined) {
      // new Date(year, 3) make sure in current year
      var firstDate = Object(__WEBPACK_IMPORTED_MODULE_1__util__["c" /* startOfWeekYear */])(year === undefined ? backupDate : new Date(year, 3), {
        firstDayOfWeek: _locale.firstDayOfWeek,
        firstWeekContainsDate: _locale.firstWeekContainsDate
      });
      return new Date(firstDate.getTime() + (week - 1) * 7 * 24 * 3600 * 1000);
    }

    var parsedDate;
    var result = getFullInputArray(inputArray, backupDate);

    if (offset !== undefined) {
      result[6] += offset * 60 * 1000;
      parsedDate = createUTCDate.apply(void 0, _toConsumableArray(result));
    } else {
      parsedDate = createDate.apply(void 0, _toConsumableArray(result));
    } // check weekday


    if (weekday !== undefined && parsedDate.getDay() !== weekday) {
      return new Date(NaN);
    }

    return parsedDate;
  } catch (e) {
    return new Date(NaN);
  }
}

/***/ }),

/***/ 1583:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Datepicker_vue__ = __webpack_require__(1584);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8fbc336e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Datepicker_vue__ = __webpack_require__(1617);
function injectStyle (ssrContext) {
  __webpack_require__(1613)
  __webpack_require__(1615)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8fbc336e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Datepicker_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8fbc336e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Datepicker_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1584:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_datepicker__ = __webpack_require__(1572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_datepicker_index_css__ = __webpack_require__(1599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_datepicker_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue2_datepicker_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);


//
//
//
//
//
//





var context = null;

/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        dateFrom: {
            type: Date,
            required: false,
            default: null
        },
        dateTo: {
            type: Date,
            required: false,
            default: null
        },
        min: {
            type: Date,
            required: false,
            default: null
        },
        max: {
            type: Date,
            required: false,
            default: null
        },
        showTime: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    components: {
        DatePicker: __WEBPACK_IMPORTED_MODULE_2_vue2_datepicker__["a" /* default */]
    },
    data: function data() {
        var _this = this;

        var now = new Date();
        var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        var yesterday = new Date();
        var weekAgo = new Date();
        weekAgo.setDate(now.getDate() - 7);
        weekAgo = new Date(weekAgo.getFullYear(), weekAgo.getMonth(), weekAgo.getDate(), 0, 0, 0);
        yesterday.setDate(now.getDate() - 1);
        yesterday = new Date(yesterday.getFullYear(), yesterday.getMonth(), yesterday.getDate(), 0, 0, 0);
        return {
            time: null,
            name: '',
            specialName: '',
            separator: '~',
            renderInputText: function renderInputText(dates) {
                try {
                    if (context.specialName !== '') {
                        var s = context.specialName;
                        context.specialName = '';
                        return s;
                    }
                } catch (e) {
                    //ignored
                }
                return __WEBPACK_IMPORTED_MODULE_4_moment___default()(dates[0]).format('DD-MM-YYYY') + ' ~ ' + __WEBPACK_IMPORTED_MODULE_4_moment___default()(dates[1]).format('DD-MM-YYYY');
            },
            shortcuts: [{
                text: this.$t('Today'),
                onClick: function onClick() {
                    _this.time = [today, now];
                    _this.specialName = _this.$t('Today');
                }
            }, {
                text: this.$t('Yesterday'),
                onClick: function onClick() {
                    _this.time = [yesterday, new Date(yesterday.getFullYear(), yesterday.getMonth(), yesterday.getDate(), 23, 59, 0)];
                    _this.specialName = _this.$t('Yesterday');
                }
            }, {
                text: this.$t('Last7Days'),
                onClick: function onClick() {
                    _this.time = [weekAgo, now];
                    _this.specialName = _this.$t('Last7Days');
                }
            }]
        };
    },

    watch: {
        time: function time(newVal) {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (_this2.specialName === '') {
                                    newVal[1] = new Date(newVal[1].getFullYear(), newVal[1].getMonth(), newVal[1].getDate(), 23, 59, 0);
                                    if (new Date(newVal[1]) > new Date()) {
                                        newVal[1] = new Date();
                                    }
                                }
                                _this2.$emit('dateChanged', newVal[0], newVal[1]);

                            case 2:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        }
    },
    methods: {
        setDate: function setDate() {
            if (this.dateFrom != null && this.dateTo != null) {
                this.time = [this.dateFrom, this.dateTo];
            }
        }
    },
    mounted: function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            context = this;
                            this.setDate();

                        case 2:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this);
        }));

        function mounted() {
            return _ref.apply(this, arguments);
        }

        return mounted;
    }()
});

/***/ }),

/***/ 1595:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_api__ = __webpack_require__(952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_grids__ = __webpack_require__(953);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Modal_vue__ = __webpack_require__(1547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SciChart_vue__ = __webpack_require__(1612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SciChartMultiple_vue__ = __webpack_require__(1620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Charts_SciChartSingleDayPriorityAlarms_vue__ = __webpack_require__(1641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Charts_SciChartOneLineAlarms_vue__ = __webpack_require__(1650);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        Modal: __WEBPACK_IMPORTED_MODULE_4__Modal_vue__["a" /* default */],
        SciChart: __WEBPACK_IMPORTED_MODULE_5__SciChart_vue__["a" /* default */],
        SciChartMultiple: __WEBPACK_IMPORTED_MODULE_6__SciChartMultiple_vue__["a" /* default */],
        SciChartSingleDayPriorityAlarms: __WEBPACK_IMPORTED_MODULE_7__Charts_SciChartSingleDayPriorityAlarms_vue__["a" /* default */],
        SciChartOneLineAlarms: __WEBPACK_IMPORTED_MODULE_8__Charts_SciChartOneLineAlarms_vue__["a" /* default */]
    },
    provide: {
        grid: [__WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_grids__["l" /* Sort */], __WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_grids__["i" /* Page */], __WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_grids__["g" /* Filter */], __WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_grids__["m" /* Toolbar */], __WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_grids__["k" /* Search */], __WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_grids__["b" /* CommandColumn */], __WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_grids__["j" /* PdfExport */], __WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_grids__["f" /* ExcelExport */]]
    },
    props: {
        data: {
            type: Object,
            required: true
        },
        day: {
            type: Number,
            required: false,
            default: 0
        },
        apiMethodName: {
            type: String,
            required: true
        },
        value: {
            type: Number
        }
    },
    data: function data() {
        return {
            obj: [],
            chart: [],
            devices: 0,
            activeModal: null,
            graphData: {
                xValues: [],
                yValues: []
            },
            filterMenu: {
                type: "Menu"
            },
            statusChartData: [],
            allAlarmTypes: [],

            toolbar: [{ text: this.$t('ShowGraph'), id: 'show-graph', prefixIcon: "ChartIcon", align: 'Right' }],
            pageSettings: { pageSize: 100, pageSizes: [10, 25, 50, 100] },
            wrapSettings: { wrapMode: "Content" },
            selectionOptions: { type: "Multiple" },
            filterOptions: {
                type: "CheckBox"
            },
            dateTimeFormatOptions: { format: 'yyyy-MM-dd HH:mm:ss', type: 'dateTime' },
            customAttributes: { class: "customcss" }
        };
    },

    methods: {
        getData: function getData() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var field, result, availableDevices, i, _i;

                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                field = _this.data.column.field;
                                _context.t0 = _this.apiMethodName;
                                _context.next = _context.t0 === 'getSystemAlarmFromToday' ? 4 : _context.t0 === 'getAlarmsByIdAndDay' ? 15 : _context.t0 === 'getAlarmsForDetailsModal' ? 19 : _context.t0 === 'getDeviceAlarmFromDay' ? 23 : _context.t0 === 'getVisitsForDay' ? 27 : 29;
                                break;

                            case 4:
                                _this.loadAlarmTypes();

                                _context.next = 7;
                                return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_67" /* getSystemAlarmFromDay */])(_this.data.id, field.charAt(field.length - 1), _this.day);

                            case 7:
                                _this.obj = _context.sent;
                                _context.next = 10;
                                return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_66" /* getSystemAlarmChartsForDay */])(_this.data.id, field.charAt(field.length - 1), _this.day);

                            case 10:
                                result = _context.sent;


                                if (result.alarms.length != result.numberOfDevices && result.alarms.length != 0) {
                                    availableDevices = result.alarms.map(function (x) {
                                        return x.item2;
                                    });

                                    for (i = 1; i <= result.numberOfDevices; i++) {
                                        if (!availableDevices.includes(i.toString())) {
                                            result.alarms.push({ item1: [], item2: i.toString() });
                                        }
                                    }
                                }

                                _this.chart.push(result.alarms);
                                _this.devices = result.numberOfDevices;
                                return _context.abrupt('break', 29);

                            case 15:
                                _context.next = 17;
                                return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["X" /* getAlarmsByIdAndDay */])(_this.data.id, _this.day);

                            case 17:
                                _this.obj = _context.sent;
                                return _context.abrupt('break', 29);

                            case 19:
                                _context.next = 21;
                                return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["Y" /* getAlarmsForDetailsModal */])(_this.data.alarmTypeId, _this.data.systemId, _this.data.deviceId, _this.day);

                            case 21:
                                _this.obj = _context.sent;
                                return _context.abrupt('break', 29);

                            case 23:
                                _context.next = 25;
                                return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_23" /* getDeviceAlarmFromDay */])(_this.data.id, field, _this.day);

                            case 25:
                                _this.obj = _context.sent;
                                return _context.abrupt('break', 29);

                            case 27:
                                _this.obj = _this.data[_this.data.column.field][_this.day];
                                return _context.abrupt('break', 29);

                            case 29:

                                for (_i = 0; _i < _this.obj.length; _i++) {
                                    _this.obj[_i]['createDate'] = new Date(_this.obj[_i]['createDate'].toDateTime());
                                    _this.obj[_i]['endDate'] = new Date(_this.obj[_i]['endDate'].toDateTime());
                                    _this.obj[_i]['alarmType'] = _this.$t(_this.obj[_i]['alarmType']);
                                }

                            case 30:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        loadAlarmTypes: function loadAlarmTypes() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var aT;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_0" /* getAllAlarmTypes */])();

                            case 2:
                                aT = _context2.sent;

                                _this2.allAlarmTypes = aT;

                            case 4:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        },

        dataBound: function dataBound() {
            this.$refs.system_modal_grid.autoFitColumns();
        },
        toolbarClick: function toolbarClick(args) {
            switch (args.item.id) {
                case "show-graph":
                    if (this.apiMethodName == "getSystemAlarmFromToday" || this.data.column.field == "errorLogs") {
                        this.activeModal = "PRIORITY-CHART";
                        return;
                    }
                    break;
            }
        },
        closeModal: function closeModal() {
            this.activeModal = null;
            this.graphData = {
                xValues: [],
                yValues: []
            };
        }
    },
    mounted: function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            this.getData();

                        case 1:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, this);
        }));

        function mounted() {
            return _ref.apply(this, arguments);
        }

        return mounted;
    }()
});

/***/ }),

/***/ 1596:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_scichart_Charting_Visuals_SciChartSurface__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_scichart_Charting_Visuals_SciChartSurface___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_scichart_Charting_Visuals_SciChartSurface__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_scichart_Charting_Visuals_Axis_NumericAxis__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_scichart_Charting_Visuals_Axis_NumericAxis___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_scichart_Charting_Visuals_Axis_NumericAxis__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_scichart_types_AxisAlignment__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_scichart_types_AxisAlignment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_scichart_types_AxisAlignment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_scichart_Charting_Visuals_RenderableSeries_FastLineRenderableSeries__ = __webpack_require__(955);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_scichart_Charting_Visuals_RenderableSeries_FastLineRenderableSeries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_scichart_Charting_Visuals_RenderableSeries_FastLineRenderableSeries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_scichart_Charting_Model_XyDataSeries__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_scichart_Charting_Model_XyDataSeries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_scichart_Charting_Model_XyDataSeries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_scichart_Charting_ChartModifiers_ZoomPanModifier__ = __webpack_require__(959);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_scichart_Charting_ChartModifiers_ZoomPanModifier___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_scichart_Charting_ChartModifiers_ZoomPanModifier__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_scichart_Charting_ChartModifiers_MouseWheelZoomModifier__ = __webpack_require__(957);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_scichart_Charting_ChartModifiers_MouseWheelZoomModifier___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_scichart_Charting_ChartModifiers_MouseWheelZoomModifier__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_scichart_Charting_ChartModifiers_RubberBandXyZoomModifier__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_scichart_Charting_ChartModifiers_RubberBandXyZoomModifier___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_scichart_Charting_ChartModifiers_RubberBandXyZoomModifier__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_scichart_Charting_ChartModifiers_ZoomExtentsModifier__ = __webpack_require__(958);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_scichart_Charting_ChartModifiers_ZoomExtentsModifier___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_scichart_Charting_ChartModifiers_ZoomExtentsModifier__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_scichart_Charting_ChartModifiers_RolloverModifier__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_scichart_Charting_ChartModifiers_RolloverModifier___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_scichart_Charting_ChartModifiers_RolloverModifier__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_scichart_Charting_Visuals_PointMarkers_EllipsePointMarker__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_scichart_Charting_Visuals_PointMarkers_EllipsePointMarker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_scichart_Charting_Visuals_PointMarkers_EllipsePointMarker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_chartTheme__ = __webpack_require__(1556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_scichart_Charting_Drawing_WebGlRenderContext2D__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_scichart_Charting_Drawing_WebGlRenderContext2D___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_scichart_Charting_Drawing_WebGlRenderContext2D__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_scichart_Core_NumberRange__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_scichart_Core_NumberRange___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_scichart_Core_NumberRange__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_scichart_types_XyDirection__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_scichart_types_XyDirection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_scichart_types_XyDirection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_scichart_Charting_ChartModifiers_CursorModifier__ = __webpack_require__(956);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_scichart_Charting_ChartModifiers_CursorModifier___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_scichart_Charting_ChartModifiers_CursorModifier__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_moment__);


//
//
//
//
//
//
//
//



















/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_13__utils_chartTheme__["a" /* chartThemeMixin */]],
    props: ['data', 'labelX', 'labelY', 'sid', 'zoom', 'pan', 'showValues', 'mouseZoom', 'initialZoomOut'],
    data: function data() {
        return {
            sciChartSurface: null,
            wasmContext: null,
            xAxis: null,
            yAxis: null
        };
    },

    watch: {
        chartData: function chartData(newVal, oldVal) {
            this.redraw();
        }
    },
    computed: {
        chartData: function chartData() {
            return this.data;
        }
    },
    methods: {
        initSciChart: function initSciChart() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var xValues, yValues, _ref, sciChartSurface, wasmContext, xAxis, yAxis, d, lineSeries, i, rolloverModifier;

                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                xValues = _this.data.xValues;
                                yValues = _this.data.yValues;
                                _context.next = 4;
                                return __WEBPACK_IMPORTED_MODULE_2_scichart_Charting_Visuals_SciChartSurface__["SciChartSurface"].create("scichart-root-" + _this.sid);

                            case 4:
                                _ref = _context.sent;
                                sciChartSurface = _ref.sciChartSurface;
                                wasmContext = _ref.wasmContext;


                                _this.sciChartSurface = sciChartSurface;
                                _this.wasmContext = wasmContext;

                                _context.next = 11;
                                return sciChartSurface.applyTheme(_this.chartTheme());

                            case 11:
                                xAxis = new __WEBPACK_IMPORTED_MODULE_3_scichart_Charting_Visuals_Axis_NumericAxis__["NumericAxis"](_this.wasmContext, { axisAlignment: __WEBPACK_IMPORTED_MODULE_4_scichart_types_AxisAlignment__["EAxisAlignment"].Top });
                                yAxis = new __WEBPACK_IMPORTED_MODULE_3_scichart_Charting_Visuals_Axis_NumericAxis__["NumericAxis"](_this.wasmContext, { axisAlignment: __WEBPACK_IMPORTED_MODULE_4_scichart_types_AxisAlignment__["EAxisAlignment"].Left });

                                _this.xAxis = xAxis;
                                _this.yAxis = yAxis;

                                if (_this.initialZoomOut == true) {
                                    yAxis.growBy = new __WEBPACK_IMPORTED_MODULE_15_scichart_Core_NumberRange__["NumberRange"](0.1, 0.1);
                                    xAxis.growBy = new __WEBPACK_IMPORTED_MODULE_15_scichart_Core_NumberRange__["NumberRange"](0.1, 0.1);
                                }

                                sciChartSurface.xAxes.add(_this.xAxis);
                                sciChartSurface.yAxes.add(_this.yAxis);

                                xAxis.labelProvider.formatLabel = function (unixTimestamp) {
                                    return __WEBPACK_IMPORTED_MODULE_18_moment___default()(unixTimestamp).format("YYYY-MM-DD, HH:mm:ss");
                                };

                                d = [];
                                lineSeries = new __WEBPACK_IMPORTED_MODULE_5_scichart_Charting_Visuals_RenderableSeries_FastLineRenderableSeries__["FastLineRenderableSeries"](_this.wasmContext, {
                                    stroke: "#0095B2",
                                    drawNaNAs: __WEBPACK_IMPORTED_MODULE_14_scichart_Charting_Drawing_WebGlRenderContext2D__["ELineDrawMode"].DiscontinuousLine,
                                    strokeThickness: 2,
                                    pointMarker: new __WEBPACK_IMPORTED_MODULE_12_scichart_Charting_Visuals_PointMarkers_EllipsePointMarker__["EllipsePointMarker"](wasmContext, {
                                        width: 6,
                                        height: 6,
                                        strokeThickness: 2,
                                        fill: "#0095B230",
                                        stroke: "#0095B2"
                                    })
                                });


                                if (!(xValues == undefined || xValues == null || xValues.length == 0)) {
                                    for (i = 0; i < xValues.length; i++) {
                                        d[i] = new Date(__WEBPACK_IMPORTED_MODULE_18_moment___default()(xValues[i])).getTime();
                                    }

                                    lineSeries.dataSeries = new __WEBPACK_IMPORTED_MODULE_6_scichart_Charting_Model_XyDataSeries__["XyDataSeries"](_this.wasmContext, {
                                        xValues: d,
                                        yValues: yValues
                                    });

                                    lineSeries.strokeThickness = 3;
                                    lineSeries.rolloverModifierProps.tooltipLabelX = _this.labelX ? _this.labelX : "X";
                                    lineSeries.rolloverModifierProps.tooltipLabelY = _this.labelY ? _this.labelY : "Y";
                                } else {
                                    d = {};

                                    lineSeries.dataSeries = new __WEBPACK_IMPORTED_MODULE_6_scichart_Charting_Model_XyDataSeries__["XyDataSeries"](_this.wasmContext, {
                                        xValues: {},
                                        yValues: {}
                                    });
                                }

                                _this.sciChartSurface.renderableSeries.add(lineSeries);

                                if (_this.zoomBySelection == true) sciChartSurface.chartModifiers.add(new __WEBPACK_IMPORTED_MODULE_9_scichart_Charting_ChartModifiers_RubberBandXyZoomModifier__["RubberBandXyZoomModifier"]({ xyDirection: __WEBPACK_IMPORTED_MODULE_16_scichart_types_XyDirection__["EXyDirection"].XDirection }));
                                if (_this.pan != false) sciChartSurface.chartModifiers.add(new __WEBPACK_IMPORTED_MODULE_7_scichart_Charting_ChartModifiers_ZoomPanModifier__["ZoomPanModifier"]({ xyDirection: __WEBPACK_IMPORTED_MODULE_16_scichart_types_XyDirection__["EXyDirection"].XDirection }));
                                if (_this.zoom != false) sciChartSurface.chartModifiers.add(new __WEBPACK_IMPORTED_MODULE_10_scichart_Charting_ChartModifiers_ZoomExtentsModifier__["ZoomExtentsModifier"]({ xyDirection: __WEBPACK_IMPORTED_MODULE_16_scichart_types_XyDirection__["EXyDirection"].XDirection }));
                                if (_this.mouseZoom != false) sciChartSurface.chartModifiers.add(new __WEBPACK_IMPORTED_MODULE_8_scichart_Charting_ChartModifiers_MouseWheelZoomModifier__["MouseWheelZoomModifier"]({ xyDirection: __WEBPACK_IMPORTED_MODULE_16_scichart_types_XyDirection__["EXyDirection"].XDirection }));

                                rolloverModifier = new __WEBPACK_IMPORTED_MODULE_11_scichart_Charting_ChartModifiers_RolloverModifier__["RolloverModifier"]();

                                rolloverModifier.showRolloverLine = false;
                                _this.sciChartSurface.chartModifiers.add(rolloverModifier);

                                _this.sciChartSurface.chartModifiers.add(new __WEBPACK_IMPORTED_MODULE_17_scichart_Charting_ChartModifiers_CursorModifier__["CursorModifier"]({
                                    crosshairStroke: "#0095B2",
                                    crosshairStrokeThickness: 1,
                                    tooltipContainerBackground: "#000",
                                    tooltipTextStroke: "#0095B2",
                                    showTooltip: false,
                                    axisLabelFill: "#0095B2",
                                    axisLabelStroke: "#fff"
                                }));

                                _this.sciChartSurface.zoomExtents();

                            case 32:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        redraw: function redraw() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var dataSeries, _lineSeries, xValues, yValues, d, i, lineSeries;

                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (!(_this2.sciChartSurface == null)) {
                                    _context2.next = 2;
                                    break;
                                }

                                return _context2.abrupt("return");

                            case 2:

                                _this2.sciChartSurface.renderableSeries.items = [];

                                if (_this2.data.length == 0) {
                                    dataSeries = new __WEBPACK_IMPORTED_MODULE_6_scichart_Charting_Model_XyDataSeries__["XyDataSeries"](_this2.wasmContext, {
                                        xValues: {},
                                        yValues: {}
                                    });
                                    _lineSeries = new __WEBPACK_IMPORTED_MODULE_5_scichart_Charting_Visuals_RenderableSeries_FastLineRenderableSeries__["FastLineRenderableSeries"](_this2.wasmContext, {
                                        dataSeries: dataSeries
                                    });


                                    _this2.sciChartSurface.renderableSeries.add(_lineSeries);
                                }

                                xValues = _this2.data.xValues;
                                yValues = _this2.data.yValues;

                                // Create an X,Y Axis and add to the chart

                                _this2.xAxis = new __WEBPACK_IMPORTED_MODULE_3_scichart_Charting_Visuals_Axis_NumericAxis__["NumericAxis"](_this2.wasmContext, { axisAlignment: __WEBPACK_IMPORTED_MODULE_4_scichart_types_AxisAlignment__["EAxisAlignment"].Top });
                                _this2.yAxis = new __WEBPACK_IMPORTED_MODULE_3_scichart_Charting_Visuals_Axis_NumericAxis__["NumericAxis"](_this2.wasmContext, { axisAlignment: __WEBPACK_IMPORTED_MODULE_4_scichart_types_AxisAlignment__["EAxisAlignment"].Left });

                                _this2.xAxis.labelProvider.formatLabel = function (unixTimestamp) {
                                    return __WEBPACK_IMPORTED_MODULE_18_moment___default()(unixTimestamp).format("DD MMM, HH:mm");
                                };

                                d = [];

                                for (i = 0; i < xValues.length; i++) {
                                    d[i] = new Date(__WEBPACK_IMPORTED_MODULE_18_moment___default()(xValues[i])).getTime();
                                }

                                lineSeries = new __WEBPACK_IMPORTED_MODULE_5_scichart_Charting_Visuals_RenderableSeries_FastLineRenderableSeries__["FastLineRenderableSeries"](_this2.wasmContext, {
                                    stroke: "#0095B2",
                                    drawNaNAs: __WEBPACK_IMPORTED_MODULE_14_scichart_Charting_Drawing_WebGlRenderContext2D__["ELineDrawMode"].DiscontinuousLine,
                                    strokeThickness: 2,
                                    pointMarker: new __WEBPACK_IMPORTED_MODULE_12_scichart_Charting_Visuals_PointMarkers_EllipsePointMarker__["EllipsePointMarker"](_this2.wasmContext, {
                                        width: 6,
                                        height: 6,
                                        strokeThickness: 2,
                                        fill: "#0095B230",
                                        stroke: "#0095B2"
                                    })
                                });

                                // Declare a DataSeries

                                lineSeries.dataSeries = new __WEBPACK_IMPORTED_MODULE_6_scichart_Charting_Model_XyDataSeries__["XyDataSeries"](_this2.wasmContext, {
                                    xValues: d,
                                    yValues: yValues
                                });

                                lineSeries.strokeThickness = 3;
                                lineSeries.rolloverModifierProps.tooltipLabelX = _this2.labelX ? _this2.labelX : "X";
                                lineSeries.rolloverModifierProps.tooltipLabelY = _this2.labelY ? _this2.labelY : "Y";
                                _this2.sciChartSurface.renderableSeries.add(lineSeries);

                                _this2.sciChartSurface.zoomExtents();

                            case 18:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        },
        applyStyles: function applyStyles() {
            this.sciChartSurface.applyTheme({
                annotationsGripsBackroundBrush: "white",
                annotationsGripsBorderBrush: "white",
                axis3DBandsFill: "#1F3D6833",
                axisBandsFill: "#1F3D6833",
                axisPlaneBackgroundFill: "Transparent",
                columnFillBrush: "white",
                columnLineColor: "white",
                cursorLineBrush: "#6495ED99",
                defaultColorMapBrush: [{ offset: 0, color: "DarkBlue" }, { offset: 0.5, color: "CornflowerBlue" }, { offset: 1, color: "#FF22AA" }],
                downBandSeriesFillColor: "#52CC5490",
                downBandSeriesLineColor: "#E26565FF",
                downBodyBrush: "white",
                downWickColor: "white",
                gridBackgroundBrush: "white",
                gridBorderBrush: "white",
                labelBackgroundBrush: "#6495EDAA",
                labelBorderBrush: "#6495ED",
                labelForegroundBrush: "#EEEEEE",
                legendBackgroundBrush: "#1D2C35",
                lineSeriesColor: "#0095B2",
                majorGridLineBrush: "#1F3D68",
                minorGridLineBrush: "#102A47",
                mountainAreaBrush: "white",
                mountainLineColor: "white",
                overviewFillBrush: "white",
                planeBorderColor: "white",
                rolloverLineBrush: "#FD9F2533",
                rubberBandFillBrush: "#99999933",
                rubberBandStrokeBrush: "#99999977",
                sciChartBackground: "#0D213A",
                scrollbarBackgroundBrush: "white",
                scrollbarBorderBrush: "white",
                scrollbarGripsBackgroundBrush: "white",
                scrollbarViewportBackgroundBrush: "white",
                scrollbarViewportBorderBrush: "white",
                shadowEffectColor: "white",
                textAnnotationBackground: "#6495EDAA",
                textAnnotationForeground: "#EEEEEE",
                tickTextBrush: "#6495ED",
                upBandSeriesFillColor: "white",
                upBandSeriesLineColor: "white",
                upBodyBrush: "#6495EDA0",
                upWickColor: "#6495ED"
            });
        }
    },
    mounted: function () {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            this.initSciChart();

                        case 1:
                        case "end":
                            return _context3.stop();
                    }
                }
            }, _callee3, this);
        }));

        function mounted() {
            return _ref2.apply(this, arguments);
        }

        return mounted;
    }(),
    beforeDestroy: function () {
        var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            if (this.sciChartSurface || this.wasmContext) {
                                this.sciChartSurface = null;
                                this.wasmContext = null;
                            }
                            this.sciChartSurface = null;
                            this.wasmContext = null;

                        case 3:
                        case "end":
                            return _context4.stop();
                    }
                }
            }, _callee4, this);
        }));

        function beforeDestroy() {
            return _ref3.apply(this, arguments);
        }

        return beforeDestroy;
    }()
});

/***/ }),

/***/ 1597:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_scichart_Charting_Visuals_SciChartSurface__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_scichart_Charting_Visuals_SciChartSurface___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_scichart_Charting_Visuals_SciChartSurface__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_scichart_Charting_Visuals_Axis_NumericAxis__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_scichart_Charting_Visuals_Axis_NumericAxis___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_scichart_Charting_Visuals_Axis_NumericAxis__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_scichart_types_AxisAlignment__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_scichart_types_AxisAlignment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_scichart_types_AxisAlignment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_scichart_Charting_Visuals_RenderableSeries_FastLineRenderableSeries__ = __webpack_require__(955);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_scichart_Charting_Visuals_RenderableSeries_FastLineRenderableSeries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_scichart_Charting_Visuals_RenderableSeries_FastLineRenderableSeries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_scichart_Charting_Model_XyDataSeries__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_scichart_Charting_Model_XyDataSeries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_scichart_Charting_Model_XyDataSeries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_scichart_Charting_ChartModifiers_ZoomPanModifier__ = __webpack_require__(959);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_scichart_Charting_ChartModifiers_ZoomPanModifier___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_scichart_Charting_ChartModifiers_ZoomPanModifier__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_scichart_Charting_ChartModifiers_MouseWheelZoomModifier__ = __webpack_require__(957);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_scichart_Charting_ChartModifiers_MouseWheelZoomModifier___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_scichart_Charting_ChartModifiers_MouseWheelZoomModifier__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_scichart_Charting_ChartModifiers_RubberBandXyZoomModifier__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_scichart_Charting_ChartModifiers_RubberBandXyZoomModifier___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_scichart_Charting_ChartModifiers_RubberBandXyZoomModifier__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_scichart_Charting_ChartModifiers_ZoomExtentsModifier__ = __webpack_require__(958);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_scichart_Charting_ChartModifiers_ZoomExtentsModifier___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_scichart_Charting_ChartModifiers_ZoomExtentsModifier__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_chartTheme__ = __webpack_require__(1556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_scichart_Core_NumberRange__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_scichart_Core_NumberRange___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_scichart_Core_NumberRange__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_scichart_Charting_ChartModifiers_RolloverModifier__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_scichart_Charting_ChartModifiers_RolloverModifier___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_scichart_Charting_ChartModifiers_RolloverModifier__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_scichart_Charting_ChartModifiers_CursorModifier__ = __webpack_require__(956);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_scichart_Charting_ChartModifiers_CursorModifier___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_scichart_Charting_ChartModifiers_CursorModifier__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_scichart_Charting_Visuals_PointMarkers_EllipsePointMarker__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_scichart_Charting_Visuals_PointMarkers_EllipsePointMarker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_scichart_Charting_Visuals_PointMarkers_EllipsePointMarker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_scichart_types_XyDirection__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_scichart_types_XyDirection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_scichart_types_XyDirection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_scichart_Charting_Drawing_WebGlRenderContext2D__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_scichart_Charting_Drawing_WebGlRenderContext2D___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_scichart_Charting_Drawing_WebGlRenderContext2D__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__syncfusion_ej2_vue_grids__ = __webpack_require__(953);


//
//
//
//
//
//
//
//
//
//
//
//
//
//





















/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_11__utils_chartTheme__["a" /* chartThemeMixin */]],
    props: ['data', 'labelX', 'labelY', 'zoom', 'pan', 'showValues', 'mouseZoom', 'sid', 'initialZoomOut'],
    provide: {
        grid: [__WEBPACK_IMPORTED_MODULE_19__syncfusion_ej2_vue_grids__["l" /* Sort */], __WEBPACK_IMPORTED_MODULE_19__syncfusion_ej2_vue_grids__["i" /* Page */], __WEBPACK_IMPORTED_MODULE_19__syncfusion_ej2_vue_grids__["g" /* Filter */], __WEBPACK_IMPORTED_MODULE_19__syncfusion_ej2_vue_grids__["m" /* Toolbar */], __WEBPACK_IMPORTED_MODULE_19__syncfusion_ej2_vue_grids__["k" /* Search */], __WEBPACK_IMPORTED_MODULE_19__syncfusion_ej2_vue_grids__["b" /* CommandColumn */]]
    },
    data: function data() {
        return {
            sciChartSurface: null,
            wasmContext: null,
            selection: [],
            wrapSettings: { wrapMode: 'Content' },
            selectionOptions: { type: 'Multiple' },
            filterOptions: {
                type: 'Menu'
            },
            customAttributes: { class: 'customcss' }
        };
    },

    methods: {
        selectionChanged: function selectionChanged() {
            this.selection = this.$refs['grid-' + this.sid].getSelectedRecords();

            if (this.data.length == 0) this.selection = [];

            if (this.sciChartSurface != null) this.redrawScichart();
        },
        redrawScichart: function redrawScichart() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var dataSeries, lineSeries;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this.sciChartSurface.renderableSeries.items = [];

                                if (_this.selection.length == 0) {
                                    dataSeries = new __WEBPACK_IMPORTED_MODULE_6_scichart_Charting_Model_XyDataSeries__["XyDataSeries"](_this.wasmContext, {
                                        xValues: {},
                                        yValues: {}
                                    });
                                    lineSeries = new __WEBPACK_IMPORTED_MODULE_5_scichart_Charting_Visuals_RenderableSeries_FastLineRenderableSeries__["FastLineRenderableSeries"](_this.wasmContext, {
                                        dataSeries: dataSeries
                                    });


                                    _this.sciChartSurface.renderableSeries.add(lineSeries);
                                }

                                _this.selection.forEach(function (e, index) {

                                    var d = [];
                                    e.yValues.forEach(function (dt, i) {
                                        d.push(new Date(__WEBPACK_IMPORTED_MODULE_18_moment___default()(dt, "DD.MM.YYYY HH.mm.ss")).getTime());
                                    });

                                    var v = [];
                                    e.xValues.forEach(function (dt) {
                                        v.push(dt);
                                    });

                                    var dataSeries = new __WEBPACK_IMPORTED_MODULE_6_scichart_Charting_Model_XyDataSeries__["XyDataSeries"](_this.wasmContext, {
                                        xValues: d,
                                        yValues: v
                                    });

                                    dataSeries.dataSeriesName = e.title;

                                    var lineSeries = new __WEBPACK_IMPORTED_MODULE_5_scichart_Charting_Visuals_RenderableSeries_FastLineRenderableSeries__["FastLineRenderableSeries"](_this.wasmContext, {
                                        dataSeries: dataSeries,
                                        stroke: e.strokeColor,
                                        pointMarker: new __WEBPACK_IMPORTED_MODULE_15_scichart_Charting_Visuals_PointMarkers_EllipsePointMarker__["EllipsePointMarker"](_this.wasmContext, {
                                            width: 3,
                                            height: 3,
                                            strokeThickness: 1,
                                            fill: e.strokeColor + "30",
                                            stroke: e.strokeColor
                                        })
                                    });

                                    lineSeries.stroke = e.strokeColor;
                                    lineSeries.rolloverModifierProps.tooltipTitle = e.title;
                                    lineSeries.rolloverModifierProps.tooltipTextColor = '#fff';
                                    lineSeries.rolloverModifierProps.tooltipColor = e.strokeColor;
                                    lineSeries.rolloverModifierProps.tooltipLabelX = _this.labelX ? _this.labelX : "X";
                                    // lineSeries.rolloverModifierProps.tooltipLabelY = this.labelY ? this.labelY : "Y";
                                    _this.sciChartSurface.renderableSeries.add(lineSeries);
                                });

                                if (_this.selection.length != 0) {
                                    _this.sciChartSurface.zoomExtents();
                                }

                            case 4:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        initSciChart: function initSciChart() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var _ref, sciChartSurface, wasmContext, xAxis, yAxis, rolloverModifier;

                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return __WEBPACK_IMPORTED_MODULE_2_scichart_Charting_Visuals_SciChartSurface__["SciChartSurface"].create("scichart-root-" + _this2.sid);

                            case 2:
                                _ref = _context2.sent;
                                sciChartSurface = _ref.sciChartSurface;
                                wasmContext = _ref.wasmContext;


                                _this2.sciChartSurface = sciChartSurface;
                                _this2.wasmContext = wasmContext;

                                _context2.next = 9;
                                return sciChartSurface.applyTheme(_this2.chartTheme());

                            case 9:
                                xAxis = new __WEBPACK_IMPORTED_MODULE_3_scichart_Charting_Visuals_Axis_NumericAxis__["NumericAxis"](_this2.wasmContext, { axisAlignment: __WEBPACK_IMPORTED_MODULE_4_scichart_types_AxisAlignment__["EAxisAlignment"].Top });
                                yAxis = new __WEBPACK_IMPORTED_MODULE_3_scichart_Charting_Visuals_Axis_NumericAxis__["NumericAxis"](_this2.wasmContext, { axisAlignment: __WEBPACK_IMPORTED_MODULE_4_scichart_types_AxisAlignment__["EAxisAlignment"].Left });


                                if (_this2.initialZoomOut == true) {
                                    yAxis.growBy = new __WEBPACK_IMPORTED_MODULE_12_scichart_Core_NumberRange__["NumberRange"](0.1, 0.1);
                                    xAxis.growBy = new __WEBPACK_IMPORTED_MODULE_12_scichart_Core_NumberRange__["NumberRange"](0.1, 0.1);
                                }

                                _this2.sciChartSurface.xAxes.add(xAxis);
                                _this2.sciChartSurface.yAxes.add(yAxis);

                                xAxis.labelProvider.formatLabel = function (unixTimestamp) {
                                    return __WEBPACK_IMPORTED_MODULE_18_moment___default()(unixTimestamp).format("DD.MM, HH:mm:ss");
                                };

                                _this2.data.forEach(function (e, index) {

                                    var d = [];
                                    e.yValues.forEach(function (dt, i) {
                                        d.push(new Date(__WEBPACK_IMPORTED_MODULE_18_moment___default()(dt, "DD.MM.YYYY HH.mm.ss")).getTime());
                                    });

                                    var v = [];
                                    e.xValues.forEach(function (dt) {
                                        v.push(dt);
                                    });

                                    var dataSeries = new __WEBPACK_IMPORTED_MODULE_6_scichart_Charting_Model_XyDataSeries__["XyDataSeries"](_this2.wasmContext, {
                                        xValues: d,
                                        yValues: v
                                    });

                                    dataSeries.dataSeriesName = e.title;

                                    var lineSeries = new __WEBPACK_IMPORTED_MODULE_5_scichart_Charting_Visuals_RenderableSeries_FastLineRenderableSeries__["FastLineRenderableSeries"](_this2.wasmContext, {
                                        dataSeries: dataSeries,
                                        drawNaNAs: __WEBPACK_IMPORTED_MODULE_17_scichart_Charting_Drawing_WebGlRenderContext2D__["ELineDrawMode"].DiscontinuousLine,
                                        stroke: e.strokeColor,
                                        strokeThickness: 3,
                                        pointMarker: new __WEBPACK_IMPORTED_MODULE_15_scichart_Charting_Visuals_PointMarkers_EllipsePointMarker__["EllipsePointMarker"](_this2.wasmContext, {
                                            width: 4,
                                            height: 4,
                                            strokeThickness: 1,
                                            fill: e.strokeColor + "30",
                                            stroke: e.strokeColor
                                        })
                                    });

                                    lineSeries.stroke = e.strokeColor;
                                    lineSeries.rolloverModifierProps.tooltipTitle = e.title;
                                    lineSeries.rolloverModifierProps.tooltipTextColor = '#fff';
                                    lineSeries.rolloverModifierProps.tooltipColor = e.strokeColor;
                                    lineSeries.rolloverModifierProps.tooltipLabelX = _this2.labelX ? _this2.labelX : "X";
                                    // lineSeries.rolloverModifierProps.tooltipLabelY = this.labelY ? this.labelY : "Y";
                                    _this2.sciChartSurface.renderableSeries.add(lineSeries);
                                });

                                if (_this2.zoomBySelection == true) _this2.sciChartSurface.chartModifiers.add(new __WEBPACK_IMPORTED_MODULE_9_scichart_Charting_ChartModifiers_RubberBandXyZoomModifier__["RubberBandXyZoomModifier"]({ xyDirection: __WEBPACK_IMPORTED_MODULE_16_scichart_types_XyDirection__["EXyDirection"].XDirection }));
                                if (_this2.pan != false) _this2.sciChartSurface.chartModifiers.add(new __WEBPACK_IMPORTED_MODULE_7_scichart_Charting_ChartModifiers_ZoomPanModifier__["ZoomPanModifier"]({ xyDirection: __WEBPACK_IMPORTED_MODULE_16_scichart_types_XyDirection__["EXyDirection"].XDirection }));
                                if (_this2.zoom != false) _this2.sciChartSurface.chartModifiers.add(new __WEBPACK_IMPORTED_MODULE_10_scichart_Charting_ChartModifiers_ZoomExtentsModifier__["ZoomExtentsModifier"]({ xyDirection: __WEBPACK_IMPORTED_MODULE_16_scichart_types_XyDirection__["EXyDirection"].XDirection }));
                                if (_this2.mouseZoom != false) _this2.sciChartSurface.chartModifiers.add(new __WEBPACK_IMPORTED_MODULE_8_scichart_Charting_ChartModifiers_MouseWheelZoomModifier__["MouseWheelZoomModifier"]({ xyDirection: __WEBPACK_IMPORTED_MODULE_16_scichart_types_XyDirection__["EXyDirection"].XDirection }));
                                rolloverModifier = new __WEBPACK_IMPORTED_MODULE_13_scichart_Charting_ChartModifiers_RolloverModifier__["RolloverModifier"]();

                                rolloverModifier.showRolloverLine = false;
                                _this2.sciChartSurface.chartModifiers.add(rolloverModifier);

                                _this2.sciChartSurface.chartModifiers.add(new __WEBPACK_IMPORTED_MODULE_14_scichart_Charting_ChartModifiers_CursorModifier__["CursorModifier"]({
                                    crosshairStroke: "#0095B2",
                                    crosshairStrokeThickness: 1,
                                    tooltipContainerBackground: "#000",
                                    tooltipTextStroke: "#0095B2",
                                    showTooltip: false,
                                    axisLabelFill: "#0095B2",
                                    axisLabelStroke: "#fff"
                                }));

                                _this2.sciChartSurface.zoomExtents();

                            case 25:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        },
        applyStyles: function applyStyles() {
            this.sciChartSurface.applyTheme({
                annotationsGripsBackroundBrush: "white",
                annotationsGripsBorderBrush: "white",
                axis3DBandsFill: "#1F3D6833",
                axisBandsFill: "#1F3D6833",
                axisPlaneBackgroundFill: "Transparent",
                columnFillBrush: "white",
                columnLineColor: "white",
                cursorLineBrush: "#6495ED99",
                defaultColorMapBrush: [{ offset: 0, color: "DarkBlue" }, { offset: 0.5, color: "CornflowerBlue" }, { offset: 1, color: "#FF22AA" }],
                downBandSeriesFillColor: "#6495ED99", // "#52CC5490",
                downBandSeriesLineColor: "#E26565FF",
                downBodyBrush: "white",
                downWickColor: "white",
                gridBackgroundBrush: "white",
                gridBorderBrush: "white",
                labelBackgroundBrush: "#6495EDAA",
                labelBorderBrush: "#6495ED",
                labelForegroundBrush: "#EEEEEE",
                legendBackgroundBrush: "#1D2C35",
                lineSeriesColor: "#0095B2",
                majorGridLineBrush: "#1F3D68",
                minorGridLineBrush: "#102A47",
                mountainAreaBrush: "white",
                mountainLineColor: "white",
                overviewFillBrush: "white",
                planeBorderColor: "white",
                rolloverLineBrush: "#FD9F2533",
                rubberBandFillBrush: "#99999933",
                rubberBandStrokeBrush: "#99999977",
                sciChartBackground: "#0D213A",
                scrollbarBackgroundBrush: "white",
                scrollbarBorderBrush: "white",
                scrollbarGripsBackgroundBrush: "white",
                scrollbarViewportBackgroundBrush: "white",
                scrollbarViewportBorderBrush: "white",
                shadowEffectColor: "white",
                textAnnotationBackground: "#6495EDAA",
                textAnnotationForeground: "#EEEEEE",
                tickTextBrush: "#6495ED",
                upBandSeriesFillColor: "white",
                upBandSeriesLineColor: "white",
                upBodyBrush: "#6495EDA0",
                upWickColor: "#6495ED"
            });
        },

        dataBound: function dataBound() {
            this.$refs['grid-' + this.sid].autoFitColumns();
            var rowIndexes = [];
            this.data.forEach(function (e, i) {
                rowIndexes.push(i);
            });
            this.$refs['grid-' + this.sid].selectRows(rowIndexes);
        },
        rowDataBound: function rowDataBound(args) {
            args.row.classList.add('whiteText');
            args.row.style.backgroundColor = args.data['strokeColor'];
        }
    },
    mounted: function () {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            this.initSciChart();

                        case 1:
                        case "end":
                            return _context3.stop();
                    }
                }
            }, _callee3, this);
        }));

        function mounted() {
            return _ref2.apply(this, arguments);
        }

        return mounted;
    }(),
    beforeDestroy: function () {
        var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            if (this.sciChartSurface || this.wasmContext) {
                                this.sciChartSurface = null;
                                this.wasmContext = null;
                            }
                            this.sciChartSurface = null;
                            this.wasmContext = null;

                        case 3:
                        case "end":
                            return _context4.stop();
                    }
                }
            }, _callee4, this);
        }));

        function beforeDestroy() {
            return _ref3.apply(this, arguments);
        }

        return beforeDestroy;
    }(),
    updated: function () {
        var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            if (this.data.length == 0) {
                                this.selectionChanged();
                            }

                        case 1:
                        case "end":
                            return _context5.stop();
                    }
                }
            }, _callee5, this);
        }));

        function updated() {
            return _ref4.apply(this, arguments);
        }

        return updated;
    }()
});

/***/ }),

/***/ 1598:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(1548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_scichart_Charting_Visuals_SciChartSurface__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_scichart_Charting_Visuals_SciChartSurface___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_scichart_Charting_Visuals_SciChartSurface__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_scichart_Charting_Visuals_Axis_NumericAxis__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_scichart_Charting_Visuals_Axis_NumericAxis___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_scichart_Charting_Visuals_Axis_NumericAxis__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_scichart_Charting_Visuals_Axis_CategoryAxis__ = __webpack_require__(970);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_scichart_Charting_Visuals_Axis_CategoryAxis___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_scichart_Charting_Visuals_Axis_CategoryAxis__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_scichart_types_AxisAlignment__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_scichart_types_AxisAlignment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_scichart_types_AxisAlignment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_scichart_Charting_Visuals_RenderableSeries_FastLineRenderableSeries__ = __webpack_require__(955);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_scichart_Charting_Visuals_RenderableSeries_FastLineRenderableSeries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_scichart_Charting_Visuals_RenderableSeries_FastLineRenderableSeries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_scichart_Charting_Model_XyDataSeries__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_scichart_Charting_Model_XyDataSeries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_scichart_Charting_Model_XyDataSeries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_scichart_Charting_ChartModifiers_ZoomPanModifier__ = __webpack_require__(959);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_scichart_Charting_ChartModifiers_ZoomPanModifier___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_scichart_Charting_ChartModifiers_ZoomPanModifier__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_scichart_Charting_ChartModifiers_MouseWheelZoomModifier__ = __webpack_require__(957);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_scichart_Charting_ChartModifiers_MouseWheelZoomModifier___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_scichart_Charting_ChartModifiers_MouseWheelZoomModifier__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_scichart_Charting_ChartModifiers_RubberBandXyZoomModifier__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_scichart_Charting_ChartModifiers_RubberBandXyZoomModifier___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_scichart_Charting_ChartModifiers_RubberBandXyZoomModifier__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_scichart_Charting_ChartModifiers_ZoomExtentsModifier__ = __webpack_require__(958);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_scichart_Charting_ChartModifiers_ZoomExtentsModifier___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_scichart_Charting_ChartModifiers_ZoomExtentsModifier__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_chartTheme__ = __webpack_require__(1556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_scichart_Core_NumberRange__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_scichart_Core_NumberRange___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_scichart_Core_NumberRange__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_scichart_Charting_ChartModifiers_RolloverModifier__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_scichart_Charting_ChartModifiers_RolloverModifier___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_scichart_Charting_ChartModifiers_RolloverModifier__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_scichart_Charting_ChartModifiers_CursorModifier__ = __webpack_require__(956);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_scichart_Charting_ChartModifiers_CursorModifier___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_scichart_Charting_ChartModifiers_CursorModifier__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_scichart_Charting_Visuals_PointMarkers_EllipsePointMarker__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_scichart_Charting_Visuals_PointMarkers_EllipsePointMarker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_scichart_Charting_Visuals_PointMarkers_EllipsePointMarker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_scichart_types_XyDirection__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_scichart_types_XyDirection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_scichart_types_XyDirection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_scichart_Charting_Drawing_WebGlRenderContext2D__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_scichart_Charting_Drawing_WebGlRenderContext2D___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_scichart_Charting_Drawing_WebGlRenderContext2D__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_scichart_types_AutoRange__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_scichart_types_AutoRange___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_scichart_types_AutoRange__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_scichart_Charting_Visuals_Annotations_VerticalLineAnnotation__ = __webpack_require__(964);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_scichart_Charting_Visuals_Annotations_VerticalLineAnnotation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_scichart_Charting_Visuals_Annotations_VerticalLineAnnotation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_scichart_types_LabelPlacement__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_scichart_types_LabelPlacement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_scichart_types_LabelPlacement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__syncfusion_ej2_vue_grids__ = __webpack_require__(953);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__Datepicker_vue__ = __webpack_require__(1583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_scichart_Charting_Visuals_Axis_LabelProvider_LabelProvider__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_scichart_Charting_Visuals_Axis_LabelProvider_LabelProvider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_scichart_Charting_Visuals_Axis_LabelProvider_LabelProvider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__Filters_AlarmTypesSelect__ = __webpack_require__(1621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_vue_toggles__ = __webpack_require__(1605);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






























/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_14__utils_chartTheme__["a" /* chartThemeMixin */]],
    components: { Datepicker: __WEBPACK_IMPORTED_MODULE_26__Datepicker_vue__["a" /* default */], VueToggles: __WEBPACK_IMPORTED_MODULE_29_vue_toggles__["a" /* default */], AlarmTypesSelect: __WEBPACK_IMPORTED_MODULE_28__Filters_AlarmTypesSelect__["a" /* default */] },
    props: ['dataset', 'devices', 'systemId', 'allAlarmTypes', 'priority', 'day', 'activeSet', 'labelX', 'labelY', 'zoom', 'pan', 'showValues', 'mouseZoom', 'sid', 'initialZoomOut'],
    provide: {
        grid: [__WEBPACK_IMPORTED_MODULE_25__syncfusion_ej2_vue_grids__["l" /* Sort */], __WEBPACK_IMPORTED_MODULE_25__syncfusion_ej2_vue_grids__["i" /* Page */], __WEBPACK_IMPORTED_MODULE_25__syncfusion_ej2_vue_grids__["g" /* Filter */], __WEBPACK_IMPORTED_MODULE_25__syncfusion_ej2_vue_grids__["m" /* Toolbar */], __WEBPACK_IMPORTED_MODULE_25__syncfusion_ej2_vue_grids__["k" /* Search */], __WEBPACK_IMPORTED_MODULE_25__syncfusion_ej2_vue_grids__["b" /* CommandColumn */]]
    },
    data: function data() {
        var dateDay = new Date();
        dateDay.setDate(dateDay.getDate() - this.day);
        dateDay = new Date(dateDay.getFullYear(), dateDay.getMonth(), dateDay.getDate(), 0, 0, 0);

        return {
            sciChartSurface: null,
            wasmContext: null,
            init: false,
            changingType: false,
            allAlarmTypesOption: false,

            dateFrom: dateDay,
            dateTo: new Date(dateDay.getFullYear(), dateDay.getMonth(), dateDay.getDate(), 23, 59, 59),
            selectedAlarmType: "",
            data: [],
            availableAlarmTypes: []
        };
    },

    computed: {
        activeTab: function activeTab() {
            return this.activeSet;
        }
    },
    watch: {
        dataset: function dataset(newVal, oldVal) {
            if (newVal != 0) {
                this.checkAvailableAlarmTypes();
                this.changeDataSet(this.activeSet, false);
            }
        },
        activeTab: function activeTab(newVal, oldVal) {
            if (newVal != 0) {
                this.checkAvailableAlarmTypes();
                this.changeDataSet(newVal, false);
            }
        },
        selectedAlarmType: function selectedAlarmType(newVal, oldVal) {
            if (!this.changingType) {
                this.changeDataSet(this.activeSet, false);
            }
        },
        allAlarmTypesOption: function allAlarmTypesOption(newVal, oldVal) {
            if (newVal == false) {
                this.checkAvailableAlarmTypes();
                this.changeDataSet(this.activeSet, false);
            }
            this.refreshChartSize();
        }
    },
    methods: {
        changeAlarmType: function changeAlarmType(aT) {
            this.selectedAlarmType = aT.description;
            this.refreshChartSize();
        },
        refreshChartSize: function refreshChartSize() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this.sleep(100);

                            case 2:
                                document.getElementById('scichart-root-' + _this.sid).style.height = _this.$refs.multipleFilters.offsetHeight != null ? 'calc(85vh - ' + _this.$refs.multipleFilters.offsetHeight + 'px)' : '85vh';

                            case 3:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        sleep: function sleep(ms) {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                return _context2.abrupt("return", new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
                                    setTimeout(resolve, ms);
                                }));

                            case 1:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        },
        initSciChart: function initSciChart() {
            var _this3 = this;

            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
                var _ref, sciChartSurface, wasmContext, xAxis, yAxis, lastRange;

                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return __WEBPACK_IMPORTED_MODULE_4_scichart_Charting_Visuals_SciChartSurface__["SciChartSurface"].create("scichart-root-" + _this3.sid);

                            case 2:
                                _ref = _context3.sent;
                                sciChartSurface = _ref.sciChartSurface;
                                wasmContext = _ref.wasmContext;


                                _this3.sciChartSurface = sciChartSurface;
                                _this3.wasmContext = wasmContext;

                                sciChartSurface.applyTheme(_this3.chartTheme());

                                xAxis = new __WEBPACK_IMPORTED_MODULE_5_scichart_Charting_Visuals_Axis_NumericAxis__["NumericAxis"](_this3.wasmContext, {
                                    axisAlignment: __WEBPACK_IMPORTED_MODULE_7_scichart_types_AxisAlignment__["EAxisAlignment"].Top,
                                    drawMajorBands: true,
                                    majorGridLineStyle: {
                                        color: "#9D9D9D"
                                    }
                                });
                                yAxis = new __WEBPACK_IMPORTED_MODULE_5_scichart_Charting_Visuals_Axis_NumericAxis__["NumericAxis"](_this3.wasmContext, { axisAlignment: __WEBPACK_IMPORTED_MODULE_7_scichart_types_AxisAlignment__["EAxisAlignment"].Left });

                                yAxis.labelProvider.formatLabel = function (dataValue) {
                                    return parseInt(dataValue);
                                };
                                yAxis.maxAutoTicks = _this3.devices * 2;
                                yAxis.minorsPerMajor = 2;
                                yAxis.visibleRange = new __WEBPACK_IMPORTED_MODULE_15_scichart_Core_NumberRange__["NumberRange"](1, _this3.devices);

                                if (_this3.initialZoomOut == true) {
                                    yAxis.growBy = new __WEBPACK_IMPORTED_MODULE_15_scichart_Core_NumberRange__["NumberRange"](0.02, 0.02);
                                    xAxis.growBy = new __WEBPACK_IMPORTED_MODULE_15_scichart_Core_NumberRange__["NumberRange"](0.02, 0.02);
                                }

                                _this3.sciChartSurface.xAxes.add(xAxis);
                                _this3.sciChartSurface.yAxes.add(yAxis);

                                xAxis.labelProvider.formatLabel = function (dt) {
                                    return __WEBPACK_IMPORTED_MODULE_24_moment___default()(dt).format("DD.MM, HH:mm:ss");
                                };

                                sciChartSurface.annotations.add(new __WEBPACK_IMPORTED_MODULE_22_scichart_Charting_Visuals_Annotations_VerticalLineAnnotation__["VerticalLineAnnotation"]({
                                    labelPlacement: __WEBPACK_IMPORTED_MODULE_23_scichart_types_LabelPlacement__["ELabelPlacement"].Axis,
                                    showLabel: true,
                                    stroke: "Red",
                                    strokeThickness: 2,
                                    x1: Date.now(),
                                    axisLabelFill: "Red",
                                    labelValue: _this3.$t("Now")
                                }));

                                _context3.next = 21;
                                return _this3.populateSciChart(true);

                            case 21:

                                xAxis.autoTicks = false, xAxis.majorDelta = 3600000;
                                xAxis.minorDelta = 720000;
                                lastRange = 3;


                                xAxis.visibleRangeChanged.subscribe(function (args) {
                                    var rangeDiff = args.visibleRange.max - args.visibleRange.min;

                                    if (rangeDiff / 3600000 <= 1 && lastRange != 0) {
                                        xAxis.majorDelta = 60000;
                                        xAxis.minorDelta = 12000;
                                        lastRange = 0;
                                    } else if (rangeDiff / 3600000 <= 2 && rangeDiff / 3600000 >= 1 && lastRange != 1) {
                                        xAxis.majorDelta = 600000;
                                        xAxis.minorDelta = 120000;
                                        lastRange = 1;
                                    } else if (rangeDiff / 3600000 > 2 && rangeDiff / 3600000 <= 6 && lastRange != 2) {
                                        xAxis.majorDelta = 1800000;
                                        xAxis.minorDelta = 360000;
                                        lastRange = 2;
                                    } else if (rangeDiff / 3600000 > 6 && lastRange != 3) {
                                        xAxis.majorDelta = 3600000;
                                        xAxis.minorDelta = 720000;
                                        lastRange = 3;
                                    }
                                });

                            case 25:
                            case "end":
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this3);
            }))();
        },
        reloadSciChart: function reloadSciChart() {
            var _this4 = this;

            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4() {
                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                if (!(_this4.sciChartSurface != null)) {
                                    _context4.next = 4;
                                    break;
                                }

                                if (_this4.sciChartSurface.renderableSeries != null) {
                                    _this4.sciChartSurface.renderableSeries.items = [];
                                }

                                _context4.next = 4;
                                return _this4.populateSciChart(false);

                            case 4:
                            case "end":
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this4);
            }))();
        },
        populateSciChart: function populateSciChart(init) {
            var _this5 = this;

            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee5() {
                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _this5.data.forEach(function (e, i) {
                                    var d = [];
                                    var d2 = [];
                                    var v = [];
                                    var v2 = [];
                                    var value = e.xValues.filter(function (x) {
                                        return !isNaN(x);
                                    })[0];

                                    if (value == undefined) {
                                        value = parseInt(e.title);
                                    }

                                    //DF-1
                                    var c1 = new Date(_this5.dateFrom);
                                    c1.setSeconds(c1.getSeconds() - 1);
                                    d2.push(c1);
                                    if (e.xValues.length != 2) {
                                        d2.push(_this5.dateFrom);
                                    }
                                    //DTs
                                    e.yValues.forEach(function (dt, j) {
                                        d.push(new Date(__WEBPACK_IMPORTED_MODULE_24_moment___default()(dt, "DD.MM.YYYY HH.mm.ss")));
                                        d2.push(new Date(__WEBPACK_IMPORTED_MODULE_24_moment___default()(dt, "DD.MM.YYYY HH.mm.ss")));
                                    });
                                    //DT+1
                                    if (e.xValues.length != 2) {
                                        d2.push(_this5.dateTo);
                                    }
                                    var e1 = new Date(_this5.dateTo);
                                    e1.setSeconds(e1.getSeconds() + 1);
                                    d2.push(e1);

                                    v2.push(NaN);
                                    v2.push(value);
                                    if (e.xValues.length != 2) {
                                        e.xValues.forEach(function (val, j) {
                                            v.push(val);
                                            v2.push(!isNaN(val) ? NaN : value);
                                        });
                                    }
                                    v2.push(value);
                                    v2.push(NaN);

                                    if (v.some(function (x) {
                                        return !isNaN(x);
                                    })) {
                                        var dataSeries = new __WEBPACK_IMPORTED_MODULE_9_scichart_Charting_Model_XyDataSeries__["XyDataSeries"](_this5.wasmContext, {
                                            xValues: d,
                                            yValues: v
                                        });

                                        dataSeries.dataSeriesName = e.title;

                                        var lineSeries = new __WEBPACK_IMPORTED_MODULE_8_scichart_Charting_Visuals_RenderableSeries_FastLineRenderableSeries__["FastLineRenderableSeries"](_this5.wasmContext, {
                                            dataSeries: dataSeries,
                                            drawNaNAs: __WEBPACK_IMPORTED_MODULE_20_scichart_Charting_Drawing_WebGlRenderContext2D__["ELineDrawMode"].DiscontinuousLine,
                                            stroke: '#E06C65',
                                            strokeThickness: 15
                                        });

                                        lineSeries.strokeColor = '#E06C65';
                                        lineSeries.rolloverModifierProps.tooltipTitle = e.title;
                                        lineSeries.rolloverModifierProps.tooltipTextColor = '#fff';
                                        lineSeries.rolloverModifierProps.tooltipColor = e.strokeColor;
                                        lineSeries.rolloverModifierProps.tooltipLabelX = _this5.labelX ? _this5.labelX : "X";
                                        _this5.sciChartSurface.renderableSeries.add(lineSeries);
                                    }

                                    d2 = d2.sort(function (a, b) {
                                        return new Date(a) - new Date(b);
                                    });

                                    var greenDataSeries = new __WEBPACK_IMPORTED_MODULE_9_scichart_Charting_Model_XyDataSeries__["XyDataSeries"](_this5.wasmContext, {
                                        xValues: d2,
                                        yValues: v2
                                    });

                                    greenDataSeries.dataSeriesName = e.title;

                                    var lineSeries2 = new __WEBPACK_IMPORTED_MODULE_8_scichart_Charting_Visuals_RenderableSeries_FastLineRenderableSeries__["FastLineRenderableSeries"](_this5.wasmContext, {
                                        drawNaNAs: __WEBPACK_IMPORTED_MODULE_20_scichart_Charting_Drawing_WebGlRenderContext2D__["ELineDrawMode"].DiscontinuousLine,
                                        stroke: '#84CA85',
                                        strokeThickness: 10
                                    });

                                    lineSeries2.dataSeries = greenDataSeries;

                                    _this5.sciChartSurface.renderableSeries.add(lineSeries2);
                                });

                                if (init) {
                                    if (_this5.zoomBySelection == true) _this5.sciChartSurface.chartModifiers.add(new __WEBPACK_IMPORTED_MODULE_12_scichart_Charting_ChartModifiers_RubberBandXyZoomModifier__["RubberBandXyZoomModifier"]({ xyDirection: __WEBPACK_IMPORTED_MODULE_19_scichart_types_XyDirection__["EXyDirection"].XDirection }));
                                    if (_this5.pan != false) _this5.sciChartSurface.chartModifiers.add(new __WEBPACK_IMPORTED_MODULE_10_scichart_Charting_ChartModifiers_ZoomPanModifier__["ZoomPanModifier"]({ xyDirection: __WEBPACK_IMPORTED_MODULE_19_scichart_types_XyDirection__["EXyDirection"].XDirection }));
                                    if (_this5.zoom != false) _this5.sciChartSurface.chartModifiers.add(new __WEBPACK_IMPORTED_MODULE_13_scichart_Charting_ChartModifiers_ZoomExtentsModifier__["ZoomExtentsModifier"]({ xyDirection: __WEBPACK_IMPORTED_MODULE_19_scichart_types_XyDirection__["EXyDirection"].XDirection }));
                                    if (_this5.mouseZoom != false) _this5.sciChartSurface.chartModifiers.add(new __WEBPACK_IMPORTED_MODULE_11_scichart_Charting_ChartModifiers_MouseWheelZoomModifier__["MouseWheelZoomModifier"]({ xyDirection: __WEBPACK_IMPORTED_MODULE_19_scichart_types_XyDirection__["EXyDirection"].XDirection }));

                                    _this5.sciChartSurface.chartModifiers.add(new __WEBPACK_IMPORTED_MODULE_17_scichart_Charting_ChartModifiers_CursorModifier__["CursorModifier"]({
                                        crosshairStroke: "#0095B2",
                                        crosshairStrokeThickness: 1,
                                        tooltipContainerBackground: "#000",
                                        tooltipTextStroke: "#0095B2",
                                        showTooltip: false,
                                        axisLabelFill: "#0095B2",
                                        axisLabelStroke: "#fff"
                                    }));
                                }

                                _this5.sciChartSurface.zoomExtents();

                            case 3:
                            case "end":
                                return _context5.stop();
                        }
                    }
                }, _callee5, _this5);
            }))();
        },
        changeDataSet: function changeDataSet(index, init) {
            var _this6 = this;

            var set = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.dataset[index]));
            var res = [];

            set.forEach(function (e, i) {
                var dev = { xValues: [], yValues: [], title: -1 };
                e.item1.forEach(function (at, j) {
                    if (at.item2 == _this6.selectedAlarmType) {
                        at.item1.forEach(function (a, k) {
                            // console.log({a: a, at: at, res: new Date(a.createDate) >= this.dateFrom && new Date(a.createDate) <= this.dateTo})
                            if (new Date(a.createDate) >= _this6.dateFrom && new Date(a.createDate) <= _this6.dateTo) {
                                var c1 = new Date(a.createDate);
                                c1.setSeconds(c1.getSeconds() - 1);
                                dev.yValues.push(c1);
                                dev.xValues.push(NaN);

                                dev.yValues.push(new Date(a.createDate));
                                if (new Date(a.endDate) > _this6.dateTo) {
                                    dev.yValues.push(new Date(_this6.dateTo));
                                    var e1 = new Date(_this6.dateTo);
                                    e1.setSeconds(e1.getSeconds() + 1);
                                    dev.yValues.push(e1);
                                } else {
                                    dev.yValues.push(new Date(a.endDate));
                                    var e1 = new Date(a.endDate);
                                    e1.setSeconds(e1.getSeconds() + 1);
                                    dev.yValues.push(e1);
                                }
                                dev.xValues.push(parseInt(e.item2));
                                dev.xValues.push(parseInt(e.item2));

                                dev.xValues.push(NaN);
                            }
                        });
                    }
                });

                dev.title = e.item2;

                if (dev.yValues.length != 0) {
                    dev.yValues.sort(function (a, b) {
                        return new Date(a) - new Date(b);
                    });
                } else {
                    dev.yValues.push(_this6.dateFrom);
                    dev.yValues.push(_this6.dateTo);
                    dev.xValues.push(NaN);
                    dev.xValues.push(NaN);
                }

                res.push(dev);
            });

            this.data = [].concat(res);
            if (init == false) this.reloadSciChart();
        },
        dateChanged: function dateChanged(dateFrom, dateTo) {
            if (this.init == false) {
                return;
            }
            this.dateFrom = dateFrom;
            this.dateTo = dateTo;

            this.checkAvailableAlarmTypes();
            this.changeDataSet(this.activeSet, false);
        },
        checkAvailableAlarmTypes: function checkAvailableAlarmTypes() {
            var _this7 = this;

            this.changingType = true;
            var newSelection = [];

            this.dataset[this.activeSet].forEach(function (e, i) {
                e.item1.forEach(function (at, j) {
                    at.item1.forEach(function (a, k) {
                        if (new Date(a.createDate) >= new Date(_this7.dateFrom) && new Date(a.createDate) <= new Date(_this7.dateTo)) {
                            if (!newSelection.includes(at.item2)) {
                                newSelection.push(at.item2);
                            }
                        }
                    });
                });
            });

            if (newSelection.length != 0) {
                newSelection.sort(function (a, b) {
                    return a.localeCompare(b);
                });

                if (!newSelection.includes(this.selectedAlarmType)) {
                    this.selectedAlarmType = newSelection[0];
                }
            }

            this.availableAlarmTypes = [].concat(newSelection);
            this.changingType = false;
        },
        datediff: function datediff(first, second) {
            return Math.round((second - first) / (1000 * 60 * 60 * 24));
        }
    },
    mounted: function () {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee6() {
            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
                while (1) {
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            if (!(this.dataset.length == 0)) {
                                _context6.next = 5;
                                break;
                            }

                            _context6.next = 3;
                            return this.initSciChart();

                        case 3:
                            this.init = true;
                            return _context6.abrupt("return");

                        case 5:
                            this.checkAvailableAlarmTypes();
                            this.changeDataSet(this.activeSet, true);
                            _context6.next = 9;
                            return this.initSciChart();

                        case 9:
                            this.init = true;
                            this.refreshChartSize();

                        case 11:
                        case "end":
                            return _context6.stop();
                    }
                }
            }, _callee6, this);
        }));

        function mounted() {
            return _ref2.apply(this, arguments);
        }

        return mounted;
    }(),
    beforeDestroy: function () {
        var _ref3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee7() {
            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
                while (1) {
                    switch (_context7.prev = _context7.next) {
                        case 0:
                            if (this.sciChartSurface || this.wasmContext) {
                                this.sciChartSurface = null;
                                this.wasmContext = null;
                            }
                            this.sciChartSurface = null;
                            this.wasmContext = null;

                        case 3:
                        case "end":
                            return _context7.stop();
                    }
                }
            }, _callee7, this);
        }));

        function beforeDestroy() {
            return _ref3.apply(this, arguments);
        }

        return beforeDestroy;
    }(),
    updated: function () {
        var _ref4 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee8() {
            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
                while (1) {
                    switch (_context8.prev = _context8.next) {
                        case 0:
                            if (this.dataset[this.activeSet].length == 0) {
                                // this.selectionChanged()
                            }

                        case 1:
                        case "end":
                            return _context8.stop();
                    }
                }
            }, _callee8, this);
        }));

        function updated() {
            return _ref4.apply(this, arguments);
        }

        return updated;
    }()
});

/***/ }),

/***/ 1599:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1604);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("3b83cca8", content, true, {});

/***/ }),

/***/ 1600:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(1548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_api__ = __webpack_require__(952);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var context = null;

/* harmony default export */ __webpack_exports__["a"] = ({
	name: "AlarmTypesSelect",
	props: {
		priority: {
			type: Number,
			required: true
		},
		preSelectedAlarm: {
			required: false,
			default: null
		},
		systemId: {
			type: String,
			required: true
		},
		dateFrom: {
			type: Date,
			required: true
		},
		dateTo: {
			type: Date,
			required: true
		},
		allTypes: {
			type: Boolean,
			required: true
		}
	},
	computed: {
		computedId: function computedId() {
			return this.selectedAlarm !== undefined ? this.selectedAlarm.id : '-1';
		}
	},
	watch: {
		priority: function priority(newVal, oldVal) {
			this.getData();
		},
		allTypes: function allTypes() {
			this.getData();
		},
		dateFrom: function dateFrom(newVal, oldVal) {
			this.getData();
		},
		dateTo: function dateTo(newVal, oldVal) {
			this.getData();
		},
		preSelectedAlarm: function preSelectedAlarm(newVal, oldVal) {
			this.getData();
		}
	},
	data: function data() {
		return {
			selectedAlarm: null,
			alarmTypes: [],
			allAlarmTypes: [],
			selectedAlarmIndex: 0
		};
	},

	methods: {
		scroll: function scroll(value) {
			var scrollAmount = 0;
			var slideTimer = setInterval(function () {
				context.$refs.container.scrollLeft += value / 20;
				scrollAmount += 20;
				if (scrollAmount >= Math.abs(value)) {
					window.clearInterval(slideTimer);
				}

				if (context.$refs.container.scrollLeft === 0) {
					document.getElementById("left-arrow").style.display = 'none';
				} else {
					document.getElementById("left-arrow").style.display = 'flex';
				}

				if (context.$refs.container.scrollWidth > context.$refs.container.offsetWidth + context.$refs.container.scrollLeft) {
					document.getElementById("right-arrow").style.display = 'flex';
				} else {
					document.getElementById("right-arrow").style.display = 'none';
				}
			}, 10);

			if (this.$refs.container.scrollLeft < 100) {
				document.getElementById("left-arrow").style.display = 'none';
			} else {
				document.getElementById("left-arrow").style.display = 'flex';
			}

			if (this.$refs.container.scrollWidth > this.$refs.container.offsetWidth + this.$refs.container.scrollLeft || value == 0) {
				document.getElementById("right-arrow").style.display = 'flex';
			} else {
				document.getElementById("right-arrow").style.display = 'none';
			}
		},
		getData: function getData() {
			var _this = this;

			return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
				var data, allAlarms;
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								_context.next = 2;
								return Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["_2" /* getAllAlarmTypesForSystem */])(_this.systemId, _this.dateFrom.toISOString(), _this.dateTo.toISOString());

							case 2:
								data = _context.sent;

								_this.allAlarmTypes = data;
								allAlarms = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(_this.allAlarmTypes.filter(function (x) {
									return x.priority == _this.priority;
								})));

								if (!_this.allTypes) {
									allAlarms = allAlarms.filter(function (x) {
										return x.numberOfAlarms > 0;
									});
								}
								_this.alarmTypes = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(allAlarms.sort(function (a, b) {
									return b.numberOfAlarms - a.numberOfAlarms;
								})));
								_this.selectedAlarm = _this.preSelectedAlarm == null || _this.preSelectedAlarm == '' ? allAlarms[0] : allAlarms[allAlarms.findIndex(function (x) {
									return x.description === _this.preSelectedAlarm;
								})];

								_this.scroll(0);

							case 9:
							case "end":
								return _context.stop();
						}
					}
				}, _callee, _this);
			}))();
		},
		changeSelection: function changeSelection(selection) {
			var _this2 = this;

			this.selectedAlarm = selection;
			if (this.selectedAlarm != undefined) {
				this.selectedAlarmIndex = this.alarmTypes.findIndex(function (x) {
					return x.id == _this2.selectedAlarm.id;
				});
			}
			this.$emit('alarmTypeChanged', selection);
		}
	},
	mounted: function () {
		var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
				while (1) {
					switch (_context2.prev = _context2.next) {
						case 0:
							this.getData();
							this.scroll(0);
							context = this;

						case 3:
						case "end":
							return _context2.stop();
					}
				}
			}, _callee2, this);
		}));

		function mounted() {
			return _ref.apply(this, arguments);
		}

		return mounted;
	}()
});

/***/ }),

/***/ 1601:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(1548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_scichart_Charting_Visuals_SciChartSurface__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_scichart_Charting_Visuals_SciChartSurface___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_scichart_Charting_Visuals_SciChartSurface__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_scichart_Charting_Visuals_Axis_NumericAxis__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_scichart_Charting_Visuals_Axis_NumericAxis___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_scichart_Charting_Visuals_Axis_NumericAxis__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_scichart_types_AxisAlignment__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_scichart_types_AxisAlignment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_scichart_types_AxisAlignment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_scichart_Charting_Visuals_RenderableSeries_FastLineRenderableSeries__ = __webpack_require__(955);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_scichart_Charting_Visuals_RenderableSeries_FastLineRenderableSeries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_scichart_Charting_Visuals_RenderableSeries_FastLineRenderableSeries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_scichart_Charting_Model_XyDataSeries__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_scichart_Charting_Model_XyDataSeries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_scichart_Charting_Model_XyDataSeries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_scichart_Charting_ChartModifiers_ZoomPanModifier__ = __webpack_require__(959);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_scichart_Charting_ChartModifiers_ZoomPanModifier___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_scichart_Charting_ChartModifiers_ZoomPanModifier__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_scichart_Charting_ChartModifiers_MouseWheelZoomModifier__ = __webpack_require__(957);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_scichart_Charting_ChartModifiers_MouseWheelZoomModifier___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_scichart_Charting_ChartModifiers_MouseWheelZoomModifier__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_scichart_Charting_ChartModifiers_RubberBandXyZoomModifier__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_scichart_Charting_ChartModifiers_RubberBandXyZoomModifier___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_scichart_Charting_ChartModifiers_RubberBandXyZoomModifier__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_scichart_Charting_ChartModifiers_ZoomExtentsModifier__ = __webpack_require__(958);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_scichart_Charting_ChartModifiers_ZoomExtentsModifier___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_scichart_Charting_ChartModifiers_ZoomExtentsModifier__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_chartTheme__ = __webpack_require__(1556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_scichart_Core_NumberRange__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_scichart_Core_NumberRange___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_scichart_Core_NumberRange__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_scichart_Charting_ChartModifiers_CursorModifier__ = __webpack_require__(956);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_scichart_Charting_ChartModifiers_CursorModifier___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_scichart_Charting_ChartModifiers_CursorModifier__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_scichart_types_XyDirection__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_scichart_types_XyDirection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_scichart_types_XyDirection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_scichart_Charting_Drawing_WebGlRenderContext2D__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_scichart_Charting_Drawing_WebGlRenderContext2D___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_scichart_Charting_Drawing_WebGlRenderContext2D__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_scichart_Charting_Visuals_Annotations_VerticalLineAnnotation__ = __webpack_require__(964);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_scichart_Charting_Visuals_Annotations_VerticalLineAnnotation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_scichart_Charting_Visuals_Annotations_VerticalLineAnnotation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_scichart_types_LabelPlacement__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_scichart_types_LabelPlacement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_scichart_types_LabelPlacement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_scichart_Charting_Visuals_Axis_LabelProvider_LabelProvider__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_scichart_Charting_Visuals_Axis_LabelProvider_LabelProvider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_scichart_Charting_Visuals_Axis_LabelProvider_LabelProvider__);



//
//
//
//
//
//
//
//





















/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_12__utils_chartTheme__["a" /* chartThemeMixin */]],
    props: ['dataset', 'devices', 'day', 'name', 'activeSet', 'labelX', 'labelY', 'zoom', 'pan', 'showValues', 'mouseZoom', 'sid', 'initialZoomOut'],
    data: function data() {
        var dateDay = new Date();
        dateDay.setDate(dateDay.getDate() - this.day);
        dateDay = new Date(dateDay.getFullYear(), dateDay.getMonth(), dateDay.getDate(), 0, 0, 0);

        return {
            sciChartSurface: null,
            wasmContext: null,
            init: false,
            data: [],
            dateFrom: dateDay,
            dateTo: new Date(dateDay.getFullYear(), dateDay.getMonth(), dateDay.getDate(), 23, 59, 59)
        };
    },

    watch: {
        dataset: function dataset(newVal, oldVal) {
            if (newVal != 0) {
                this.changeDataSet(newVal, false);
            }
        }
    },
    methods: {
        initSciChart: function initSciChart() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
                var _ref, sciChartSurface, wasmContext, xAxis, yAxis, lastRange;

                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return __WEBPACK_IMPORTED_MODULE_3_scichart_Charting_Visuals_SciChartSurface__["SciChartSurface"].create("scichart-root-" + _this.sid);

                            case 2:
                                _ref = _context.sent;
                                sciChartSurface = _ref.sciChartSurface;
                                wasmContext = _ref.wasmContext;


                                _this.sciChartSurface = sciChartSurface;
                                _this.wasmContext = wasmContext;

                                sciChartSurface.applyTheme(_this.chartTheme());

                                xAxis = new __WEBPACK_IMPORTED_MODULE_4_scichart_Charting_Visuals_Axis_NumericAxis__["NumericAxis"](_this.wasmContext, {
                                    axisAlignment: __WEBPACK_IMPORTED_MODULE_5_scichart_types_AxisAlignment__["EAxisAlignment"].Top,
                                    drawMajorBands: true,
                                    majorGridLineStyle: {
                                        color: "#9D9D9D"
                                    }
                                });
                                yAxis = new __WEBPACK_IMPORTED_MODULE_4_scichart_Charting_Visuals_Axis_NumericAxis__["NumericAxis"](_this.wasmContext, { axisAlignment: __WEBPACK_IMPORTED_MODULE_5_scichart_types_AxisAlignment__["EAxisAlignment"].Left });

                                yAxis.labelProvider.formatLabel = function (dataValue) {
                                    return parseInt(dataValue);
                                };
                                yAxis.maxAutoTicks = 2;
                                yAxis.minorsPerMajor = 2;
                                yAxis.visibleRange = new __WEBPACK_IMPORTED_MODULE_13_scichart_Core_NumberRange__["NumberRange"](1, 2);

                                if (_this.initialZoomOut == true) {
                                    yAxis.growBy = new __WEBPACK_IMPORTED_MODULE_13_scichart_Core_NumberRange__["NumberRange"](0.02, 0.02);
                                    xAxis.growBy = new __WEBPACK_IMPORTED_MODULE_13_scichart_Core_NumberRange__["NumberRange"](0.02, 0.02);
                                }

                                _this.sciChartSurface.xAxes.add(xAxis);
                                _this.sciChartSurface.yAxes.add(yAxis);

                                xAxis.labelProvider.formatLabel = function (dt) {
                                    return __WEBPACK_IMPORTED_MODULE_19_moment___default()(dt).format("DD.MM, HH:mm:ss");
                                };

                                yAxis.labelProvider.formatLabel = function (val) {
                                    return _this.name;
                                };

                                sciChartSurface.annotations.add(new __WEBPACK_IMPORTED_MODULE_17_scichart_Charting_Visuals_Annotations_VerticalLineAnnotation__["VerticalLineAnnotation"]({
                                    labelPlacement: __WEBPACK_IMPORTED_MODULE_18_scichart_types_LabelPlacement__["ELabelPlacement"].Axis,
                                    showLabel: true,
                                    stroke: "Red",
                                    strokeThickness: 2,
                                    x1: Date.now(),
                                    axisLabelFill: "Red",
                                    labelValue: _this.$t("Now")
                                }));

                                _context.next = 22;
                                return _this.populateSciChart(true);

                            case 22:

                                xAxis.autoTicks = false, xAxis.majorDelta = 3600000;
                                xAxis.minorDelta = 720000;
                                lastRange = 3;


                                xAxis.visibleRangeChanged.subscribe(function (args) {
                                    var rangeDiff = args.visibleRange.max - args.visibleRange.min;

                                    if (rangeDiff / 3600000 <= 1 && lastRange != 0) {
                                        xAxis.majorDelta = 60000;
                                        xAxis.minorDelta = 12000;
                                        lastRange = 0;
                                    } else if (rangeDiff / 3600000 <= 2 && rangeDiff / 3600000 >= 1 && lastRange != 1) {
                                        xAxis.majorDelta = 600000;
                                        xAxis.minorDelta = 120000;
                                        lastRange = 1;
                                    } else if (rangeDiff / 3600000 > 2 && rangeDiff / 3600000 <= 6 && lastRange != 2) {
                                        xAxis.majorDelta = 1800000;
                                        xAxis.minorDelta = 360000;
                                        lastRange = 2;
                                    } else if (rangeDiff / 3600000 > 6 && lastRange != 3) {
                                        xAxis.majorDelta = 3600000;
                                        xAxis.minorDelta = 720000;
                                        lastRange = 3;
                                    }
                                });

                            case 26:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        reloadSciChart: function reloadSciChart() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (!(_this2.sciChartSurface != null)) {
                                    _context2.next = 4;
                                    break;
                                }

                                if (_this2.sciChartSurface.renderableSeries != null) {
                                    _this2.sciChartSurface.renderableSeries.items = [];
                                }

                                _context2.next = 4;
                                return _this2.populateSciChart(false);

                            case 4:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        },
        populateSciChart: function populateSciChart(init) {
            var _this3 = this;

            this.data.forEach(function (e, i) {
                var d = [];
                var d2 = [];
                var v = [];
                var v2 = [];
                var value = e.xValues.filter(function (x) {
                    return !isNaN(x);
                })[0];

                if (value == undefined) {
                    value = parseInt(e.title);
                }

                //DF-1
                var c1 = new Date(_this3.dateFrom);
                c1.setSeconds(c1.getSeconds() - 1);
                d2.push(c1);
                if (e.xValues.length != 2) {
                    d2.push(_this3.dateFrom);
                }
                //DTs
                e.yValues.forEach(function (dt, j) {
                    d.push(new Date(__WEBPACK_IMPORTED_MODULE_19_moment___default()(dt, "DD.MM.YYYY HH.mm.ss")));
                    d2.push(new Date(__WEBPACK_IMPORTED_MODULE_19_moment___default()(dt, "DD.MM.YYYY HH.mm.ss")));
                });
                //DT+1
                if (e.xValues.length != 2) {
                    d2.push(_this3.dateTo);
                }
                var e1 = new Date(_this3.dateTo);
                e1.setSeconds(e1.getSeconds() + 1);
                d2.push(e1);

                v2.push(NaN);
                v2.push(value);
                if (e.xValues.length != 2) {
                    e.xValues.forEach(function (val, j) {
                        v.push(val);
                        v2.push(!isNaN(val) ? NaN : value);
                    });
                }
                v2.push(value);
                v2.push(NaN);

                if (v.some(function (x) {
                    return !isNaN(x);
                })) {
                    var dataSeries = new __WEBPACK_IMPORTED_MODULE_7_scichart_Charting_Model_XyDataSeries__["XyDataSeries"](_this3.wasmContext, {
                        xValues: d,
                        yValues: v
                    });

                    dataSeries.dataSeriesName = e.title;

                    var lineSeries = new __WEBPACK_IMPORTED_MODULE_6_scichart_Charting_Visuals_RenderableSeries_FastLineRenderableSeries__["FastLineRenderableSeries"](_this3.wasmContext, {
                        dataSeries: dataSeries,
                        drawNaNAs: __WEBPACK_IMPORTED_MODULE_16_scichart_Charting_Drawing_WebGlRenderContext2D__["ELineDrawMode"].DiscontinuousLine,
                        stroke: '#E06C65',
                        strokeThickness: 15
                    });

                    lineSeries.strokeColor = '#E06C65';
                    lineSeries.rolloverModifierProps.tooltipTitle = e.title;
                    lineSeries.rolloverModifierProps.tooltipTextColor = '#fff';
                    lineSeries.rolloverModifierProps.tooltipColor = e.strokeColor;
                    lineSeries.rolloverModifierProps.tooltipLabelX = _this3.labelX ? _this3.labelX : "X";
                    _this3.sciChartSurface.renderableSeries.add(lineSeries);
                }

                d2 = d2.sort(function (a, b) {
                    return new Date(a) - new Date(b);
                });

                var greenDataSeries = new __WEBPACK_IMPORTED_MODULE_7_scichart_Charting_Model_XyDataSeries__["XyDataSeries"](_this3.wasmContext, {
                    xValues: d2,
                    yValues: v2
                });

                greenDataSeries.dataSeriesName = e.title;

                var lineSeries2 = new __WEBPACK_IMPORTED_MODULE_6_scichart_Charting_Visuals_RenderableSeries_FastLineRenderableSeries__["FastLineRenderableSeries"](_this3.wasmContext, {
                    drawNaNAs: __WEBPACK_IMPORTED_MODULE_16_scichart_Charting_Drawing_WebGlRenderContext2D__["ELineDrawMode"].DiscontinuousLine,
                    stroke: '#84CA85',
                    strokeThickness: 10
                });

                lineSeries2.dataSeries = greenDataSeries;

                _this3.sciChartSurface.renderableSeries.add(lineSeries2);
            });

            if (init) {
                if (this.zoomBySelection == true) this.sciChartSurface.chartModifiers.add(new __WEBPACK_IMPORTED_MODULE_10_scichart_Charting_ChartModifiers_RubberBandXyZoomModifier__["RubberBandXyZoomModifier"]({ xyDirection: __WEBPACK_IMPORTED_MODULE_15_scichart_types_XyDirection__["EXyDirection"].XDirection }));
                if (this.pan != false) this.sciChartSurface.chartModifiers.add(new __WEBPACK_IMPORTED_MODULE_8_scichart_Charting_ChartModifiers_ZoomPanModifier__["ZoomPanModifier"]({ xyDirection: __WEBPACK_IMPORTED_MODULE_15_scichart_types_XyDirection__["EXyDirection"].XDirection }));
                if (this.zoom != false) this.sciChartSurface.chartModifiers.add(new __WEBPACK_IMPORTED_MODULE_11_scichart_Charting_ChartModifiers_ZoomExtentsModifier__["ZoomExtentsModifier"]({ xyDirection: __WEBPACK_IMPORTED_MODULE_15_scichart_types_XyDirection__["EXyDirection"].XDirection }));
                if (this.mouseZoom != false) this.sciChartSurface.chartModifiers.add(new __WEBPACK_IMPORTED_MODULE_9_scichart_Charting_ChartModifiers_MouseWheelZoomModifier__["MouseWheelZoomModifier"]({ xyDirection: __WEBPACK_IMPORTED_MODULE_15_scichart_types_XyDirection__["EXyDirection"].XDirection }));

                this.sciChartSurface.chartModifiers.add(new __WEBPACK_IMPORTED_MODULE_14_scichart_Charting_ChartModifiers_CursorModifier__["CursorModifier"]({
                    crosshairStroke: "#0095B2",
                    crosshairStrokeThickness: 1,
                    tooltipContainerBackground: "#000",
                    tooltipTextStroke: "#0095B2",
                    showTooltip: false,
                    axisLabelFill: "#0095B2",
                    axisLabelStroke: "#fff"
                }));
            }

            this.sciChartSurface.zoomExtents();
        },
        changeDataSet: function changeDataSet(index, init) {
            var _this4 = this;

            var set = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.dataset));

            //sort dataset
            set.sort(function (a, b) {
                return new Date(a.createDate) - new Date(b.createDate);
            });

            var dev = { xValues: [], yValues: [], title: -1 };

            set.forEach(function (e, i) {
                var c1 = new Date(e.createDate);
                c1.setSeconds(c1.getSeconds() - 1);
                dev.yValues.push(c1);
                dev.xValues.push(NaN);

                dev.yValues.push(new Date(e.createDate));

                if (new Date(e.endDate) > _this4.dateTo) {
                    dev.yValues.push(new Date(_this4.dateTo));
                    var e1 = new Date(_this4.dateTo);
                    e1.setSeconds(e1.getSeconds() + 1);
                    dev.yValues.push(e1);
                } else {
                    dev.yValues.push(new Date(e.endDate));
                    var e1 = new Date(e.endDate);
                    e1.setSeconds(e1.getSeconds() + 1);
                    dev.yValues.push(e1);
                }

                dev.xValues.push(1);
                dev.xValues.push(1);

                dev.xValues.push(NaN);
            });

            dev.title = 1;

            this.data = [];
            this.data.push(dev);
            if (init == false) {
                this.reloadSciChart();
            }
        }
    },
    mounted: function () {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            if (!(this.dataset.length == 0)) {
                                _context3.next = 5;
                                break;
                            }

                            _context3.next = 3;
                            return this.initSciChart();

                        case 3:
                            this.init = true;
                            return _context3.abrupt("return");

                        case 5:
                            this.changeDataSet(this.activeSet, true);
                            _context3.next = 8;
                            return this.initSciChart();

                        case 8:
                            this.init = true;

                        case 9:
                        case "end":
                            return _context3.stop();
                    }
                }
            }, _callee3, this);
        }));

        function mounted() {
            return _ref2.apply(this, arguments);
        }

        return mounted;
    }(),
    beforeDestroy: function () {
        var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            if (this.sciChartSurface || this.wasmContext) {
                                this.sciChartSurface = null;
                                this.wasmContext = null;
                            }
                            this.sciChartSurface = null;
                            this.wasmContext = null;

                        case 3:
                        case "end":
                            return _context4.stop();
                    }
                }
            }, _callee4, this);
        }));

        function beforeDestroy() {
            return _ref3.apply(this, arguments);
        }

        return beforeDestroy;
    }()
});

/***/ }),

/***/ 1604:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".mx-icon-double-left:after,.mx-icon-double-left:before,.mx-icon-double-right:after,.mx-icon-double-right:before,.mx-icon-left:before,.mx-icon-right:before{content:\"\";position:relative;top:-1px;display:inline-block;width:10px;height:10px;vertical-align:middle;border-style:solid;border-color:currentColor;border-width:2px 0 0 2px;border-radius:1px;-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-transform-origin:center;transform-origin:center;-webkit-transform:rotate(-45deg) scale(.7);transform:rotate(-45deg) scale(.7)}.mx-icon-double-left:after{left:-4px}.mx-icon-double-right:before{left:4px}.mx-icon-double-right:after,.mx-icon-double-right:before,.mx-icon-right:before{-webkit-transform:rotate(135deg) scale(.7);transform:rotate(135deg) scale(.7)}.mx-btn{-webkit-box-sizing:border-box;box-sizing:border-box;line-height:1;font-size:14px;font-weight:500;padding:7px 15px;margin:0;cursor:pointer;background-color:transparent;outline:none;border:1px solid rgba(0,0,0,.1);border-radius:4px;color:#73879c;white-space:nowrap}.mx-btn:hover{border-color:#1284e7;color:#1284e7}.mx-btn.disabled,.mx-btn:disabled{color:#ccc;cursor:not-allowed}.mx-btn-text{border:0;padding:0 4px;text-align:left;line-height:inherit}.mx-scrollbar{height:100%}.mx-scrollbar:hover .mx-scrollbar-track{opacity:1}.mx-scrollbar-wrap{height:100%;overflow-x:hidden;overflow-y:auto}.mx-scrollbar-track{position:absolute;top:2px;right:2px;bottom:2px;width:6px;z-index:1;border-radius:4px;opacity:0;-webkit-transition:opacity .24s ease-out;transition:opacity .24s ease-out}.mx-scrollbar-track .mx-scrollbar-thumb{position:absolute;width:100%;height:0;cursor:pointer;border-radius:inherit;background-color:hsla(220,4%,58%,.3);-webkit-transition:background-color .3s;transition:background-color .3s}.mx-zoom-in-down-enter-active,.mx-zoom-in-down-leave-active{opacity:1;-webkit-transform:scaleY(1);transform:scaleY(1);-webkit-transition:opacity .3s cubic-bezier(.23,1,.32,1),-webkit-transform .3s cubic-bezier(.23,1,.32,1);transition:opacity .3s cubic-bezier(.23,1,.32,1),-webkit-transform .3s cubic-bezier(.23,1,.32,1);transition:transform .3s cubic-bezier(.23,1,.32,1),opacity .3s cubic-bezier(.23,1,.32,1);transition:transform .3s cubic-bezier(.23,1,.32,1),opacity .3s cubic-bezier(.23,1,.32,1),-webkit-transform .3s cubic-bezier(.23,1,.32,1);-webkit-transform-origin:center top;transform-origin:center top}.mx-zoom-in-down-enter,.mx-zoom-in-down-enter-from,.mx-zoom-in-down-leave-to{opacity:0;-webkit-transform:scaleY(0);transform:scaleY(0)}.mx-datepicker{position:relative;display:inline-block;width:210px}.mx-datepicker svg{width:1em;height:1em;vertical-align:-.15em;fill:currentColor;overflow:hidden}.mx-datepicker-range{width:320px}.mx-datepicker-inline{width:auto}.mx-input-wrapper{position:relative}.mx-input{display:inline-block;-webkit-box-sizing:border-box;box-sizing:border-box;width:100%;height:34px;padding:6px 30px;padding-left:10px;font-size:14px;line-height:1.4;color:#555;background-color:#fff;border:1px solid #ccc;border-radius:4px;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.mx-input:focus,.mx-input:hover{border-color:#409aff}.mx-input.disabled,.mx-input:disabled{color:#ccc;background-color:#f3f3f3;border-color:#ccc;cursor:not-allowed}.mx-input:focus{outline:none}.mx-input::-ms-clear{display:none}.mx-icon-calendar,.mx-icon-clear{position:absolute;top:50%;right:8px;-webkit-transform:translateY(-50%);transform:translateY(-50%);font-size:16px;line-height:1;color:rgba(0,0,0,.5);vertical-align:middle}.mx-icon-clear{cursor:pointer}.mx-icon-clear:hover{color:rgba(0,0,0,.8)}.mx-datepicker-main{font:14px/1.5 Helvetica Neue,Helvetica,Arial,Microsoft Yahei,sans-serif;color:#73879c;background-color:#fff;border:1px solid #e8e8e8}.mx-datepicker-popup{position:absolute;margin-top:1px;margin-bottom:1px;-webkit-box-shadow:0 6px 12px rgba(0,0,0,.175);box-shadow:0 6px 12px rgba(0,0,0,.175);z-index:2001}.mx-datepicker-sidebar{float:left;-webkit-box-sizing:border-box;box-sizing:border-box;width:100px;padding:6px;overflow:auto}.mx-datepicker-sidebar+.mx-datepicker-content{margin-left:100px;border-left:1px solid #e8e8e8}.mx-datepicker-body{position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.mx-btn-shortcut{display:block;padding:0 6px;line-height:24px}.mx-range-wrapper{display:-webkit-box;display:-ms-flexbox;display:flex}@media(max-width:750px){.mx-range-wrapper{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}}.mx-datepicker-header{padding:6px 8px;border-bottom:1px solid #e8e8e8}.mx-datepicker-footer{padding:6px 8px;text-align:right;border-top:1px solid #e8e8e8}.mx-calendar{-webkit-box-sizing:border-box;box-sizing:border-box;width:248px;padding:6px 12px}.mx-calendar+.mx-calendar{border-left:1px solid #e8e8e8}.mx-calendar-header,.mx-time-header{-webkit-box-sizing:border-box;box-sizing:border-box;height:34px;line-height:34px;text-align:center;overflow:hidden}.mx-btn-icon-double-left,.mx-btn-icon-left{float:left}.mx-btn-icon-double-right,.mx-btn-icon-right{float:right}.mx-calendar-header-label{font-size:14px}.mx-calendar-decade-separator{margin:0 2px}.mx-calendar-decade-separator:after{content:\"~\"}.mx-calendar-content{position:relative;height:224px;-webkit-box-sizing:border-box;box-sizing:border-box}.mx-calendar-content .cell{cursor:pointer}.mx-calendar-content .cell:hover{color:#73879c;background-color:#f3f9fe}.mx-calendar-content .cell.active{color:#fff;background-color:#1284e7}.mx-calendar-content .cell.hover-in-range,.mx-calendar-content .cell.in-range{color:#73879c;background-color:#dbedfb}.mx-calendar-content .cell.disabled{cursor:not-allowed;color:#ccc;background-color:#f3f3f3}.mx-calendar-week-mode .mx-date-row{cursor:pointer}.mx-calendar-week-mode .mx-date-row:hover{background-color:#f3f9fe}.mx-calendar-week-mode .mx-date-row.mx-active-week{background-color:#dbedfb}.mx-calendar-week-mode .mx-date-row .cell.active,.mx-calendar-week-mode .mx-date-row .cell:hover{color:inherit;background-color:transparent}.mx-week-number{opacity:.5}.mx-table{table-layout:fixed;border-collapse:separate;border-spacing:0;width:100%;height:100%;-webkit-box-sizing:border-box;box-sizing:border-box;text-align:center}.mx-table th{font-weight:500}.mx-table td,.mx-table th{padding:0;vertical-align:middle}.mx-table-date td,.mx-table-date th{height:32px;font-size:12px}.mx-table-date .today{color:#2a90e9}.mx-table-date .cell.not-current-month{color:#ccc;background:none}.mx-time{-webkit-box-flex:1;-ms-flex:1;flex:1;width:224px;background:#fff}.mx-time+.mx-time{border-left:1px solid #e8e8e8}.mx-calendar-time{position:absolute;top:0;left:0;width:100%;height:100%}.mx-time-header{border-bottom:1px solid #e8e8e8}.mx-time-content{height:224px;-webkit-box-sizing:border-box;box-sizing:border-box;overflow:hidden}.mx-time-columns{display:-webkit-box;display:-ms-flexbox;display:flex;width:100%;height:100%;overflow:hidden}.mx-time-column{-webkit-box-flex:1;-ms-flex:1;flex:1;position:relative;border-left:1px solid #e8e8e8;text-align:center}.mx-time-column:first-child{border-left:0}.mx-time-column .mx-time-list{margin:0;padding:0;list-style:none}.mx-time-column .mx-time-list:after{content:\"\";display:block;height:192px}.mx-time-column .mx-time-item{cursor:pointer;font-size:12px;height:32px;line-height:32px}.mx-time-column .mx-time-item:hover{color:#73879c;background-color:#f3f9fe}.mx-time-column .mx-time-item.active{color:#1284e7;background-color:transparent;font-weight:700}.mx-time-column .mx-time-item.disabled{cursor:not-allowed;color:#ccc;background-color:#f3f3f3}.mx-time-option{cursor:pointer;padding:8px 10px;font-size:14px;line-height:20px}.mx-time-option:hover{color:#73879c;background-color:#f3f9fe}.mx-time-option.active{color:#1284e7;background-color:transparent;font-weight:700}.mx-time-option.disabled{cursor:not-allowed;color:#ccc;background-color:#f3f3f3}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/node_modules/vue2-datepicker/index.css"],"names":[],"mappings":"AAAA,2JAA2J,WAAW,kBAAkB,SAAS,qBAAqB,WAAW,YAAY,sBAAsB,mBAAmB,0BAA0B,yBAAyB,kBAAkB,8BAA8B,sBAAsB,gCAAgC,wBAAwB,2CAA4C,kCAAmC,CAAC,2BAA2B,SAAS,CAAC,6BAA6B,QAAQ,CAAC,+EAA+E,2CAA4C,kCAAmC,CAAC,QAAQ,8BAA8B,sBAAsB,cAAc,eAAe,gBAAgB,iBAAiB,SAAS,eAAe,6BAA6B,aAAa,gCAAgC,kBAAkB,cAAc,kBAAkB,CAAC,cAAc,qBAAqB,aAAa,CAAC,kCAAkC,WAAW,kBAAkB,CAAC,aAAa,SAAS,cAAc,gBAAgB,mBAAmB,CAAC,cAAc,WAAW,CAAC,wCAAwC,SAAS,CAAC,mBAAmB,YAAY,kBAAkB,eAAe,CAAC,oBAAoB,kBAAkB,QAAQ,UAAU,WAAW,UAAU,UAAU,kBAAkB,UAAU,yCAAyC,gCAAgC,CAAC,wCAAwC,kBAAkB,WAAW,SAAS,eAAe,sBAAsB,qCAAsC,wCAAwC,+BAA+B,CAAC,4DAA4D,UAAU,4BAA4B,oBAAoB,yGAAmH,iGAA2G,yFAAmG,yIAAwJ,oCAAoC,2BAA2B,CAAC,6EAA6E,UAAU,4BAA4B,mBAAmB,CAAC,eAAe,kBAAkB,qBAAqB,WAAW,CAAC,mBAAmB,UAAU,WAAW,sBAAuB,kBAAkB,eAAe,CAAC,qBAAqB,WAAW,CAAC,sBAAsB,UAAU,CAAC,kBAAkB,iBAAiB,CAAC,UAAU,qBAAqB,8BAA8B,sBAAsB,WAAW,YAAY,iBAAiB,kBAAkB,eAAe,gBAAgB,WAAW,sBAAsB,sBAAsB,kBAAkB,oDAAoD,2CAA2C,CAAC,gCAAgC,oBAAoB,CAAC,sCAAsC,WAAW,yBAAyB,kBAAkB,kBAAkB,CAAC,gBAAgB,YAAY,CAAC,qBAAqB,YAAY,CAAC,iCAAiC,kBAAkB,QAAQ,UAAU,mCAAmC,2BAA2B,eAAe,cAAc,qBAAqB,qBAAqB,CAAC,eAAe,cAAc,CAAC,qBAAqB,oBAAoB,CAAC,oBAAoB,wEAA4E,cAAc,sBAAsB,wBAAwB,CAAC,qBAAqB,kBAAkB,eAAe,kBAAkB,+CAA+C,uCAAuC,YAAY,CAAC,uBAAuB,WAAW,8BAA8B,sBAAsB,YAAY,YAAY,aAAa,CAAC,8CAA8C,kBAAkB,6BAA6B,CAAC,oBAAoB,kBAAkB,yBAAyB,sBAAsB,qBAAqB,gBAAgB,CAAC,iBAAiB,cAAc,cAAc,gBAAgB,CAAC,kBAAkB,oBAAoB,oBAAoB,YAAY,CAAC,wBAAyB,kBAAkB,4BAA4B,6BAA6B,0BAA0B,qBAAqB,CAAC,CAAC,sBAAsB,gBAAgB,+BAA+B,CAAC,sBAAsB,gBAAgB,iBAAiB,4BAA4B,CAAC,aAAa,8BAA8B,sBAAsB,YAAY,gBAAgB,CAAC,0BAA0B,6BAA6B,CAAC,oCAAoC,8BAA8B,sBAAsB,YAAY,iBAAiB,kBAAkB,eAAe,CAAC,2CAA2C,UAAU,CAAC,6CAA6C,WAAW,CAAC,0BAA0B,cAAc,CAAC,8BAA8B,YAAY,CAAC,oCAAoC,WAAW,CAAC,qBAAqB,kBAAkB,aAAa,8BAA8B,qBAAqB,CAAC,2BAA2B,cAAc,CAAC,iCAAiC,cAAc,wBAAwB,CAAC,kCAAkC,WAAW,wBAAwB,CAAC,8EAA8E,cAAc,wBAAwB,CAAC,oCAAoC,mBAAmB,WAAW,wBAAwB,CAAC,oCAAoC,cAAc,CAAC,0CAA0C,wBAAwB,CAAC,mDAAmD,wBAAwB,CAAC,AAA2F,iGAAiD,cAAc,4BAA4B,CAAC,gBAAgB,UAAU,CAAC,UAAU,mBAAmB,yBAAyB,iBAAiB,WAAW,YAAY,8BAA8B,sBAAsB,iBAAiB,CAAC,aAAuB,eAAgB,CAAsB,0BAAhD,UAAU,AAAgB,qBAAqB,CAA8C,oCAAoC,YAAY,cAAc,CAAC,sBAAsB,aAAa,CAAC,uCAAuC,WAAW,eAAe,CAAC,SAAS,mBAAmB,WAAW,OAAO,YAAY,eAAe,CAAC,kBAAkB,6BAA6B,CAAC,kBAAkB,kBAAkB,MAAM,OAAO,WAAW,WAAW,CAAC,gBAAgB,+BAA+B,CAAC,iBAAiB,aAAa,8BAA8B,sBAAsB,eAAe,CAAC,iBAAiB,oBAAoB,oBAAoB,aAAa,WAAW,YAAY,eAAe,CAAC,gBAAgB,mBAAmB,WAAW,OAAO,kBAAkB,8BAA8B,iBAAiB,CAAC,4BAA4B,aAAa,CAAC,8BAA8B,SAAS,UAAU,eAAe,CAAC,oCAAqC,WAAW,cAAc,YAAY,CAAC,8BAA8B,eAAe,eAAe,YAAY,gBAAgB,CAAC,oCAAoC,cAAc,wBAAwB,CAAC,qCAAqC,cAAc,6BAA6B,eAAe,CAAC,uCAAuC,mBAAmB,WAAW,wBAAwB,CAAC,gBAAgB,eAAe,iBAAiB,eAAe,gBAAgB,CAAC,sBAAsB,cAAc,wBAAwB,CAAC,uBAAuB,cAAc,6BAA6B,eAAe,CAAC,yBAAyB,mBAAmB,WAAW,wBAAwB,CAAC","file":"index.css","sourcesContent":[".mx-icon-left:before,.mx-icon-right:before,.mx-icon-double-left:before,.mx-icon-double-right:before,.mx-icon-double-left:after,.mx-icon-double-right:after{content:\"\";position:relative;top:-1px;display:inline-block;width:10px;height:10px;vertical-align:middle;border-style:solid;border-color:currentColor;border-width:2px 0 0 2px;border-radius:1px;-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-transform-origin:center;transform-origin:center;-webkit-transform:rotate(-45deg) scale(0.7);transform:rotate(-45deg) scale(0.7)}.mx-icon-double-left:after{left:-4px}.mx-icon-double-right:before{left:4px}.mx-icon-right:before,.mx-icon-double-right:before,.mx-icon-double-right:after{-webkit-transform:rotate(135deg) scale(0.7);transform:rotate(135deg) scale(0.7)}.mx-btn{-webkit-box-sizing:border-box;box-sizing:border-box;line-height:1;font-size:14px;font-weight:500;padding:7px 15px;margin:0;cursor:pointer;background-color:transparent;outline:none;border:1px solid rgba(0,0,0,.1);border-radius:4px;color:#73879c;white-space:nowrap}.mx-btn:hover{border-color:#1284e7;color:#1284e7}.mx-btn:disabled,.mx-btn.disabled{color:#ccc;cursor:not-allowed}.mx-btn-text{border:0;padding:0 4px;text-align:left;line-height:inherit}.mx-scrollbar{height:100%}.mx-scrollbar:hover .mx-scrollbar-track{opacity:1}.mx-scrollbar-wrap{height:100%;overflow-x:hidden;overflow-y:auto}.mx-scrollbar-track{position:absolute;top:2px;right:2px;bottom:2px;width:6px;z-index:1;border-radius:4px;opacity:0;-webkit-transition:opacity .24s ease-out;transition:opacity .24s ease-out}.mx-scrollbar-track .mx-scrollbar-thumb{position:absolute;width:100%;height:0;cursor:pointer;border-radius:inherit;background-color:rgba(144,147,153,.3);-webkit-transition:background-color .3s;transition:background-color .3s}.mx-zoom-in-down-enter-active,.mx-zoom-in-down-leave-active{opacity:1;-webkit-transform:scaleY(1);transform:scaleY(1);-webkit-transition:opacity .3s cubic-bezier(0.23, 1, 0.32, 1),-webkit-transform .3s cubic-bezier(0.23, 1, 0.32, 1);transition:opacity .3s cubic-bezier(0.23, 1, 0.32, 1),-webkit-transform .3s cubic-bezier(0.23, 1, 0.32, 1);transition:transform .3s cubic-bezier(0.23, 1, 0.32, 1),opacity .3s cubic-bezier(0.23, 1, 0.32, 1);transition:transform .3s cubic-bezier(0.23, 1, 0.32, 1),opacity .3s cubic-bezier(0.23, 1, 0.32, 1),-webkit-transform .3s cubic-bezier(0.23, 1, 0.32, 1);-webkit-transform-origin:center top;transform-origin:center top}.mx-zoom-in-down-enter,.mx-zoom-in-down-enter-from,.mx-zoom-in-down-leave-to{opacity:0;-webkit-transform:scaleY(0);transform:scaleY(0)}.mx-datepicker{position:relative;display:inline-block;width:210px}.mx-datepicker svg{width:1em;height:1em;vertical-align:-0.15em;fill:currentColor;overflow:hidden}.mx-datepicker-range{width:320px}.mx-datepicker-inline{width:auto}.mx-input-wrapper{position:relative}.mx-input{display:inline-block;-webkit-box-sizing:border-box;box-sizing:border-box;width:100%;height:34px;padding:6px 30px;padding-left:10px;font-size:14px;line-height:1.4;color:#555;background-color:#fff;border:1px solid #ccc;border-radius:4px;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.mx-input:hover,.mx-input:focus{border-color:#409aff}.mx-input:disabled,.mx-input.disabled{color:#ccc;background-color:#f3f3f3;border-color:#ccc;cursor:not-allowed}.mx-input:focus{outline:none}.mx-input::-ms-clear{display:none}.mx-icon-calendar,.mx-icon-clear{position:absolute;top:50%;right:8px;-webkit-transform:translateY(-50%);transform:translateY(-50%);font-size:16px;line-height:1;color:rgba(0,0,0,.5);vertical-align:middle}.mx-icon-clear{cursor:pointer}.mx-icon-clear:hover{color:rgba(0,0,0,.8)}.mx-datepicker-main{font:14px/1.5 \"Helvetica Neue\",Helvetica,Arial,\"Microsoft Yahei\",sans-serif;color:#73879c;background-color:#fff;border:1px solid #e8e8e8}.mx-datepicker-popup{position:absolute;margin-top:1px;margin-bottom:1px;-webkit-box-shadow:0 6px 12px rgba(0,0,0,.175);box-shadow:0 6px 12px rgba(0,0,0,.175);z-index:2001}.mx-datepicker-sidebar{float:left;-webkit-box-sizing:border-box;box-sizing:border-box;width:100px;padding:6px;overflow:auto}.mx-datepicker-sidebar+.mx-datepicker-content{margin-left:100px;border-left:1px solid #e8e8e8}.mx-datepicker-body{position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.mx-btn-shortcut{display:block;padding:0 6px;line-height:24px}.mx-range-wrapper{display:-webkit-box;display:-ms-flexbox;display:flex}@media(max-width: 750px){.mx-range-wrapper{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}}.mx-datepicker-header{padding:6px 8px;border-bottom:1px solid #e8e8e8}.mx-datepicker-footer{padding:6px 8px;text-align:right;border-top:1px solid #e8e8e8}.mx-calendar{-webkit-box-sizing:border-box;box-sizing:border-box;width:248px;padding:6px 12px}.mx-calendar+.mx-calendar{border-left:1px solid #e8e8e8}.mx-calendar-header,.mx-time-header{-webkit-box-sizing:border-box;box-sizing:border-box;height:34px;line-height:34px;text-align:center;overflow:hidden}.mx-btn-icon-left,.mx-btn-icon-double-left{float:left}.mx-btn-icon-right,.mx-btn-icon-double-right{float:right}.mx-calendar-header-label{font-size:14px}.mx-calendar-decade-separator{margin:0 2px}.mx-calendar-decade-separator:after{content:\"~\"}.mx-calendar-content{position:relative;height:224px;-webkit-box-sizing:border-box;box-sizing:border-box}.mx-calendar-content .cell{cursor:pointer}.mx-calendar-content .cell:hover{color:#73879c;background-color:#f3f9fe}.mx-calendar-content .cell.active{color:#fff;background-color:#1284e7}.mx-calendar-content .cell.in-range,.mx-calendar-content .cell.hover-in-range{color:#73879c;background-color:#dbedfb}.mx-calendar-content .cell.disabled{cursor:not-allowed;color:#ccc;background-color:#f3f3f3}.mx-calendar-week-mode .mx-date-row{cursor:pointer}.mx-calendar-week-mode .mx-date-row:hover{background-color:#f3f9fe}.mx-calendar-week-mode .mx-date-row.mx-active-week{background-color:#dbedfb}.mx-calendar-week-mode .mx-date-row .cell:hover{color:inherit;background-color:transparent}.mx-calendar-week-mode .mx-date-row .cell.active{color:inherit;background-color:transparent}.mx-week-number{opacity:.5}.mx-table{table-layout:fixed;border-collapse:separate;border-spacing:0;width:100%;height:100%;-webkit-box-sizing:border-box;box-sizing:border-box;text-align:center}.mx-table th{padding:0;font-weight:500;vertical-align:middle}.mx-table td{padding:0;vertical-align:middle}.mx-table-date td,.mx-table-date th{height:32px;font-size:12px}.mx-table-date .today{color:#2a90e9}.mx-table-date .cell.not-current-month{color:#ccc;background:none}.mx-time{-webkit-box-flex:1;-ms-flex:1;flex:1;width:224px;background:#fff}.mx-time+.mx-time{border-left:1px solid #e8e8e8}.mx-calendar-time{position:absolute;top:0;left:0;width:100%;height:100%}.mx-time-header{border-bottom:1px solid #e8e8e8}.mx-time-content{height:224px;-webkit-box-sizing:border-box;box-sizing:border-box;overflow:hidden}.mx-time-columns{display:-webkit-box;display:-ms-flexbox;display:flex;width:100%;height:100%;overflow:hidden}.mx-time-column{-webkit-box-flex:1;-ms-flex:1;flex:1;position:relative;border-left:1px solid #e8e8e8;text-align:center}.mx-time-column:first-child{border-left:0}.mx-time-column .mx-time-list{margin:0;padding:0;list-style:none}.mx-time-column .mx-time-list::after{content:\"\";display:block;height:192px}.mx-time-column .mx-time-item{cursor:pointer;font-size:12px;height:32px;line-height:32px}.mx-time-column .mx-time-item:hover{color:#73879c;background-color:#f3f9fe}.mx-time-column .mx-time-item.active{color:#1284e7;background-color:transparent;font-weight:700}.mx-time-column .mx-time-item.disabled{cursor:not-allowed;color:#ccc;background-color:#f3f3f3}.mx-time-option{cursor:pointer;padding:8px 10px;font-size:14px;line-height:20px}.mx-time-option:hover{color:#73879c;background-color:#f3f9fe}.mx-time-option.active{color:#1284e7;background-color:transparent;font-weight:700}.mx-time-option.disabled{cursor:not-allowed;color:#ccc;background-color:#f3f3f3}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1605:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __vue_component__; });
/* unused harmony export install */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script = {
  name: 'VueToggles',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    reverse: {
      type: Boolean,
      default: false,
    },
    checkedText: {
      type: String,
      default: null,
    },
    uncheckedText: {
      type: String,
      default: null,
    },
    width: {
      type: [Number, String],
      default: 75,
    },
    height: {
      type: [Number, String],
      default: 25,
    },
    uncheckedBg: {
      type: String,
      default: '#939393',
    },
    checkedBg: {
      type: String,
      default: '#5850ec',
    },
    dotColor: {
      type: String,
      default: '#fff',
    },
    fontSize: {
      type: [Number, String],
      default: '12',
    },
    checkedColor: {
      type: String,
      default: '#fff',
    },
    uncheckedColor: {
      type: String,
      default: '#fff',
    },
    fontWeight: {
      type: [Number, String],
      default: 'normal',
    },
  },
  computed: {
    bgStyle: function bgStyle() {
      var styles = {
        width: ((this.width) + "px"),
        height: ((this.height) + "px"),
        background: this.value ? this.checkedBg : this.uncheckedBg,
        opacity: this.disabled ? '0.5' : '1',
        cursor: !this.disabled ? 'pointer' : 'not-allowed',
      };

      return styles;
    },
    dotStyle: function dotStyle() {
      var styles = {
        background: this.dotColor,
        width: ((this.height - 8) + "px"),
        height: ((this.height - 8) + "px"),
        'min-width': ((this.height - 8) + "px"),
        'min-height': ((this.height - 8) + "px"),
        'margin-left': this.value ? ((this.width - (this.height - 3)) + "px") : '5px',
      };

      if ((!this.value && this.reverse) || (this.value && !this.reverse)) {
        styles.marginLeft = (this.width - (this.height - 3)) + "px";
      } else if ((this.value && this.reverse) || (!this.value && !this.reverse)) {
        styles.marginLeft = '5px';
      }

      return styles;
    },
    textStyle: function textStyle() {
      var styles = {
        'font-weight': this.fontWeight,
        'font-size': ((this.fontSize) + "px"),
        color: this.value && !this.disabled ? this.checkedColor : this.uncheckedColor,
        right: this.value ? ((this.height - 3) + "px") : 'auto',
        left: this.value ? 'auto' : ((this.height - 3) + "px"),
      };

      if (!this.value && this.reverse) {
        styles.right = (this.height - 3) + "px";
        styles.left = 'auto';
      } else if (this.value && this.reverse) {
        styles.left = (this.height - 3) + "px";
        styles.right = 'auto';
      }

      return styles;
    },
  },
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    var options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    var hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            var originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            var existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

var isOldIE = typeof navigator !== 'undefined' &&
    /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
    return function (id, style) { return addStyle(id, style); };
}
var HEAD;
var styles = {};
function addStyle(id, css) {
    var group = isOldIE ? css.media || 'default' : id;
    var style = styles[group] || (styles[group] = { ids: new Set(), styles: [] });
    if (!style.ids.has(id)) {
        style.ids.add(id);
        var code = css.source;
        if (css.map) {
            // https://developer.chrome.com/devtools/docs/javascript-debugging
            // this makes source maps inside style tags work properly in Chrome
            code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
            // http://stackoverflow.com/a/26603875
            code +=
                '\n/*# sourceMappingURL=data:application/json;base64,' +
                    btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
                    ' */';
        }
        if (!style.element) {
            style.element = document.createElement('style');
            style.element.type = 'text/css';
            if (css.media)
                { style.element.setAttribute('media', css.media); }
            if (HEAD === undefined) {
                HEAD = document.head || document.getElementsByTagName('head')[0];
            }
            HEAD.appendChild(style.element);
        }
        if ('styleSheet' in style.element) {
            style.styles.push(code);
            style.element.styleSheet.cssText = style.styles
                .filter(Boolean)
                .join('\n');
        }
        else {
            var index = style.ids.size - 1;
            var textNode = document.createTextNode(code);
            var nodes = style.element.childNodes;
            if (nodes[index])
                { style.element.removeChild(nodes[index]); }
            if (nodes.length)
                { style.element.insertBefore(textNode, nodes[index]); }
            else
                { style.element.appendChild(textNode); }
        }
    }
}

/* script */
var __vue_script__ = script;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "span",
    {
      staticClass: "vue-toggles",
      style: _vm.bgStyle,
      attrs: {
        role: "switch",
        tabindex: "0",
        "aria-checked": _vm.value ? "true" : "false",
        "aria-readonly": _vm.disabled ? "true" : "false"
      },
      on: {
        click: function($event) {
          !_vm.disabled ? _vm.$emit("click", _vm.value) : null;
        },
        keyup: [
          function($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            ) {
              return null
            }
            $event.preventDefault();
            !_vm.disabled ? _vm.$emit("click", _vm.value) : null;
          },
          function($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])
            ) {
              return null
            }
            $event.preventDefault();
            !_vm.disabled ? _vm.$emit("click", _vm.value) : null;
          }
        ]
      }
    },
    [
      _c(
        "span",
        {
          staticClass: "dot",
          style: _vm.dotStyle,
          attrs: { "aria-hidden": "true" }
        },
        [
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.checkedText && _vm.value,
                  expression: "checkedText && value"
                }
              ],
              staticClass: "text",
              style: _vm.textStyle
            },
            [_vm._v("\n      " + _vm._s(_vm.checkedText) + "\n    ")]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.uncheckedText && !_vm.value,
                  expression: "uncheckedText && !value"
                }
              ],
              staticClass: "text",
              style: _vm.textStyle
            },
            [_vm._v("\n      " + _vm._s(_vm.uncheckedText) + "\n    ")]
          )
        ]
      )
    ]
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  var __vue_inject_styles__ = function (inject) {
    if (!inject) { return }
    inject("data-v-ce3b9412_0", { source: "\n.vue-toggles {\r\n  display: flex;\r\n  align-items: center;\r\n  border-radius: 9999px;\r\n  overflow: hidden;\r\n  transition: background-color ease 0.2s, width ease 0.2s, height ease 0.2s;\n}\n.vue-toggles .dot {\r\n  position: relative;\r\n  display: flex;\r\n  align-items: center;\r\n  border-radius: 9999px;\r\n  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);\r\n  transition: margin ease 0.2s;\n}\n.vue-toggles .text {\r\n  position: absolute;\r\n  font-family: inherit;\r\n  user-select: none;\r\n  white-space: nowrap;\n}\n@media all and (-ms-high-contrast: none) {\n.vue-toggles .text {\r\n    /* IE11 fix */\r\n    top: 50%;\r\n    transform: translateY(-50%);\n}\n}\n@media (prefers-reduced-motion) {\r\n  /* disable animations if user have a reduced motion setting */\n.vue-toggles,\r\n  .vue-toggles *,\r\n  .vue-toggles *::before,\r\n  .vue-toggles *::after {\r\n    animation: none !important;\r\n    transition: none !important;\r\n    transition-duration: none !important;\n}\n}\r\n", map: {"version":3,"sources":["D:\\Folder\\codetemp\\vue-toggles\\src\\VueToggles.vue"],"names":[],"mappings":";AA2IA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,gBAAA;EACA,yEAAA;AACA;AAEA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,2EAAA;EACA,4BAAA;AACA;AAEA;EACA,kBAAA;EACA,oBAAA;EACA,iBAAA;EACA,mBAAA;AACA;AAEA;AACA;IACA,aAAA;IACA,QAAA;IACA,2BAAA;AACA;AACA;AAEA;EACA,6DAAA;AACA;;;;IAIA,0BAAA;IACA,2BAAA;IACA,oCAAA;AACA;AACA","file":"VueToggles.vue","sourcesContent":["<template>\r\n  <span\r\n    class=\"vue-toggles\"\r\n    :style=\"bgStyle\"\r\n    role=\"switch\"\r\n    tabindex=\"0\"\r\n    :aria-checked=\"value ? 'true' : 'false'\"\r\n    :aria-readonly=\"disabled ? 'true' : 'false'\"\r\n    @click=\"!disabled ? $emit('click', value) : null\"\r\n    @keyup.enter.prevent=\"!disabled ? $emit('click', value) : null\"\r\n    @keyup.space.prevent=\"!disabled ? $emit('click', value) : null\"\r\n  >\r\n    <span aria-hidden=\"true\" :style=\"dotStyle\" class=\"dot\">\r\n      <span v-show=\"checkedText && value\" :style=\"textStyle\" class=\"text\">\r\n        {{ checkedText }}\r\n      </span>\r\n\r\n      <span v-show=\"uncheckedText && !value\" :style=\"textStyle\" class=\"text\">\r\n        {{ uncheckedText }}\r\n      </span>\r\n    </span>\r\n  </span>\r\n</template>\r\n\r\n<script>\r\nexport default {\r\n  name: 'VueToggles',\r\n  props: {\r\n    value: {\r\n      type: Boolean,\r\n      default: false,\r\n    },\r\n    disabled: {\r\n      type: Boolean,\r\n      default: false,\r\n    },\r\n    reverse: {\r\n      type: Boolean,\r\n      default: false,\r\n    },\r\n    checkedText: {\r\n      type: String,\r\n      default: null,\r\n    },\r\n    uncheckedText: {\r\n      type: String,\r\n      default: null,\r\n    },\r\n    width: {\r\n      type: [Number, String],\r\n      default: 75,\r\n    },\r\n    height: {\r\n      type: [Number, String],\r\n      default: 25,\r\n    },\r\n    uncheckedBg: {\r\n      type: String,\r\n      default: '#939393',\r\n    },\r\n    checkedBg: {\r\n      type: String,\r\n      default: '#5850ec',\r\n    },\r\n    dotColor: {\r\n      type: String,\r\n      default: '#fff',\r\n    },\r\n    fontSize: {\r\n      type: [Number, String],\r\n      default: '12',\r\n    },\r\n    checkedColor: {\r\n      type: String,\r\n      default: '#fff',\r\n    },\r\n    uncheckedColor: {\r\n      type: String,\r\n      default: '#fff',\r\n    },\r\n    fontWeight: {\r\n      type: [Number, String],\r\n      default: 'normal',\r\n    },\r\n  },\r\n  computed: {\r\n    bgStyle() {\r\n      const styles = {\r\n        width: `${this.width}px`,\r\n        height: `${this.height}px`,\r\n        background: this.value ? this.checkedBg : this.uncheckedBg,\r\n        opacity: this.disabled ? '0.5' : '1',\r\n        cursor: !this.disabled ? 'pointer' : 'not-allowed',\r\n      };\r\n\r\n      return styles;\r\n    },\r\n    dotStyle() {\r\n      const styles = {\r\n        background: this.dotColor,\r\n        width: `${this.height - 8}px`,\r\n        height: `${this.height - 8}px`,\r\n        'min-width': `${this.height - 8}px`,\r\n        'min-height': `${this.height - 8}px`,\r\n        'margin-left': this.value ? `${this.width - (this.height - 3)}px` : '5px',\r\n      };\r\n\r\n      if ((!this.value && this.reverse) || (this.value && !this.reverse)) {\r\n        styles.marginLeft = `${this.width - (this.height - 3)}px`;\r\n      } else if ((this.value && this.reverse) || (!this.value && !this.reverse)) {\r\n        styles.marginLeft = '5px';\r\n      }\r\n\r\n      return styles;\r\n    },\r\n    textStyle() {\r\n      const styles = {\r\n        'font-weight': this.fontWeight,\r\n        'font-size': `${this.fontSize}px`,\r\n        color: this.value && !this.disabled ? this.checkedColor : this.uncheckedColor,\r\n        right: this.value ? `${this.height - 3}px` : 'auto',\r\n        left: this.value ? 'auto' : `${this.height - 3}px`,\r\n      };\r\n\r\n      if (!this.value && this.reverse) {\r\n        styles.right = `${this.height - 3}px`;\r\n        styles.left = 'auto';\r\n      } else if (this.value && this.reverse) {\r\n        styles.left = `${this.height - 3}px`;\r\n        styles.right = 'auto';\r\n      }\r\n\r\n      return styles;\r\n    },\r\n  },\r\n};\r\n</script>\r\n\r\n<style>\r\n.vue-toggles {\r\n  display: flex;\r\n  align-items: center;\r\n  border-radius: 9999px;\r\n  overflow: hidden;\r\n  transition: background-color ease 0.2s, width ease 0.2s, height ease 0.2s;\r\n}\r\n\r\n.vue-toggles .dot {\r\n  position: relative;\r\n  display: flex;\r\n  align-items: center;\r\n  border-radius: 9999px;\r\n  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);\r\n  transition: margin ease 0.2s;\r\n}\r\n\r\n.vue-toggles .text {\r\n  position: absolute;\r\n  font-family: inherit;\r\n  user-select: none;\r\n  white-space: nowrap;\r\n}\r\n\r\n@media all and (-ms-high-contrast: none) {\r\n  .vue-toggles .text {\r\n    /* IE11 fix */\r\n    top: 50%;\r\n    transform: translateY(-50%);\r\n  }\r\n}\r\n\r\n@media (prefers-reduced-motion) {\r\n  /* disable animations if user have a reduced motion setting */\r\n  .vue-toggles,\r\n  .vue-toggles *,\r\n  .vue-toggles *::before,\r\n  .vue-toggles *::after {\r\n    animation: none !important;\r\n    transition: none !important;\r\n    transition-duration: none !important;\r\n  }\r\n}\r\n</style>\r\n"]}, media: undefined });

  };
  /* scoped */
  var __vue_scope_id__ = undefined;
  /* module identifier */
  var __vue_module_identifier__ = undefined;
  /* functional template */
  var __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  var __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    createInjector,
    undefined,
    undefined
  );

// Declare install function executed by Vue.use()
function install(Vue) {
  if (install.installed) { return; }
  install.installed = true;
  Vue.component('VueToggles', __vue_component__);
}

// Create module definition for Vue.use()
var plugin = {
  install: install,
};

// Auto-install when vue is found (eg. in browser via <script> tag)
var GlobalVue = null;
if (typeof window !== 'undefined') {
  GlobalVue = window.Vue;
} else if (typeof global !== 'undefined') {
  GlobalVue = global.Vue;
}
if (GlobalVue) {
  GlobalVue.use(plugin);
}



/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(123)))

/***/ }),

/***/ 1610:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Modal__ = __webpack_require__(1547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Systems_TooltipSystemStatus_vue__ = __webpack_require__(1672);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        Modal: __WEBPACK_IMPORTED_MODULE_0__components_Modal__["a" /* default */],
        TooltipSystemStatus: __WEBPACK_IMPORTED_MODULE_1__components_Systems_TooltipSystemStatus_vue__["a" /* default */]
    },
    props: {
        callback: {}
    },
    data: function data() {
        return {
            data: {},
            header: '',
            tooltip: false,
            list: []
        };
    },

    methods: {
        getData: function getData() {
            this.list = this.data[this.data.column.field].slice().reverse();

            if (this.data.column.field == 'visits') {
                var max = Math.max.apply(null, this.list);
                var green = 0.6 * max;
                var yellow = 0.3 * max;

                for (var i = 0; i < this.list.length; i++) {

                    if (this.list[i] >= green) {
                        this.list[i] = 0;
                    } else if (this.list[i] >= yellow) {
                        this.list[i] = 1;
                    } else {
                        this.list[i] = 2;
                    }
                }
            } else if (this.data.column.field == 'statusTab') {
                for (var _i = 0; _i < this.list.length; _i++) {
                    this.list[_i] = this.list[_i][0];
                }
            }
        },
        calculateDate: function calculateDate(index, data) {
            var dt = new Date();
            dt = new Date(dt.setDate(dt.getDate() - index));
            var ret = dt.setTime(dt.getTime() - 1 * 60 * 60 * 1000);
            return ret > new Date(data.lastUpdate);
        },
        calculateAlarmOffDate: function calculateAlarmOffDate(index, data) {
            var dt = new Date();
            dt = new Date(dt.setDate(dt.getDate() - index));

            return data.alarmsOffCrfi != undefined && data.alarmsOffCrfi != '0001-01-01T00:00:00' && dt > new Date(data.alarmsOffCrfi) || data.alarmsOffMonitoring != undefined && data.alarmsOffMonitoring != '0001-01-01T00:00:00' && dt > new Date(data.alarmsOffMonitoring);
        },
        openInfo: function openInfo(args, value, index) {
            if (this.callback != undefined) {
                this.callback(this.data, 'INFO', 7 - index, value, args);
            }
        }
    },
    mounted: function mounted() {
        this.getData();
    }
});

/***/ }),

/***/ 1611:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Modal__ = __webpack_require__(1547);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        Modal: __WEBPACK_IMPORTED_MODULE_0__components_Modal__["a" /* default */]
    },
    props: {
        activeObject: {},
        activeDay: {},
        title: {
            type: String,
            required: false,
            default: "Status (" + this.activeDay + " days ago)"
        }
    },
    data: function data() {
        return {
            general: 0,
            blackBox: 0,
            device: 0,
            rapid24: 0,
            photocells: 0,
            pressure: 0,
            database: 0
        };
    },

    methods: {
        computeData: function computeData() {
            var index = this.activeDay;
            this.general = this.activeObject.statusTab[index][1];
            this.blackBox = this.activeObject.statusTab[index][2];
            this.device = this.activeObject.statusTab[index][3];
            this.rapid24 = this.activeObject.statusTab[index][4];
            this.photocells = this.activeObject.statusTab[index][5];
            this.pressure = this.activeObject.statusTab[index][6];
            this.database = this.activeObject.statusTab[index][7];
        }
    },
    mounted: function mounted() {
        this.computeData();
    }
});

/***/ }),

/***/ 1612:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SciChart_vue__ = __webpack_require__(1596);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13c4aa24_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SciChart_vue__ = __webpack_require__(1637);
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SciChart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13c4aa24_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SciChart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1613:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1614);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("6e196bb3", content, true, {});

/***/ }),

/***/ 1614:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".mx-datepicker-range{width:250px}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/Datepicker.vue"],"names":[],"mappings":"AACA,qBACC,WAAa,CACb","file":"Datepicker.vue","sourcesContent":["\n.mx-datepicker-range {\n\twidth: 250px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1615:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1616);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("95f8b262", content, true, {});

/***/ }),

/***/ 1616:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"Datepicker.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 1617:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('date-picker',{attrs:{"confirm":false,"type":'date',"disabled-date":function (date) { return date < _vm.min || date > _vm.max; },"shortcuts":_vm.shortcuts,"clearable":false,"format":'DD-MM-YYYY',"render-input-text":_vm.renderInputText,"range-separator":_vm.separator,"range":""},model:{value:(_vm.time),callback:function ($$v) {_vm.time=$$v},expression:"time"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1620:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SciChartMultiple_vue__ = __webpack_require__(1597);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1635f11c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SciChartMultiple_vue__ = __webpack_require__(1640);
function injectStyle (ssrContext) {
  __webpack_require__(1638)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SciChartMultiple_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1635f11c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SciChartMultiple_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1621:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AlarmTypesSelect_vue__ = __webpack_require__(1600);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33618b12_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AlarmTypesSelect_vue__ = __webpack_require__(1648);
function injectStyle (ssrContext) {
  __webpack_require__(1644)
  __webpack_require__(1646)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-33618b12"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AlarmTypesSelect_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33618b12_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AlarmTypesSelect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1622:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tenor.aa5f34f.gif";

/***/ }),

/***/ 1631:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SystemAlarmsDetailsModal_vue__ = __webpack_require__(1595);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aa10d0ea_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SystemAlarmsDetailsModal_vue__ = __webpack_require__(1654);
function injectStyle (ssrContext) {
  __webpack_require__(1632)
  __webpack_require__(1635)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-aa10d0ea"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SystemAlarmsDetailsModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aa10d0ea_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SystemAlarmsDetailsModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1632:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1633);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("16c2ac30", content, true, {});

/***/ }),

/***/ 1633:
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(1503);
exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".ChartIcon:before{content:url(" + escape(__webpack_require__(1634)) + ")}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/Systems/SystemAlarmsDetailsModal.vue"],"names":[],"mappings":"AACA,kBACI,qCAAsD,CACzD","file":"SystemAlarmsDetailsModal.vue","sourcesContent":["\n.ChartIcon::before {\n    content: url(\"~@/assets/img/Systems/GraphsBlack.svg\");\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1634:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTkiIGhlaWdodD0iMTkiIHZpZXdCb3g9IjAgMCAxOSAxOSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE3IDE1SDIuNTUyMzNDMi4yNDcyOCAxNSAyIDE0Ljc0MDggMiAxNC40MjExVjQiIHN0cm9rZT0iIzAwMCIgc3Ryb2tlLXdpZHRoPSIxLjMiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNNSAxMkw4LjI3NTEgOC4xNzc4OUM4LjMyMzQzIDguMTIxNSA4LjM4MDggOC4wNzY3NiA4LjQ0Mzk0IDguMDQ2MjNDOC41MDcwOSA4LjAxNTcxIDguNTc0NzYgOCA4LjY0MzExIDhDOC43MTE0NiA4IDguNzc5MTMgOC4wMTU3MSA4Ljg0MjI4IDguMDQ2MjNDOC45MDU0MiA4LjA3Njc2IDguOTYyNzkgOC4xMjE1IDkuMDExMTIgOC4xNzc4OUwxMS45MTgyIDExLjU3MDVDMTEuOTY2NSAxMS42MjY5IDEyLjAyMzkgMTEuNjcxNyAxMi4wODcxIDExLjcwMjJDMTIuMTUwMiAxMS43MzI3IDEyLjIxNzkgMTEuNzQ4NCAxMi4yODYyIDExLjc0ODRDMTIuMzU0NiAxMS43NDg0IDEyLjQyMjMgMTEuNzMyNyAxMi40ODU0IDExLjcwMjJDMTIuNTQ4NSAxMS42NzE3IDEyLjYwNTkgMTEuNjI2OSAxMi42NTQyIDExLjU3MDVMMTQgMTAiIHN0cm9rZT0iIzAwMCIgc3Ryb2tlLXdpZHRoPSIxLjMiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K"

/***/ }),

/***/ 1635:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1636);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("23d18458", content, true, {});

/***/ }),

/***/ 1636:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".height-120[data-v-aa10d0ea]{height:calc(80vh - 120px)}.height-80[data-v-aa10d0ea]{height:80vh}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/Systems/SystemAlarmsDetailsModal.vue"],"names":[],"mappings":"AACA,6BACI,yBAA2B,CAC9B,AACD,4BACI,WAAa,CAChB","file":"SystemAlarmsDetailsModal.vue","sourcesContent":["\n.height-120[data-v-aa10d0ea] {\n    height: calc(80vh - 120px);\n}\n.height-80[data-v-aa10d0ea] {\n    height: 80vh;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1637:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"horizontal",staticStyle:{"height":"80vh","width":"90vw"}},[_c('div',{staticStyle:{"width":"100%","margin-right":"10px"},attrs:{"id":'scichart-root-' + _vm.sid}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1638:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1639);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("690358ff", content, true, {});

/***/ }),

/***/ 1639:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, "#sciTable.e-grid .e-selectionbackground.e-rowcell{background-color:hsla(0,0%,100%,.05)}#sciTable.e-grid .e-row.whiteText .e-rowcell{color:#fff;font-weight:600;font-size:13px;line-height:16px}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/SciChartMultiple.vue"],"names":[],"mappings":"AACA,kDACI,oCAA4C,CAC/C,AACD,6CACI,WAAY,AACZ,gBAAiB,AACjB,eAAgB,AAChB,gBAAkB,CACrB","file":"SciChartMultiple.vue","sourcesContent":["\n#sciTable.e-grid .e-selectionbackground.e-rowcell {\n    background-color: rgba(255, 255, 255, 0.05);\n}\n#sciTable.e-grid .e-row.whiteText .e-rowcell {\n    color: #fff;\n    font-weight: 600;\n    font-size: 13px;\n    line-height: 16px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1640:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"horizontal",staticStyle:{"height":"80vh","width":"90vw"}},[_c('div',{staticStyle:{"width":"80%","margin-right":"10px"},attrs:{"id":'scichart-root-' + _vm.sid}}),_vm._v(" "),_c('ejs-grid',{ref:'grid-' + _vm.sid,attrs:{"id":"sciTable","width":"20%","height":"100%","selectionSettings":_vm.selectionOptions,"allowTextWrap":true,"textWrapSettings":_vm.wrapSettings,"dataBound":_vm.dataBound,"dataSource":_vm.data,"showBusyIndicator":true,"rowDataBound":_vm.rowDataBound,"rowSelected":_vm.selectionChanged,"rowDeselected":_vm.selectionChanged}},[_c('e-columns',[_c('e-column',{attrs:{"type":"checkbox","width":"50","headerText":"Discontinued","textAlign":"Left","customAttributes":_vm.customAttributes}}),_vm._v(" "),_c('e-column',{attrs:{"field":"title","headerText":'Alarm type',"textAlign":"Left","width":"130","customAttributes":_vm.customAttributes}})],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1641:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SciChartSingleDayPriorityAlarms_vue__ = __webpack_require__(1598);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c36de844_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SciChartSingleDayPriorityAlarms_vue__ = __webpack_require__(1649);
function injectStyle (ssrContext) {
  __webpack_require__(1642)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SciChartSingleDayPriorityAlarms_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c36de844_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SciChartSingleDayPriorityAlarms_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1642:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1643);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("12526f8e", content, true, {});

/***/ }),

/***/ 1643:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, "#sciTable.e-grid .e-selectionbackground.e-rowcell{background-color:hsla(0,0%,100%,.05)}#sciTable.e-grid .e-row.whiteText .e-rowcell{color:#fff;font-weight:600;font-size:13px;line-height:16px}select{padding:5px;width:100%}select:focus{outline:none;border-bottom:1px solid #0095b2}option{padding:4px}option:checked{background:#347c93;color:#fff}.info-field-title{font-style:normal;font-weight:600;font-size:12px;line-height:16px;padding-right:20px;color:#272727;margin:0}.info-field-row{width:100%;margin:0;padding-bottom:5px}.info-field-value{font-style:normal;font-weight:400;font-size:12px;line-height:16px;color:#272727}.alert-no-alarms{z-index:11;position:absolute;top:50%;left:calc(50% - 162px);-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;font-weight:600;padding:40px;background-color:#fefefe;border:1px solid #888;width:auto;border-radius:5px;-webkit-box-shadow:0 4px 10px rgba(0,0,0,.2);box-shadow:0 4px 10px rgba(0,0,0,.2)}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/Charts/SciChartSingleDayPriorityAlarms.vue"],"names":[],"mappings":"AACA,kDACI,oCAA4C,CAC/C,AACD,6CACI,WAAY,AACZ,gBAAiB,AACjB,eAAgB,AAChB,gBAAkB,CACrB,AACD,OAEI,YAAa,AACb,UAAY,CACf,AACD,aACI,aAAc,AACd,+BAAiC,CACpC,AACD,OACI,WAAa,CAChB,AACD,eACI,mBAAoB,AACpB,UAAa,CAChB,AAOD,kBACI,kBAAmB,AACnB,gBAAiB,AACjB,eAAgB,AAChB,iBAAkB,AAElB,mBAAoB,AACpB,cAAe,AACf,QAAU,CACb,AACD,gBACI,WAAY,AACZ,SAAU,AACV,kBAAoB,CACvB,AACD,kBACI,kBAAmB,AACnB,gBAAoB,AACpB,eAAgB,AAChB,iBAAkB,AAElB,aAAe,CAClB,AACD,iBACI,WAAY,AACZ,kBAAmB,AACnB,QAAS,AACT,uBAAwB,AACxB,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,gBAAiB,AACjB,aAAc,AACd,yBAA0B,AAC1B,sBAAuB,AACvB,WAAY,AACZ,kBAAmB,AACnB,6CAAiD,AACzC,oCAAyC,CACpD","file":"SciChartSingleDayPriorityAlarms.vue","sourcesContent":["\n#sciTable.e-grid .e-selectionbackground.e-rowcell {\n    background-color: rgba(255, 255, 255, 0.05);\n}\n#sciTable.e-grid .e-row.whiteText .e-rowcell {\n    color: #fff;\n    font-weight: 600;\n    font-size: 13px;\n    line-height: 16px;\n}\nselect {\n    /* border: none; */\n    padding: 5px;\n    width: 100%;\n}\nselect:focus {\n    outline: none;\n    border-bottom: 1px solid #0095b2;\n}\noption {\n    padding: 4px;\n}\noption:checked {\n    background: #347C93;\n    color: white;\n}\n\n/* .info-field {\n    border-bottom: 1px solid #E9E9E9;\n    margin-bottom: 12px;\n    margin-top: 12px;\n} */\n.info-field-title {\n    font-style: normal;\n    font-weight: 600;\n    font-size: 12px;\n    line-height: 16px;\n\n    padding-right: 20px;\n    color: #272727;\n    margin: 0;\n}\n.info-field-row {\n    width: 100%;\n    margin: 0;\n    padding-bottom: 5px;\n}\n.info-field-value {\n    font-style: normal;\n    font-weight: normal;\n    font-size: 12px;\n    line-height: 16px;\n\n    color: #272727;\n}\n.alert-no-alarms {\n    z-index: 11;\n    position: absolute;\n    top: 50%;\n    left: calc(50% - 162px);\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    font-weight: 600;\n    padding: 40px;\n    background-color: #fefefe;\n    border: 1px solid #888;\n    width: auto;\n    border-radius: 5px;\n    -webkit-box-shadow: 0px 4px 10px rgba(0,0,0,0.2);\n            box-shadow: 0px 4px 10px rgba(0,0,0,0.2);\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1644:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1645);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("54cb6980", content, true, {});

/***/ }),

/***/ 1645:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".tippy-popper[x-placement^=bottom] .tippy-tooltip.customTheme-theme .tippy-arrow{border-bottom:8px solid #346f8b}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/Filters/AlarmTypesSelect.vue"],"names":[],"mappings":"AACA,iFACC,+BAAiC,CACjC","file":"AlarmTypesSelect.vue","sourcesContent":["\n.tippy-popper[x-placement^=bottom] .tippy-tooltip.customTheme-theme .tippy-arrow {\n\tborder-bottom: 8px solid #346F8B;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1646:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1647);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("550b5e64", content, true, {});

/***/ }),

/***/ 1647:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, "[data-v-33618b12]::-webkit-scrollbar{display:none}.alarm-type-container[data-v-33618b12]{max-width:90vw;white-space:nowrap;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:0;-ms-flex:none;flex:none}.alarm-type-buttons-container[data-v-33618b12]{width:90vw;max-width:90vw;overflow-x:scroll;position:relative;scrollbar-width:none}.alarm-type-card[data-v-33618b12]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;background-color:#f3f3f3;cursor:pointer;padding:0 12px;border:1px solid #e0e0e0;border-radius:5px;height:30px;margin:5px;-webkit-box-shadow:0 4px 5px 0 rgba(0,0,0,.1);box-shadow:0 4px 5px 0 rgba(0,0,0,.1);-ms-flex-item-align:center;text-align:left;background-color:#fff}.alarm-type-card[data-v-33618b12]:hover{background-color:rgba(0,125,149,.1);color:#000}.selected-alarm-type[data-v-33618b12]{background-color:#007d95;color:#fff}.arrow-button[data-v-33618b12]{width:56px;background-color:hsla(0,0%,98%,.98);-webkit-box-orient:vertical;-ms-flex-direction:column;flex-direction:column}.arrow-button[data-v-33618b12],.before-renderer[data-v-33618b12]{z-index:2000;height:40px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-direction:normal;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.before-renderer[data-v-33618b12]{position:absolute;-webkit-box-orient:horizontal;-ms-flex-direction:row;flex-direction:row}#left-arrow.before-renderer[data-v-33618b12]:after{background:-webkit-gradient(linear,left top,right top,color-stop(20%,hsla(0,0%,98%,.98)),color-stop(80%,hsla(0,0%,98%,0)));background:linear-gradient(90deg,hsla(0,0%,98%,.98) 20%,hsla(0,0%,98%,0) 80%)}#right-arrow.before-renderer[data-v-33618b12]:before{background:-webkit-gradient(linear,right top,left top,color-stop(20%,hsla(0,0%,98%,.98)),color-stop(80%,hsla(0,0%,98%,0)));background:linear-gradient(270deg,hsla(0,0%,98%,.98) 20%,hsla(0,0%,98%,0) 80%)}#left-arrow.before-renderer[data-v-33618b12]:after,#right-arrow.before-renderer[data-v-33618b12]:before{height:40px;width:50px;content:\"\";pointer-events:none}#left-arrow[data-v-33618b12]{left:0}#left-arrow[data-v-33618b12],#right-arrow[data-v-33618b12]{height:40px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}#right-arrow[data-v-33618b12]{right:0}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/Filters/AlarmTypesSelect.vue"],"names":[],"mappings":"AACA,qCACC,YAAc,CACd,AACD,uCACC,eAAgB,AAChB,mBAAoB,AACpB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,mBAAoB,AAChB,cAAe,AACX,SAAW,CACnB,AACD,+CACC,WAAY,AACZ,eAAgB,AAChB,kBAAmB,AACnB,kBAAmB,AAClB,oBAAsB,CACvB,AACD,kCACC,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,yBAAyC,AACzC,eAAgB,AAChB,eAAgB,AAChB,yBAAyC,AACzC,kBAAmB,AACnB,YAAa,AACb,WAAgB,AAChB,8CAAmD,AAC3C,sCAA2C,AACnD,2BAA4B,AAC5B,gBAAiB,AACjB,qBAAwB,CACxB,AACD,wCACC,oCAAyC,AACzC,UAAa,CACb,AACD,sCACC,yBAAuC,AACvC,UAAa,CACb,AACD,+BAEC,WAAY,AAEZ,oCAA4C,AAI5C,4BAA6B,AAEzB,0BAA2B,AACvB,qBAAuB,CAI/B,AACD,iEAfC,aAAc,AAEd,YAAa,AAEb,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AAEd,6BAA8B,AAG9B,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CAgBhC,AAdD,kCACC,kBAAmB,AAMnB,8BAA+B,AAE3B,uBAAwB,AACpB,kBAAoB,CAI5B,AACD,mDACC,2HAA+I,AAC/I,6EAAiG,CACjG,AACD,qDACC,2HAA+I,AAC/I,8EAAgG,CAChG,AACD,wGACC,YAAa,AACb,WAAY,AACZ,WAAY,AACZ,mBAAqB,CACrB,AACD,6BACC,MAAQ,CAYR,AACD,2DAZC,YAAa,AACb,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,8BAA+B,AAC/B,6BAA8B,AAC1B,uBAAwB,AACpB,mBAAoB,AAC5B,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CAehC,AAbD,8BACC,OAAS,CAYT","file":"AlarmTypesSelect.vue","sourcesContent":["\n[data-v-33618b12]::-webkit-scrollbar {\n\tdisplay: none;\n}\n.alarm-type-container[data-v-33618b12] {\n\tmax-width: 90vw;\n\twhite-space: nowrap;\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-flex: 0;\n\t    -ms-flex: none;\n\t        flex: none;\n}\n.alarm-type-buttons-container[data-v-33618b12] {\n\twidth: 90vw;\n\tmax-width: 90vw;\n\toverflow-x: scroll;\n\tposition: relative;\n  scrollbar-width: none;\n}\n.alarm-type-card[data-v-33618b12] {\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-align: center;\n\t    -ms-flex-align: center;\n\t        align-items: center;\n\tbackground-color: rgba(243, 243, 243, 1);\n\tcursor: pointer;\n\tpadding: 0 12px;\n\tborder: 1px solid rgba(224, 224, 224, 1);\n\tborder-radius: 5px;\n\theight: 30px;\n\tmargin: 5px 5px;\n\t-webkit-box-shadow: 0 4px 5px 0 rgba(0, 0, 0, 0.1);\n\t        box-shadow: 0 4px 5px 0 rgba(0, 0, 0, 0.1);\n\t-ms-flex-item-align: center;\n\ttext-align: left;\n\tbackground-color: white;\n}\n.alarm-type-card[data-v-33618b12]:hover {\n\tbackground-color: rgba(0, 125, 149, 0.1);\n\tcolor: black;\n}\n.selected-alarm-type[data-v-33618b12] {\n\tbackground-color: rgba(0, 125, 149, 1);\n\tcolor: white;\n}\n.arrow-button[data-v-33618b12] {\n\tz-index: 2000;\n\twidth: 56px;\n\theight: 40px;\n\tbackground-color: rgba(249, 249, 249, 0.98);\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-orient: vertical;\n\t-webkit-box-direction: normal;\n\t    -ms-flex-direction: column;\n\t        flex-direction: column;\n\t-webkit-box-pack: center;\n\t    -ms-flex-pack: center;\n\t        justify-content: center;\n}\n.before-renderer[data-v-33618b12] {\n\tposition: absolute;\n\theight: 40px;\n\tz-index: 2000;\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-orient: horizontal;\n\t-webkit-box-direction: normal;\n\t    -ms-flex-direction: row;\n\t        flex-direction: row;\n\t-webkit-box-pack: center;\n\t    -ms-flex-pack: center;\n\t        justify-content: center;\n}\n#left-arrow.before-renderer[data-v-33618b12]:after {\n\tbackground: -webkit-gradient(linear, left top, right top, color-stop(20%, rgba(249, 249, 249, 0.98)), color-stop(80%, rgba(249, 249, 249, 0)));\n\tbackground: linear-gradient(to right, rgba(249, 249, 249, 0.98) 20%, rgba(249, 249, 249, 0) 80%);\n}\n#right-arrow.before-renderer[data-v-33618b12]:before {\n\tbackground: -webkit-gradient(linear, right top, left top, color-stop(20%, rgba(249, 249, 249, 0.98)), color-stop(80%, rgba(249, 249, 249, 0)));\n\tbackground: linear-gradient(to left, rgba(249, 249, 249, 0.98) 20%, rgba(249, 249, 249, 0) 80%);\n}\n#left-arrow.before-renderer[data-v-33618b12]:after, #right-arrow.before-renderer[data-v-33618b12]:before {\n\theight: 40px;\n\twidth: 50px;\n\tcontent: \"\";\n\tpointer-events: none;\n}\n#left-arrow[data-v-33618b12] {\n\tleft: 0;\n\theight: 40px;\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-orient: horizontal;\n\t-webkit-box-direction: normal;\n\t    -ms-flex-direction: row;\n\t        flex-direction: row;\n\t-webkit-box-pack: center;\n\t    -ms-flex-pack: center;\n\t        justify-content: center;\n}\n#right-arrow[data-v-33618b12]  {\n\tright: 0;\n\theight: 40px;\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-orient: horizontal;\n\t-webkit-box-direction: normal;\n\t    -ms-flex-direction: row;\n\t        flex-direction: row;\n\t-webkit-box-pack: center;\n\t    -ms-flex-pack: center;\n\t        justify-content: center;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1648:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"alarm-type-container"},[_c('div',{staticClass:"before-renderer",attrs:{"id":"left-arrow"}},[_c('div',{staticClass:"arrow-button"},[_c('div',{staticStyle:{"width":"32px","height":"32px","margin":"0 12px","cursor":"pointer"},on:{"click":function($event){return _vm.scroll(-300)}}},[_c('svg',{staticClass:"style-scope yt-icon",staticStyle:{"pointer-events":"none","display":"block","width":"100%","height":"100%"},attrs:{"viewBox":"0 0 16 16","preserveAspectRatio":"xMidYMid meet","focusable":"false"}},[_c('g',{staticClass:"style-scope yt-icon",attrs:{"mirror-in-rtl":""}},[_c('path',{staticClass:"style-scope yt-icon",attrs:{"d":"M10.15,13.35L4.79,8l5.35-5.35l0.71,0.71L6.21,8l4.65,4.65L10.15,13.35z"}})])])])])]),_vm._v(" "),_c('div',{ref:"container",staticClass:"horizontal alarm-type-buttons-container",attrs:{"id":"container"}},_vm._l((_vm.alarmTypes),function(aT){return _c('div',{key:aT.id},[_c('div',{class:['alarm-type-card', { 'selected-alarm-type' : aT.id == _vm.computedId}],on:{"click":function($event){return _vm.changeSelection(aT)}}},[_c('div',{staticClass:"noselect",staticStyle:{"font-weight":"bolder","font-size":"12px","word-break":"break-word"}},[_vm._v(_vm._s(_vm.$t(aT.description))+" "),_c('span',{staticStyle:{"font-size":"12px"}},[_vm._v("("+_vm._s(aT.numberOfAlarms)+")")])])])])}),0),_vm._v(" "),_c('div',{staticClass:"before-renderer",attrs:{"id":"right-arrow"}},[_c('div',{staticClass:"arrow-button"},[_c('div',{staticStyle:{"width":"32px","height":"32px","margin":"0 12px","cursor":"pointer"},on:{"click":function($event){return _vm.scroll(300)}}},[_c('svg',{staticClass:"style-scope yt-icon",staticStyle:{"pointer-events":"none","display":"block","width":"100%","height":"100%"},attrs:{"viewBox":"0 0 16 16","preserveAspectRatio":"xMidYMid meet","focusable":"false"}},[_c('g',{staticClass:"style-scope yt-icon",attrs:{"mirror-in-rtl":""}},[_c('path',{staticClass:"style-scope yt-icon",attrs:{"d":"M4.97,12.65L9.62,8L4.97,3.35l0.71-0.71L11.03,8l-5.35,5.35L4.97,12.65z"}})])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1649:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"vertical",staticStyle:{"height":"85vh","width":"90vw"}},[_c('div',{ref:"multipleFilters",staticClass:"info-field"},[_c('tr',[_c('td',[_c('div',{staticStyle:{"display":"grid","align-content":"center"}},[_c('div',{staticClass:"horizontal",staticStyle:{"margin-left":"20px","margin-top":"5px"}},[_c('p',{staticClass:"info-field-title",staticStyle:{"align-self":"center","margin-left":"10px"}},[_vm._v(_vm._s(_vm.$t('AllAlarmTypes')))]),_vm._v(" "),_c('VueToggles',{attrs:{"value":_vm.allAlarmTypesOption,"checkedBg":"#0095b2","uncheckedBg":"lightgrey","width":"50","height":"25"},on:{"click":function($event){_vm.allAlarmTypesOption = !_vm.allAlarmTypesOption}}})],1)])])]),_vm._v(" "),_c('tr',{staticClass:"info-field-row"},[_c('td',[_c('alarm-types-select',{attrs:{"system-id":_vm.systemId,"date-from":_vm.dateFrom,"date-to":_vm.dateTo,"priority":parseInt(_vm.priority),"all-types":_vm.allAlarmTypesOption,"pre-selected-alarm":_vm.selectedAlarmType},on:{"alarmTypeChanged":function (aT) { return _vm.changeAlarmType(aT); }}})],1)])]),_vm._v(" "),_c('div',{staticStyle:{"width":"99%","height":"85vh","margin-right":"10px","margin-left":"10px","align-self":"center"},attrs:{"id":'scichart-root-' + _vm.sid}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1650:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SciChartOneLineAlarms_vue__ = __webpack_require__(1601);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f567fa2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SciChartOneLineAlarms_vue__ = __webpack_require__(1653);
function injectStyle (ssrContext) {
  __webpack_require__(1651)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7f567fa2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SciChartOneLineAlarms_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f567fa2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SciChartOneLineAlarms_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1651:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1652);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("c406aa7a", content, true, {});

/***/ }),

/***/ 1652:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"SciChartOneLineAlarms.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 1653:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"vertical",staticStyle:{"height":"120px","width":"80vw"}},[_c('div',{staticStyle:{"width":"100%","height":"100%","margin-right":"10px","align-self":"center"},attrs:{"id":'scichart-root-' + _vm.sid}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1654:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('modal',{attrs:{"showDialog":_vm.activeModal == 'PRIORITY-CHART',"title":_vm.$t('Graph')},on:{"close":_vm.closeModal}},[_c('sci-chart-single-day-priority-alarms',{attrs:{"allAlarmTypes":_vm.allAlarmTypes.filter(function (x) { return parseInt(x.priority) == _vm.data.column.field.charAt(_vm.data.column.field.length - 1); }).map(function (x) { return x.description; }),"dataset":_vm.chart,"systemId":_vm.data.id,"activeSet":0,"devices":_vm.devices,"initialZoomOut":true,"sid":1,"day":_vm.day,"priority":_vm.data.column.field.charAt(_vm.data.column.field.length - 1)}})],1),_vm._v(" "),(_vm.value == 0 && _vm.data.column.field != 'visits')?_c('div',{staticStyle:{"margin":"5px"}},[_c('img',{attrs:{"src":__webpack_require__(1622)}})]):(_vm.data.column.field == 'visits')?_c('div',{staticClass:"pl-4 pt-2 pd-2 pr-4"},[_c('p',[_vm._v(_vm._s(_vm.$t('Visits'))+": "+_vm._s(_vm.obj))])]):_c('div',{staticStyle:{"width":"85vw","height":"80vh"}},[(_vm.apiMethodName != 'getSystemAlarmFromToday')?_c('sci-chart-one-line-alarms',{staticStyle:{"margin-left":"2.5vw"},attrs:{"dataset":_vm.obj,"initialZoomOut":true,"sid":1,"day":_vm.day,"name":_vm.data.column.field}}):_vm._e(),_vm._v(" "),_c('div',{class:_vm.apiMethodName != 'getSystemAlarmFromToday' ? 'height-120' : 'height-80',staticStyle:{"display":"flex","flex-direction":"column","flex":"1"}},[_c('ejs-grid',{ref:"system_modal_grid",staticStyle:{"position":"relative"},attrs:{"height":"100%","width":"100%","toolbar":_vm.apiMethodName != 'getSystemAlarmFromToday' ? null : _vm.toolbar,"toolbarClick":_vm.toolbarClick,"selectionSettings":_vm.selectionOptions,"allowTextWrap":true,"textWrapSettings":_vm.wrapSettings,"dataBound":_vm.dataBound,"dataSource":_vm.obj,"allowPaging":true,"pageSettings":_vm.pageSettings,"allowFiltering":true,"filterSettings":_vm.filterOptions,"allowSorting":true,"allowMultiSorting":true,"allowPdfExport":true,"allowCsvExport":true,"allowExcelExport":true,"showBusyIndicator":true}},[_c('e-columns',[_c('e-column',{attrs:{"field":"number","headerText":_vm.$t('Unit'),"textAlign":"Left","customAttributes":_vm.customAttributes}}),_vm._v(" "),_c('e-column',{attrs:{"field":"type","headerText":_vm.$t('Type'),"textAlign":"Left","customAttributes":_vm.customAttributes}}),_vm._v(" "),_c('e-column',{attrs:{"field":"alarmType","headerText":_vm.$t('AlarmType'),"textAlign":"Left","customAttributes":_vm.customAttributes}}),_vm._v(" "),_c('e-column',{attrs:{"field":"createDate","headerText":_vm.$t('CreateDate'),"textAlign":"Left","customAttributes":_vm.customAttributes,"filter":_vm.filterMenu,"type":"datetime","format":_vm.dateTimeFormatOptions}}),_vm._v(" "),_c('e-column',{attrs:{"field":"endDate","headerText":_vm.$t('EndDate'),"textAlign":"Left","customAttributes":_vm.customAttributes,"filter":_vm.filterMenu,"type":"datetime","format":_vm.dateTimeFormatOptions}})],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1672:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TooltipSystemStatus_vue__ = __webpack_require__(1611);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b04b559a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TooltipSystemStatus_vue__ = __webpack_require__(1684);
function injectStyle (ssrContext) {
  __webpack_require__(1682)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b04b559a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TooltipSystemStatus_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b04b559a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TooltipSystemStatus_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1673:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(1548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_scichart_Charting_Visuals_SciChartSurface__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_scichart_Charting_Visuals_SciChartSurface___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_scichart_Charting_Visuals_SciChartSurface__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_scichart_Charting_Visuals_Axis_NumericAxis__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_scichart_Charting_Visuals_Axis_NumericAxis___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_scichart_Charting_Visuals_Axis_NumericAxis__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_scichart_types_AxisAlignment__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_scichart_types_AxisAlignment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_scichart_types_AxisAlignment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_scichart_Charting_Visuals_RenderableSeries_FastLineRenderableSeries__ = __webpack_require__(955);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_scichart_Charting_Visuals_RenderableSeries_FastLineRenderableSeries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_scichart_Charting_Visuals_RenderableSeries_FastLineRenderableSeries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_scichart_Charting_Model_XyDataSeries__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_scichart_Charting_Model_XyDataSeries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_scichart_Charting_Model_XyDataSeries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_scichart_Charting_ChartModifiers_ZoomPanModifier__ = __webpack_require__(959);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_scichart_Charting_ChartModifiers_ZoomPanModifier___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_scichart_Charting_ChartModifiers_ZoomPanModifier__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_scichart_Charting_ChartModifiers_MouseWheelZoomModifier__ = __webpack_require__(957);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_scichart_Charting_ChartModifiers_MouseWheelZoomModifier___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_scichart_Charting_ChartModifiers_MouseWheelZoomModifier__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_scichart_Charting_ChartModifiers_RubberBandXyZoomModifier__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_scichart_Charting_ChartModifiers_RubberBandXyZoomModifier___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_scichart_Charting_ChartModifiers_RubberBandXyZoomModifier__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_scichart_Charting_ChartModifiers_ZoomExtentsModifier__ = __webpack_require__(958);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_scichart_Charting_ChartModifiers_ZoomExtentsModifier___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_scichart_Charting_ChartModifiers_ZoomExtentsModifier__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_chartTheme__ = __webpack_require__(1556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_scichart_Core_NumberRange__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_scichart_Core_NumberRange___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_scichart_Core_NumberRange__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_scichart_Charting_ChartModifiers_CursorModifier__ = __webpack_require__(956);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_scichart_Charting_ChartModifiers_CursorModifier___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_scichart_Charting_ChartModifiers_CursorModifier__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_scichart_types_XyDirection__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_scichart_types_XyDirection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_scichart_types_XyDirection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_scichart_Charting_Drawing_WebGlRenderContext2D__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_scichart_Charting_Drawing_WebGlRenderContext2D___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_scichart_Charting_Drawing_WebGlRenderContext2D__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_scichart_Charting_Visuals_Annotations_VerticalLineAnnotation__ = __webpack_require__(964);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_scichart_Charting_Visuals_Annotations_VerticalLineAnnotation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_scichart_Charting_Visuals_Annotations_VerticalLineAnnotation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_scichart_types_LabelPlacement__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_scichart_types_LabelPlacement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_scichart_types_LabelPlacement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Datepicker_vue__ = __webpack_require__(1583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__api__ = __webpack_require__(952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__api_api__ = __webpack_require__(952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__Filters_DevicesSelect__ = __webpack_require__(1717);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

























/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_12__utils_chartTheme__["a" /* chartThemeMixin */]],
    props: ['sid', 'initialZoomOut', 'systemId', 'spin', 'activeSet', 'allAlarmTypes', 'deviceObj'],
    components: {
        DevicesSelect: __WEBPACK_IMPORTED_MODULE_23__Filters_DevicesSelect__["a" /* default */],
        Datepicker: __WEBPACK_IMPORTED_MODULE_20__Datepicker_vue__["a" /* default */]
    },
    watch: {
        selectedDevice: function selectedDevice(newVal, oldVal) {
            this.selectedDeviceIndex = this.devices.findIndex(function (e) {
                return e.id == newVal.id;
            });
            this.loadNewDataset();
        }
    },
    data: function data() {
        var dateWeekAgoTemp = new Date();
        dateWeekAgoTemp.setDate(dateWeekAgoTemp.getDate() - 7);
        dateWeekAgoTemp = new Date(dateWeekAgoTemp.getFullYear(), dateWeekAgoTemp.getMonth(), dateWeekAgoTemp.getDate());

        return {
            sciChartSurface: null,
            wasmContext: null,
            yAxis: null,
            init: false,

            dateWeekAgo: dateWeekAgoTemp,
            dateFrom: dateWeekAgoTemp,
            dateTo: new Date(),
            data: [],
            devices: [],
            selectedDevice: {},
            selectedDeviceIndex: 0,
            dataset: [],
            alarmTypes: [],
            tempAllAlarmTypes: [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(this.allAlarmTypes.sort(function (a, b) {
                return a.id - b.id;
            }).reverse())),
            catalogs: ["General", "Blackbox", "Device", "Rapid24h", "Photocells", "Pressure"]
        };
    },

    methods: {
        initSciChart: function initSciChart() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var _ref, sciChartSurface, wasmContext, xAxis, yAxis, alarmTypes, lastRange;

                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return __WEBPACK_IMPORTED_MODULE_3_scichart_Charting_Visuals_SciChartSurface__["SciChartSurface"].create("scichart-root-" + _this.sid);

                            case 2:
                                _ref = _context.sent;
                                sciChartSurface = _ref.sciChartSurface;
                                wasmContext = _ref.wasmContext;


                                _this.sciChartSurface = sciChartSurface;
                                _this.wasmContext = wasmContext;

                                sciChartSurface.applyTheme(_this.chartTheme());

                                xAxis = new __WEBPACK_IMPORTED_MODULE_4_scichart_Charting_Visuals_Axis_NumericAxis__["NumericAxis"](_this.wasmContext, {
                                    axisAlignment: __WEBPACK_IMPORTED_MODULE_5_scichart_types_AxisAlignment__["EAxisAlignment"].Top,
                                    drawMajorBands: true,
                                    majorGridLineStyle: {
                                        color: "#9D9D9D"
                                    }
                                });
                                yAxis = new __WEBPACK_IMPORTED_MODULE_4_scichart_Charting_Visuals_Axis_NumericAxis__["NumericAxis"](_this.wasmContext, { axisAlignment: __WEBPACK_IMPORTED_MODULE_5_scichart_types_AxisAlignment__["EAxisAlignment"].Left });

                                _this.yAxis = yAxis;
                                yAxis.labelProvider.formatLabel = function (dataValue) {
                                    return parseInt(dataValue);
                                };
                                yAxis.maxAutoTicks = _this.allAlarmTypes.length * 2;
                                yAxis.minorsPerMajor = 2;
                                yAxis.visibleRange = new __WEBPACK_IMPORTED_MODULE_13_scichart_Core_NumberRange__["NumberRange"](0, _this.allAlarmTypes.length);

                                if (_this.initialZoomOut == true) {
                                    yAxis.growBy = new __WEBPACK_IMPORTED_MODULE_13_scichart_Core_NumberRange__["NumberRange"](0.03, 0.03);
                                    xAxis.growBy = new __WEBPACK_IMPORTED_MODULE_13_scichart_Core_NumberRange__["NumberRange"](0.01, 0.01);
                                }

                                _this.sciChartSurface.xAxes.add(xAxis);
                                _this.sciChartSurface.yAxes.add(yAxis);

                                xAxis.labelProvider.formatLabel = function (dt) {
                                    return __WEBPACK_IMPORTED_MODULE_19_moment___default()(dt).format("DD.MM");
                                };

                                alarmTypes = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(_this.allAlarmTypes.sort(function (a, b) {
                                    return a.id - b.id;
                                })));


                                yAxis.labelProvider.formatLabel = function (val) {
                                    return alarmTypes[val] != undefined ? "" + alarmTypes[val].id : "";
                                };

                                sciChartSurface.annotations.add(new __WEBPACK_IMPORTED_MODULE_17_scichart_Charting_Visuals_Annotations_VerticalLineAnnotation__["VerticalLineAnnotation"]({
                                    labelPlacement: __WEBPACK_IMPORTED_MODULE_18_scichart_types_LabelPlacement__["ELabelPlacement"].Axis,
                                    showLabel: true,
                                    stroke: "Red",
                                    strokeThickness: 2,
                                    x1: Date.now(),
                                    axisLabelFill: "Red",
                                    labelValue: _this.$t("Now")
                                }));

                                _context.next = 24;
                                return _this.populateSciChart(true);

                            case 24:

                                xAxis.autoTicks = false;
                                xAxis.majorDelta = 86400000;
                                xAxis.minorDelta = 17280000;
                                lastRange = 2;


                                xAxis.visibleRangeChanged.subscribe(function (args) {
                                    var rangeDiff = args.visibleRange.max - args.visibleRange.min;

                                    if (rangeDiff / 3600000 <= 6 && lastRange != 0) {
                                        xAxis.majorDelta = 600000;
                                        xAxis.minorDelta = 120000;
                                        lastRange = 0;

                                        xAxis.labelProvider.formatLabel = function (dt) {
                                            return __WEBPACK_IMPORTED_MODULE_19_moment___default()(dt).format("DD.MM, HH:mm:ss");
                                        };
                                    } else if (rangeDiff / 3600000 > 6 && rangeDiff / 86400000 <= 2 && lastRange != 1) {
                                        xAxis.majorDelta = 3600000;
                                        xAxis.minorDelta = 720000;
                                        lastRange = 1;

                                        xAxis.labelProvider.formatLabel = function (dt) {
                                            return __WEBPACK_IMPORTED_MODULE_19_moment___default()(dt).format("DD.MM, HH:mm:ss");
                                        };
                                    } else if (rangeDiff / 86400000 > 2 && lastRange != 2) {
                                        xAxis.majorDelta = 86400000;
                                        xAxis.minorDelta = 17280000;
                                        lastRange = 2;

                                        xAxis.labelProvider.formatLabel = function (dt) {
                                            return __WEBPACK_IMPORTED_MODULE_19_moment___default()(dt).format("DD.MM");
                                        };
                                    }
                                });

                            case 29:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        reloadSciChart: function reloadSciChart() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (_this2.sciChartSurface.renderableSeries != null) {
                                    _this2.sciChartSurface.renderableSeries.items = [];
                                }

                                _context2.next = 3;
                                return _this2.populateSciChart(false);

                            case 3:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        },
        populateSciChart: function populateSciChart(init) {
            var _this3 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
                var red, green, from, to, xAlarmTypes;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                red = "#E06C65";
                                green = "#84CA85";
                                from = new Date();

                                from.setDate(from.getDate() - 7);
                                from.setHours(0, 0, 0);

                                to = new Date();
                                xAlarmTypes = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(_this3.allAlarmTypes.sort(function (a, b) {
                                    return a.id - b.id;
                                })));


                                xAlarmTypes.forEach(function (at, index) {
                                    var greenLineSeries = new __WEBPACK_IMPORTED_MODULE_6_scichart_Charting_Visuals_RenderableSeries_FastLineRenderableSeries__["FastLineRenderableSeries"](_this3.wasmContext, {
                                        dataSeries: new __WEBPACK_IMPORTED_MODULE_7_scichart_Charting_Model_XyDataSeries__["XyDataSeries"](_this3.wasmContext, {
                                            xValues: [from, to],
                                            yValues: [index, index]
                                        }),
                                        stroke: green,
                                        strokeThickness: 10
                                    });

                                    _this3.sciChartSurface.renderableSeries.add(greenLineSeries);
                                });

                                _this3.dataset.forEach(function (el) {
                                    var alarmType = el.item1;
                                    var alarms = el.item2;

                                    var value = xAlarmTypes.findIndex(function (at) {
                                        return at.id == alarmType;
                                    });

                                    if (value == -1) {
                                        return;
                                    }

                                    var filtered = alarms.sort(function (a, b) {
                                        return new Date(b.createDate) - new Date(a.createDate);
                                    });

                                    var alarmDates = filtered.flatMap(function (x) {
                                        return [new Date(x.createDate) < from ? from.getTime() - 1 : new Date(x.createDate).getTime() - 1, new Date(x.createDate) < from ? from.getTime() : new Date(x.createDate).getTime(), new Date(x.endDate) > new Date(to) ? to.getTime() : new Date(x.endDate).getTime(), new Date(x.endDate) > new Date(to) ? to.getTime() + 1 : new Date(x.endDate).getTime() + 1];
                                    });
                                    var alarmValues = filtered.flatMap(function (_) {
                                        return [NaN, value, value, NaN];
                                    });

                                    var redLineSeries = new __WEBPACK_IMPORTED_MODULE_6_scichart_Charting_Visuals_RenderableSeries_FastLineRenderableSeries__["FastLineRenderableSeries"](_this3.wasmContext, {
                                        dataSeries: new __WEBPACK_IMPORTED_MODULE_7_scichart_Charting_Model_XyDataSeries__["XyDataSeries"](_this3.wasmContext, {
                                            xValues: alarmDates,
                                            yValues: alarmValues
                                        }),
                                        drawNaNAs: __WEBPACK_IMPORTED_MODULE_16_scichart_Charting_Drawing_WebGlRenderContext2D__["ELineDrawMode"].DiscontinuousLine,
                                        stroke: red,
                                        strokeThickness: 15
                                    });

                                    _this3.sciChartSurface.renderableSeries.add(redLineSeries);
                                });

                                if (init) {
                                    if (_this3.zoomBySelection == true) _this3.sciChartSurface.chartModifiers.add(new __WEBPACK_IMPORTED_MODULE_10_scichart_Charting_ChartModifiers_RubberBandXyZoomModifier__["RubberBandXyZoomModifier"]({ xyDirection: __WEBPACK_IMPORTED_MODULE_15_scichart_types_XyDirection__["EXyDirection"].XDirection }));
                                    if (_this3.pan != false) _this3.sciChartSurface.chartModifiers.add(new __WEBPACK_IMPORTED_MODULE_8_scichart_Charting_ChartModifiers_ZoomPanModifier__["ZoomPanModifier"]({ xyDirection: __WEBPACK_IMPORTED_MODULE_15_scichart_types_XyDirection__["EXyDirection"].XDirection }));
                                    if (_this3.zoom != false) _this3.sciChartSurface.chartModifiers.add(new __WEBPACK_IMPORTED_MODULE_11_scichart_Charting_ChartModifiers_ZoomExtentsModifier__["ZoomExtentsModifier"]({ xyDirection: __WEBPACK_IMPORTED_MODULE_15_scichart_types_XyDirection__["EXyDirection"].XDirection }));
                                    if (_this3.mouseZoom != false) _this3.sciChartSurface.chartModifiers.add(new __WEBPACK_IMPORTED_MODULE_9_scichart_Charting_ChartModifiers_MouseWheelZoomModifier__["MouseWheelZoomModifier"]({ xyDirection: __WEBPACK_IMPORTED_MODULE_15_scichart_types_XyDirection__["EXyDirection"].XDirection }));

                                    _this3.sciChartSurface.chartModifiers.add(new __WEBPACK_IMPORTED_MODULE_14_scichart_Charting_ChartModifiers_CursorModifier__["CursorModifier"]({
                                        crosshairStroke: "#0095B2",
                                        crosshairStrokeThickness: 1,
                                        tooltipContainerBackground: "#000",
                                        tooltipTextStroke: "#0095B2",
                                        showTooltip: false,
                                        axisLabelFill: "#0095B2",
                                        axisLabelStroke: "#fff"
                                    }));
                                }

                                _this3.sciChartSurface.zoomExtents();

                            case 11:
                            case "end":
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this3);
            }))();
        },
        dateChanged: function dateChanged(dateFrom, dateTo) {
            if (this.init == false) {
                return;
            }
            this.dateFrom = dateFrom;
            this.dateTo = dateTo;

            this.loadNewDataset();
        },
        loadNewDataset: function loadNewDataset() {
            var _this4 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _this4.$emit('spin', true);
                                _context4.next = 3;
                                return Object(__WEBPACK_IMPORTED_MODULE_22__api_api__["_31" /* getLastWeekAlarmsForSystemPerDevice */])(_this4.selectedDevice.id, _this4.dateFrom.toISOString(), _this4.dateTo.toISOString());

                            case 3:
                                _this4.dataset = _context4.sent;


                                _this4.reloadSciChart();
                                _this4.$emit('spin', false);

                            case 6:
                            case "end":
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this4);
            }))();
        },
        getDevices: function getDevices() {
            var _this5 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return Object(__WEBPACK_IMPORTED_MODULE_21__api__["_26" /* getDevicesForSystem */])(_this5.systemId, _this5.dateFrom, _this5.dateTo);

                            case 2:
                                _this5.devices = _context5.sent;

                                _this5.devices = _this5.devices.sort(function (a, b) {
                                    return a.number - b.number;
                                });

                                if (_this5.deviceObj !== undefined) {
                                    _this5.selectedDevice = _this5.devices[_this5.devices.findIndex(function (x) {
                                        return x.id === _this5.deviceObj.deviceId;
                                    })];
                                } else {
                                    _this5.selectedDevice = _this5.devices[0];
                                }

                                _this5.loadNewDataset();

                            case 6:
                            case "end":
                                return _context5.stop();
                        }
                    }
                }, _callee5, _this5);
            }))();
        }
    },
    mounted: function () {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
                while (1) {
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            this.getDevices();
                            _context6.next = 3;
                            return this.initSciChart();

                        case 3:
                            this.init = true;

                        case 4:
                        case "end":
                            return _context6.stop();
                    }
                }
            }, _callee6, this);
        }));

        function mounted() {
            return _ref2.apply(this, arguments);
        }

        return mounted;
    }(),
    beforeDestroy: function () {
        var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
                while (1) {
                    switch (_context7.prev = _context7.next) {
                        case 0:
                            if (this.sciChartSurface || this.wasmContext) {
                                this.sciChartSurface = null;
                                this.wasmContext = null;
                            }
                            this.sciChartSurface = null;
                            this.wasmContext = null;

                        case 3:
                        case "end":
                            return _context7.stop();
                    }
                }
            }, _callee7, this);
        }));

        function beforeDestroy() {
            return _ref3.apply(this, arguments);
        }

        return beforeDestroy;
    }()
});

/***/ }),

/***/ 1674:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(1548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_api__ = __webpack_require__(952);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	name: "DevicesSelect",
	props: {
		systemId: {
			type: String,
			required: true
		},
		preSelectedDevice: {
			type: Object,
			required: false,
			default: null
		},
		preLoadedDevices: {
			type: Array,
			required: false,
			default: null
		},
		dateFrom: {
			type: Date,
			required: true
		},
		dateTo: {
			type: Date,
			required: true
		}
	},
	data: function data() {
		return {
			devices: [],
			selectedDevice: {},
			modalState: false,
			selectedDeviceIndex: 0
		};
	},

	watch: {
		dateFrom: function dateFrom(newVal, oldVal) {
			this.getData();
		},
		dateTo: function dateTo(newVal, oldVal) {
			this.getData();
		}
	},
	methods: {
		getData: function getData() {
			var _this = this;

			return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
				var devs;
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								if (!(_this.preLoadedDevices == null || _this.preLoadedDevices.length === 0 || _this.selectedDevice.id !== undefined)) {
									_context.next = 7;
									break;
								}

								_context.next = 3;
								return Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["_26" /* getDevicesForSystem */])(_this.systemId, _this.dateFrom, _this.dateTo);

							case 3:
								devs = _context.sent;

								_this.devices = devs.sort(function (a, b) {
									return a.number - b.number;
								});
								_context.next = 8;
								break;

							case 7:
								_this.devices = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(_this.preLoadedDevices));

							case 8:

								if (_this.selectedDevice.id === undefined) {
									_this.selectedDevice = _this.preSelectedDevice == null ? _this.devices[0] : _this.devices[_this.devices.findIndex(function (x) {
										return x.id == _this.preSelectedDevice.deviceId;
									})];
								} else {
									_this.selectedDevice = _this.devices[_this.devices.findIndex(function (x) {
										return x.id == _this.selectedDevice.id;
									})];
								}

								_this.selectedDeviceIndex = _this.devices.findIndex(function (x) {
									return x.id == _this.selectedDevice.id;
								});

							case 10:
							case "end":
								return _context.stop();
						}
					}
				}, _callee, _this);
			}))();
		},
		changeSelection: function changeSelection(selection) {
			var _this2 = this;

			this.selectedDevice = selection;
			this.selectedDeviceIndex = this.devices.findIndex(function (x) {
				return x.id == _this2.selectedDevice.id;
			});
			this.$emit('deviceChanged', this.selectedDevice);
			this.modalState = false;
		},
		changeModalState: function changeModalState(args) {
			this.modalState = !this.modalState;
		}
	},
	mounted: function () {
		var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
				while (1) {
					switch (_context2.prev = _context2.next) {
						case 0:
							_context2.next = 2;
							return this.getData();

						case 2:
						case "end":
							return _context2.stop();
					}
				}
			}, _callee2, this);
		}));

		function mounted() {
			return _ref.apply(this, arguments);
		}

		return mounted;
	}()
});

/***/ }),

/***/ 1675:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAANCAYAAABlyXS1AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAD2SURBVHgBXZC/agJBEMZn91YCIQHzBhJCCPlHHuHsLI6w6S7JhZxv4BuoT+AjaKfYeIKNlb6BomKhFlda2sp5jjPqyeoUM9/ub2Z2+QRcRM51MymZ6rGWJrC1TiupWgCYAdyCMuHt9U2VygcghhbG2dPk5+9fhYpOQNBohHvo/HhFRCyQXFkCvxjwvWIgAEp8wE2cD5r1YbJNJoBQrdOsB+YfJAKUD1L4juvZJrRm41H/8e1d0Aabkn54eu3Op+PlHnI6Ntxxg7Rk7v7lub2YTFbCXON8ezWa/qcnwmgbZc8cUleqQN1DdogtPJvk0L6fjtfRgPUOsgdRDfZAdk8AAAAASUVORK5CYII="

/***/ }),

/***/ 1676:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAANCAYAAABlyXS1AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADESURBVHgBbZCxDcIwEEV9yQIZwUpDoAobJD0STkfLBowQJkAsAg4dDYQN6AhVPEIm4PgOBjkoJ53Pp3f3T/qUL4tWIJh4XmvdCS8CVyUxXTOlogHERo5qkGnAwc6HoWmaTk6TigQp9Fk8mUXt83HuoX3cwA0DK0H9gMAAei9wM7O37R+1DH0IBRMniQRKrcJwc6EUhXT8bPKWPMnUSUYWXE66JAekA6i8B9j02z5gQbquDsXPhC9A3gW91mP2GThV/Hv7BuPwT14oXXSfAAAAAElFTkSuQmCC"

/***/ }),

/***/ 1679:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SystemStatus_vue__ = __webpack_require__(1610);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bf82026_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SystemStatus_vue__ = __webpack_require__(1685);
function injectStyle (ssrContext) {
  __webpack_require__(1680)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6bf82026"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SystemStatus_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bf82026_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SystemStatus_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1680:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1681);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("27df4406", content, true, {});

/***/ }),

/***/ 1681:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".the-thing[data-v-6bf82026]{border:1px solid #3eae94;height:16px;width:8px;border-radius:2px;background-color:#3cd6b1;cursor:pointer}.the-thing-title[data-v-6bf82026]{font-family:SourceSansProBold,sans-serif;font-size:8px;font-style:normal;font-weight:600;color:#414f51}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/Systems/SystemStatus.vue"],"names":[],"mappings":"AACA,4BACI,yBAA0B,AAC1B,YAAa,AACb,UAAW,AACX,kBAAmB,AACnB,yBAA0B,AAC1B,cAAgB,CACnB,AACD,kCACI,yCAA6C,AAC7C,cAAe,AACf,kBAAmB,AACnB,gBAAiB,AACjB,aAAe,CAClB","file":"SystemStatus.vue","sourcesContent":["\n.the-thing[data-v-6bf82026] {\n    border: 1px solid #3EAE94;\n    height: 16px;\n    width: 8px;\n    border-radius: 2px;\n    background-color: #3CD6B1;\n    cursor: pointer;\n}\n.the-thing-title[data-v-6bf82026] {\n    font-family: \"SourceSansProBold\", sans-serif;\n    font-size: 8px;\n    font-style: normal;\n    font-weight: 600;\n    color: #414F51;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1682:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1683);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("275ed762", content, true, {});

/***/ }),

/***/ 1683:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".system-modal[data-v-b04b559a]{z-index:999;display:block}.modal-header[data-v-b04b559a]{background-color:#34758e;width:100%;font-family:SourceSansProBold,sans-serif;font-size:12px;font-style:normal;font-weight:600;color:#fff}.title[data-v-b04b559a]{width:200px;font-family:SourceSansProSemiBold,sans-serif!important;font-weight:700;font-size:14px;margin:0}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/Systems/TooltipSystemStatus.vue"],"names":[],"mappings":"AACA,+BACI,YAAa,AACb,aAAe,CAClB,AACD,+BACI,yBAA2B,AAC3B,WAAY,AACZ,yCAA6C,AAC7C,eAAgB,AAChB,kBAAmB,AACnB,gBAAiB,AACjB,UAAa,CAChB,AACD,wBACI,YAAa,AACb,uDAA4D,AAC5D,gBAAkB,AAClB,eAAgB,AAChB,QAAU,CACb","file":"TooltipSystemStatus.vue","sourcesContent":["\n.system-modal[data-v-b04b559a] {\n    z-index: 999;\n    display: block;\n}\n.modal-header[data-v-b04b559a] {\n    background-color:  #34758E;\n    width: 100%;\n    font-family: \"SourceSansProBold\", sans-serif;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 600;\n    color: white;\n}\n.title[data-v-b04b559a] {\n    width: 200px;\n    font-family: 'SourceSansProSemiBold', sans-serif !important;\n    font-weight: bold;\n    font-size: 14px;\n    margin: 0;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1684:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"system-modal flex-container",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }return _vm.$emit('close')}}},[_c('div',{staticClass:"modal-content vertical",staticStyle:{"width":"280px"}},[_c('div',{staticClass:"modal-header"},[(_vm.title != undefined)?_c('p',{staticClass:"title"},[_vm._v(" "+_vm._s(((_vm.$t('Status')) + " " + (_vm.activeObject.systemName) + " (" + (_vm.activeDay == 0 ? _vm.$t('today') : _vm.activeDay + ' ' + _vm.$t('daysAgo')) + ")"))+" ")]):_vm._e(),_vm._v(" "),_c('div',{attrs:{"id":"mdiv"},on:{"click":function($event){return _vm.$emit('close')}}},[_vm._m(0)])]),_vm._v(" "),_c('div',{staticClass:"modal-slot vertical"},[_c('div',{staticClass:"horizontal",staticStyle:{"border-bottom":"1px solid #E9E9E9","justify-content":"space-between","padding-left":"10px","padding-right":"10px"}},[_c('div',{staticStyle:{"font-weight":"bold","font-size":"14px"}},[_vm._v(" "+_vm._s(_vm.$t('BlackBox'))+" ")]),_vm._v(" "),_c('div',[(_vm.blackBox == 0)?_c('img',{attrs:{"src":__webpack_require__(1566)}}):(_vm.blackBox == 1)?_c('img',{attrs:{"src":__webpack_require__(1567)}}):(_vm.blackBox == 2)?_c('img',{attrs:{"src":__webpack_require__(1568)}}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"horizontal",staticStyle:{"border-bottom":"1px solid #E9E9E9","justify-content":"space-between","padding-left":"10px","padding-right":"10px"}},[_c('div',{staticStyle:{"font-weight":"bold","font-size":"14px"}},[_vm._v(_vm._s(_vm.$t('Device')))]),_vm._v(" "),_c('div',[(_vm.device == 0)?_c('img',{attrs:{"src":__webpack_require__(1566)}}):(_vm.device == 1)?_c('img',{attrs:{"src":__webpack_require__(1567)}}):(_vm.device == 2)?_c('img',{attrs:{"src":__webpack_require__(1568)}}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"horizontal",staticStyle:{"border-bottom":"1px solid #E9E9E9","justify-content":"space-between","padding-left":"10px","padding-right":"10px"}},[_c('div',{staticStyle:{"font-weight":"bold","font-size":"14px"}},[_vm._v(_vm._s(_vm.$t('Rapid24h')))]),_vm._v(" "),_c('div',[(_vm.rapid24 == 0)?_c('img',{attrs:{"src":__webpack_require__(1566)}}):(_vm.rapid24 == 1)?_c('img',{attrs:{"src":__webpack_require__(1567)}}):(_vm.rapid24 == 2)?_c('img',{attrs:{"src":__webpack_require__(1568)}}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"horizontal",staticStyle:{"border-bottom":"1px solid #E9E9E9","justify-content":"space-between","padding-left":"10px","padding-right":"10px"}},[_c('div',{staticStyle:{"font-weight":"bold","font-size":"14px"}},[_vm._v(_vm._s(_vm.$t('Photocells')))]),_vm._v(" "),_c('div',[(_vm.photocells == 0)?_c('img',{attrs:{"src":__webpack_require__(1566)}}):(_vm.photocells == 1)?_c('img',{attrs:{"src":__webpack_require__(1567)}}):(_vm.photocells == 2)?_c('img',{attrs:{"src":__webpack_require__(1568)}}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"horizontal",staticStyle:{"border-bottom":"1px solid #E9E9E9","justify-content":"space-between","padding-left":"10px","padding-right":"10px"}},[_c('div',{staticStyle:{"font-weight":"bold","font-size":"14px"}},[_vm._v(_vm._s(_vm.$t('Pressure')))]),_vm._v(" "),_c('div',[(_vm.pressure == 0)?_c('img',{attrs:{"src":__webpack_require__(1566)}}):(_vm.pressure == 1)?_c('img',{attrs:{"src":__webpack_require__(1567)}}):(_vm.pressure == 2)?_c('img',{attrs:{"src":__webpack_require__(1568)}}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"horizontal",staticStyle:{"border-bottom":"1px solid #E9E9E9","justify-content":"space-between","padding-left":"10px","padding-right":"10px"}},[_c('div',{staticStyle:{"font-weight":"bold","font-size":"14px"}},[_vm._v(_vm._s(_vm.$t('Database')))]),_vm._v(" "),_c('div',[(_vm.database == 0)?_c('img',{attrs:{"src":__webpack_require__(1566)}}):(_vm.database == 1)?_c('img',{attrs:{"src":__webpack_require__(1567)}}):(_vm.database == 2)?_c('img',{attrs:{"src":__webpack_require__(1568)}}):_vm._e()])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mdiv"},[_c('div',{staticClass:"md"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1685:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"tip",staticStyle:{"width":"96px"}},[_c('div',{staticClass:"horizontal",staticStyle:{"justify-content":"space-between"}},_vm._l((_vm.list),function(day,index){return _c('div',{key:index},[(_vm.data.lastUpdate != undefined && _vm.data.lastUpdate=='0001-01-01T00:00:00')?_c('div',{staticClass:"the-thing",style:('background-color: #AAAAAA; border-color: #7A7A7A; cursor: default;')}):(_vm.calculateAlarmOffDate(7-index, _vm.data))?_c('div',{staticClass:"the-thing",style:('background-color: #f3f3f3; border-color: #e0e0e0; cursor: default;')}):(_vm.calculateDate(7-index, _vm.data))?_c('div',{staticClass:"the-thing",style:('background-color: #AAAAAA; border-color: #7A7A7A; cursor: default;')}):_c('div',{staticClass:"the-thing",style:('background-color: ' + ['#3CD6B1', '#FFBD6D', '#FF6666'][day] + '; border-color: ' + ['#3EAE94', '#C69C65', '#C65F60'][day]),on:{"click":function (args) { return _vm.openInfo(args, day, index); }}})])}),0),_vm._v(" "),_c('div',{staticClass:"horizontal the-thing-title",staticStyle:{"justify-content":"space-between"}},[_c('div',[_vm._v(_vm._s(_vm.$t('7daysAgo')))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.$t('Today')))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1711:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(1548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_scichart_Charting_Visuals_SciChartSurface__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_scichart_Charting_Visuals_SciChartSurface___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_scichart_Charting_Visuals_SciChartSurface__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_scichart_Charting_Visuals_Axis_NumericAxis__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_scichart_Charting_Visuals_Axis_NumericAxis___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_scichart_Charting_Visuals_Axis_NumericAxis__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_scichart_Charting_Visuals_Axis_CategoryAxis__ = __webpack_require__(970);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_scichart_Charting_Visuals_Axis_CategoryAxis___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_scichart_Charting_Visuals_Axis_CategoryAxis__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_scichart_types_AxisAlignment__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_scichart_types_AxisAlignment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_scichart_types_AxisAlignment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_scichart_Charting_Visuals_RenderableSeries_FastLineRenderableSeries__ = __webpack_require__(955);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_scichart_Charting_Visuals_RenderableSeries_FastLineRenderableSeries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_scichart_Charting_Visuals_RenderableSeries_FastLineRenderableSeries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_scichart_Charting_Model_XyDataSeries__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_scichart_Charting_Model_XyDataSeries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_scichart_Charting_Model_XyDataSeries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_scichart_Charting_ChartModifiers_ZoomPanModifier__ = __webpack_require__(959);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_scichart_Charting_ChartModifiers_ZoomPanModifier___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_scichart_Charting_ChartModifiers_ZoomPanModifier__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_scichart_Charting_ChartModifiers_MouseWheelZoomModifier__ = __webpack_require__(957);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_scichart_Charting_ChartModifiers_MouseWheelZoomModifier___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_scichart_Charting_ChartModifiers_MouseWheelZoomModifier__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_scichart_Charting_ChartModifiers_RubberBandXyZoomModifier__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_scichart_Charting_ChartModifiers_RubberBandXyZoomModifier___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_scichart_Charting_ChartModifiers_RubberBandXyZoomModifier__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_scichart_Charting_ChartModifiers_ZoomExtentsModifier__ = __webpack_require__(958);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_scichart_Charting_ChartModifiers_ZoomExtentsModifier___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_scichart_Charting_ChartModifiers_ZoomExtentsModifier__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_chartTheme__ = __webpack_require__(1556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_scichart_Core_NumberRange__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_scichart_Core_NumberRange___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_scichart_Core_NumberRange__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_scichart_Charting_ChartModifiers_RolloverModifier__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_scichart_Charting_ChartModifiers_RolloverModifier___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_scichart_Charting_ChartModifiers_RolloverModifier__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_scichart_Charting_ChartModifiers_CursorModifier__ = __webpack_require__(956);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_scichart_Charting_ChartModifiers_CursorModifier___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_scichart_Charting_ChartModifiers_CursorModifier__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_scichart_Charting_Visuals_PointMarkers_EllipsePointMarker__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_scichart_Charting_Visuals_PointMarkers_EllipsePointMarker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_scichart_Charting_Visuals_PointMarkers_EllipsePointMarker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_scichart_types_XyDirection__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_scichart_types_XyDirection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_scichart_types_XyDirection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_scichart_Charting_Drawing_WebGlRenderContext2D__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_scichart_Charting_Drawing_WebGlRenderContext2D___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_scichart_Charting_Drawing_WebGlRenderContext2D__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_scichart_types_AutoRange__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_scichart_types_AutoRange___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_scichart_types_AutoRange__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_scichart_Charting_Visuals_Annotations_VerticalLineAnnotation__ = __webpack_require__(964);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_scichart_Charting_Visuals_Annotations_VerticalLineAnnotation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_scichart_Charting_Visuals_Annotations_VerticalLineAnnotation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_scichart_types_LabelPlacement__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_scichart_types_LabelPlacement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_scichart_types_LabelPlacement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_scichart_Charting_Visuals_Axis_LabelProvider_LabelProvider__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_scichart_Charting_Visuals_Axis_LabelProvider_LabelProvider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_scichart_Charting_Visuals_Axis_LabelProvider_LabelProvider__);



//
//
//
//
//
//
//
//

























/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_13__utils_chartTheme__["a" /* chartThemeMixin */]],
    props: ['dataset', 'devices', 'name', 'activeSet', 'labelX', 'labelY', 'zoom', 'pan', 'showValues', 'mouseZoom', 'sid', 'initialZoomOut'],
    data: function data() {
        var dateDay = new Date();
        dateDay.setDate(dateDay.getDate() - 7);
        dateDay = new Date(dateDay.getFullYear(), dateDay.getMonth(), dateDay.getDate(), 0, 0, 0);

        var now = new Date();

        return {
            sciChartSurface: null,
            wasmContext: null,
            init: false,
            data: [],
            dateFrom: dateDay,
            dateTo: new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59)
        };
    },

    watch: {
        dataset: function dataset(newVal, oldVal) {
            if (newVal != 0) {
                this.changeDataSet(newVal, false);
            }
        }
    },
    methods: {
        initSciChart: function initSciChart() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
                var _ref, sciChartSurface, wasmContext, xAxis, yAxis, lastLabelRange;

                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return __WEBPACK_IMPORTED_MODULE_3_scichart_Charting_Visuals_SciChartSurface__["SciChartSurface"].create("scichart-root-" + _this.sid);

                            case 2:
                                _ref = _context.sent;
                                sciChartSurface = _ref.sciChartSurface;
                                wasmContext = _ref.wasmContext;


                                _this.sciChartSurface = sciChartSurface;
                                _this.wasmContext = wasmContext;

                                sciChartSurface.applyTheme(_this.chartTheme());

                                xAxis = new __WEBPACK_IMPORTED_MODULE_4_scichart_Charting_Visuals_Axis_NumericAxis__["NumericAxis"](_this.wasmContext, {
                                    axisAlignment: __WEBPACK_IMPORTED_MODULE_6_scichart_types_AxisAlignment__["EAxisAlignment"].Top,
                                    drawMajorBands: true,
                                    majorGridLineStyle: {
                                        color: "#9D9D9D"
                                    }
                                });
                                yAxis = new __WEBPACK_IMPORTED_MODULE_4_scichart_Charting_Visuals_Axis_NumericAxis__["NumericAxis"](_this.wasmContext, { axisAlignment: __WEBPACK_IMPORTED_MODULE_6_scichart_types_AxisAlignment__["EAxisAlignment"].Left });

                                yAxis.labelProvider.formatLabel = function (dataValue) {
                                    return parseInt(dataValue);
                                };
                                yAxis.maxAutoTicks = 2;
                                yAxis.minorsPerMajor = 2;
                                yAxis.visibleRange = new __WEBPACK_IMPORTED_MODULE_14_scichart_Core_NumberRange__["NumberRange"](1, 2);

                                if (_this.initialZoomOut == true) {
                                    yAxis.growBy = new __WEBPACK_IMPORTED_MODULE_14_scichart_Core_NumberRange__["NumberRange"](0.02, 0.02);
                                    xAxis.growBy = new __WEBPACK_IMPORTED_MODULE_14_scichart_Core_NumberRange__["NumberRange"](0.02, 0.02);
                                }

                                _this.sciChartSurface.xAxes.add(xAxis);
                                _this.sciChartSurface.yAxes.add(yAxis);

                                xAxis.labelProvider.formatLabel = function (dt) {
                                    return __WEBPACK_IMPORTED_MODULE_23_moment___default()(dt).format("DD.MM");
                                };

                                yAxis.labelProvider.formatLabel = function (val) {
                                    return _this.name;
                                };

                                sciChartSurface.annotations.add(new __WEBPACK_IMPORTED_MODULE_21_scichart_Charting_Visuals_Annotations_VerticalLineAnnotation__["VerticalLineAnnotation"]({
                                    labelPlacement: __WEBPACK_IMPORTED_MODULE_22_scichart_types_LabelPlacement__["ELabelPlacement"].Axis,
                                    showLabel: true,
                                    stroke: "Red",
                                    strokeThickness: 2,
                                    x1: Date.now(),
                                    axisLabelFill: "Red",
                                    labelValue: _this.$t("Now")
                                }));

                                _context.next = 22;
                                return _this.populateSciChart(true);

                            case 22:

                                xAxis.autoTicks = true;
                                // xAxis.majorDelta= 3600000;
                                // xAxis.minorDelta= 720000;
                                // let lastRange = 3;
                                lastLabelRange = 0;


                                xAxis.visibleRangeChanged.subscribe(function (args) {
                                    var rangeDiff = args.visibleRange.max - args.visibleRange.min;
                                    //     if (rangeDiff/3600000 <= 1 && lastRange != 0) {
                                    //       xAxis.majorDelta= 60000;
                                    //       xAxis.minorDelta= 12000;
                                    //       lastRange = 0;
                                    //     } else if (rangeDiff/3600000 <= 2 && rangeDiff/3600000 >= 1 && lastRange != 1) {
                                    //       xAxis.majorDelta= 600000;
                                    //       xAxis.minorDelta= 120000;
                                    //       lastRange = 1;
                                    //     } else if ( rangeDiff / 3600000 > 2 && rangeDiff / 3600000 <= 6 && lastRange != 2) {
                                    //       xAxis.majorDelta= 1800000;
                                    //       xAxis.minorDelta= 360000;
                                    //       lastRange = 2;
                                    //     } else if (rangeDiff / 3600000 > 6 && lastRange != 3) {
                                    //       xAxis.majorDelta= 3600000;
                                    //       xAxis.minorDelta= 720000;
                                    //       lastRange = 3;
                                    //     }
                                    if (rangeDiff / 86400000 >= 2 && lastLabelRange != 0) {
                                        xAxis.labelProvider.formatLabel = function (dt) {
                                            return __WEBPACK_IMPORTED_MODULE_23_moment___default()(dt).format("DD.MM");
                                        };
                                        lastLabelRange = 0;
                                    } else if (rangeDiff / 86400000 < 2 && lastLabelRange != 1) {
                                        xAxis.labelProvider.formatLabel = function (dt) {
                                            return __WEBPACK_IMPORTED_MODULE_23_moment___default()(dt).format("DD.MM, HH:mm:ss");
                                        };
                                        lastLabelRange = 1;
                                    }
                                });

                            case 25:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        reloadSciChart: function reloadSciChart() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (!(_this2.sciChartSurface != null)) {
                                    _context2.next = 4;
                                    break;
                                }

                                if (_this2.sciChartSurface.renderableSeries != null) {
                                    _this2.sciChartSurface.renderableSeries.items = [];
                                }

                                _context2.next = 4;
                                return _this2.populateSciChart(false);

                            case 4:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        },
        populateSciChart: function populateSciChart(init) {
            var _this3 = this;

            this.data.forEach(function (e, i) {
                var d = [];
                var d2 = [];
                var v = [];
                var v2 = [];
                var value = e.xValues.filter(function (x) {
                    return !isNaN(x);
                })[0];

                if (value == undefined) {
                    value = parseInt(e.title);
                }

                //DF-1
                var c1 = new Date(_this3.dateFrom);
                c1.setSeconds(c1.getSeconds() - 1);
                d2.push(c1);
                if (e.xValues.length != 2) {
                    d2.push(_this3.dateFrom);
                }
                //DTs
                e.yValues.forEach(function (dt, j) {
                    d.push(new Date(__WEBPACK_IMPORTED_MODULE_23_moment___default()(dt, "DD.MM.YYYY HH.mm.ss")));
                    d2.push(new Date(__WEBPACK_IMPORTED_MODULE_23_moment___default()(dt, "DD.MM.YYYY HH.mm.ss")));
                });
                //DT+1
                if (e.xValues.length != 2) {
                    d2.push(_this3.dateTo);
                }
                var e1 = new Date(_this3.dateTo);
                e1.setSeconds(e1.getSeconds() + 1);
                d2.push(e1);

                v2.push(NaN);
                v2.push(value);
                if (e.xValues.length != 2) {
                    e.xValues.forEach(function (val, j) {
                        v.push(val);
                        v2.push(!isNaN(val) ? NaN : value);
                    });
                }
                v2.push(value);
                v2.push(NaN);

                if (v.some(function (x) {
                    return !isNaN(x);
                })) {
                    var dataSeries = new __WEBPACK_IMPORTED_MODULE_8_scichart_Charting_Model_XyDataSeries__["XyDataSeries"](_this3.wasmContext, {
                        xValues: d,
                        yValues: v
                    });

                    dataSeries.dataSeriesName = e.title;

                    var lineSeries = new __WEBPACK_IMPORTED_MODULE_7_scichart_Charting_Visuals_RenderableSeries_FastLineRenderableSeries__["FastLineRenderableSeries"](_this3.wasmContext, {
                        dataSeries: dataSeries,
                        drawNaNAs: __WEBPACK_IMPORTED_MODULE_19_scichart_Charting_Drawing_WebGlRenderContext2D__["ELineDrawMode"].DiscontinuousLine,
                        stroke: '#E06C65',
                        strokeThickness: 15
                    });

                    lineSeries.strokeColor = '#E06C65';
                    lineSeries.rolloverModifierProps.tooltipTitle = e.title;
                    lineSeries.rolloverModifierProps.tooltipTextColor = '#fff';
                    lineSeries.rolloverModifierProps.tooltipColor = e.strokeColor;
                    lineSeries.rolloverModifierProps.tooltipLabelX = _this3.labelX ? _this3.labelX : "X";
                    _this3.sciChartSurface.renderableSeries.add(lineSeries);
                }

                d2 = d2.sort(function (a, b) {
                    return new Date(a) - new Date(b);
                });

                var greenDataSeries = new __WEBPACK_IMPORTED_MODULE_8_scichart_Charting_Model_XyDataSeries__["XyDataSeries"](_this3.wasmContext, {
                    xValues: d2,
                    yValues: v2
                });

                greenDataSeries.dataSeriesName = e.title;

                var lineSeries2 = new __WEBPACK_IMPORTED_MODULE_7_scichart_Charting_Visuals_RenderableSeries_FastLineRenderableSeries__["FastLineRenderableSeries"](_this3.wasmContext, {
                    drawNaNAs: __WEBPACK_IMPORTED_MODULE_19_scichart_Charting_Drawing_WebGlRenderContext2D__["ELineDrawMode"].DiscontinuousLine,
                    stroke: '#84CA85',
                    strokeThickness: 10
                });

                lineSeries2.dataSeries = greenDataSeries;

                _this3.sciChartSurface.renderableSeries.add(lineSeries2);
            });

            if (init) {
                if (this.zoomBySelection == true) this.sciChartSurface.chartModifiers.add(new __WEBPACK_IMPORTED_MODULE_11_scichart_Charting_ChartModifiers_RubberBandXyZoomModifier__["RubberBandXyZoomModifier"]({ xyDirection: __WEBPACK_IMPORTED_MODULE_18_scichart_types_XyDirection__["EXyDirection"].XDirection }));
                if (this.pan != false) this.sciChartSurface.chartModifiers.add(new __WEBPACK_IMPORTED_MODULE_9_scichart_Charting_ChartModifiers_ZoomPanModifier__["ZoomPanModifier"]({ xyDirection: __WEBPACK_IMPORTED_MODULE_18_scichart_types_XyDirection__["EXyDirection"].XDirection }));
                if (this.zoom != false) this.sciChartSurface.chartModifiers.add(new __WEBPACK_IMPORTED_MODULE_12_scichart_Charting_ChartModifiers_ZoomExtentsModifier__["ZoomExtentsModifier"]({ xyDirection: __WEBPACK_IMPORTED_MODULE_18_scichart_types_XyDirection__["EXyDirection"].XDirection }));
                if (this.mouseZoom != false) this.sciChartSurface.chartModifiers.add(new __WEBPACK_IMPORTED_MODULE_10_scichart_Charting_ChartModifiers_MouseWheelZoomModifier__["MouseWheelZoomModifier"]({ xyDirection: __WEBPACK_IMPORTED_MODULE_18_scichart_types_XyDirection__["EXyDirection"].XDirection }));

                this.sciChartSurface.chartModifiers.add(new __WEBPACK_IMPORTED_MODULE_16_scichart_Charting_ChartModifiers_CursorModifier__["CursorModifier"]({
                    crosshairStroke: "#0095B2",
                    crosshairStrokeThickness: 1,
                    tooltipContainerBackground: "#000",
                    tooltipTextStroke: "#0095B2",
                    showTooltip: false,
                    axisLabelFill: "#0095B2",
                    axisLabelStroke: "#fff"
                }));
            }

            this.sciChartSurface.zoomExtents();
        },
        changeDataSet: function changeDataSet(index, init) {
            var _this4 = this;

            var set = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.dataset));

            //sort dataset
            set.sort(function (a, b) {
                return new Date(a.createDate) - new Date(b.createDate);
            });

            var dev = { xValues: [], yValues: [], title: -1 };

            set.forEach(function (e, i) {
                var c1 = new Date(e.createDate);
                c1.setSeconds(c1.getSeconds() - 1);
                dev.yValues.push(c1);
                dev.xValues.push(NaN);

                dev.yValues.push(new Date(e.createDate));

                if (new Date(e.endDate) > _this4.dateTo) {
                    dev.yValues.push(new Date(_this4.dateTo));
                    var e1 = new Date(_this4.dateTo);
                    e1.setSeconds(e1.getSeconds() + 1);
                    dev.yValues.push(e1);
                } else {
                    dev.yValues.push(new Date(e.endDate));
                    var e1 = new Date(e.endDate);
                    e1.setSeconds(e1.getSeconds() + 1);
                    dev.yValues.push(e1);
                }

                dev.xValues.push(1);
                dev.xValues.push(1);

                dev.xValues.push(NaN);
            });

            dev.title = 1;

            this.data = [];
            this.data.push(dev);
            if (init == false) {
                this.reloadSciChart();
            }
        }
    },
    mounted: function () {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            if (!(this.dataset.length == 0)) {
                                _context3.next = 5;
                                break;
                            }

                            _context3.next = 3;
                            return this.initSciChart();

                        case 3:
                            this.init = true;
                            return _context3.abrupt("return");

                        case 5:
                            this.changeDataSet(this.activeSet, true);
                            _context3.next = 8;
                            return this.initSciChart();

                        case 8:
                            this.init = true;

                        case 9:
                        case "end":
                            return _context3.stop();
                    }
                }
            }, _callee3, this);
        }));

        function mounted() {
            return _ref2.apply(this, arguments);
        }

        return mounted;
    }(),
    beforeDestroy: function () {
        var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            if (this.sciChartSurface || this.wasmContext) {
                                this.sciChartSurface = null;
                                this.wasmContext = null;
                            }
                            this.sciChartSurface = null;
                            this.wasmContext = null;

                        case 3:
                        case "end":
                            return _context4.stop();
                    }
                }
            }, _callee4, this);
        }));

        function beforeDestroy() {
            return _ref3.apply(this, arguments);
        }

        return beforeDestroy;
    }()
});

/***/ }),

/***/ 1712:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SciChartPerDevice_vue__ = __webpack_require__(1673);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7535c33a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SciChartPerDevice_vue__ = __webpack_require__(1721);
function injectStyle (ssrContext) {
  __webpack_require__(1713)
  __webpack_require__(1715)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7535c33a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SciChartPerDevice_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7535c33a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SciChartPerDevice_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1713:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1714);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("6284adc4", content, true, {});

/***/ }),

/***/ 1714:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".tippy-popper[x-placement^=right] .tippy-tooltip.customTheme-theme .tippy-arrow{border-right:8px solid #346f8b}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/Charts/SciChartPerDevice.vue"],"names":[],"mappings":"AACA,gFACC,8BAAgC,CAChC","file":"SciChartPerDevice.vue","sourcesContent":["\n.tippy-popper[x-placement^=right] .tippy-tooltip.customTheme-theme .tippy-arrow {\n\tborder-right: 8px solid #346F8B;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1715:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1716);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("7f7b4300", content, true, {});

/***/ }),

/***/ 1716:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".info-field-title[data-v-7535c33a]{font-style:normal;font-weight:600;font-size:12px;line-height:16px;padding-right:20px;color:#272727;margin:0}.info-field-row[data-v-7535c33a]{width:100%;margin:0;padding-bottom:5px}.info-field-value[data-v-7535c33a]{font-style:normal;font-weight:400;font-size:12px;line-height:16px;color:#272727}select[data-v-7535c33a]{padding:5px;width:100%}select[data-v-7535c33a]:focus{outline:none;border-bottom:1px solid #0095b2}option[data-v-7535c33a]{padding:4px}option[data-v-7535c33a]:checked{background:#347c93;color:#fff}.alarms[data-v-7535c33a]{max-width:300px;font-size:12px;white-space:nowrap;margin-bottom:20px;overflow:hidden;text-overflow:ellipsis;margin-top:45px;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;text-align:right}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/Charts/SciChartPerDevice.vue"],"names":[],"mappings":"AACA,mCACI,kBAAmB,AACnB,gBAAiB,AACjB,eAAgB,AAChB,iBAAkB,AAElB,mBAAoB,AACpB,cAAe,AACf,QAAU,CACb,AACD,iCACI,WAAY,AACZ,SAAU,AACV,kBAAoB,CACvB,AACD,mCACI,kBAAmB,AACnB,gBAAoB,AACpB,eAAgB,AAChB,iBAAkB,AAElB,aAAe,CAClB,AACD,wBAEI,YAAa,AACb,UAAY,CACf,AACD,8BACI,aAAc,AACd,+BAAiC,CACpC,AACD,wBACI,WAAa,CAChB,AACD,gCACI,mBAAoB,AACpB,UAAa,CAChB,AACD,yBACC,gBAAiB,AACjB,eAAgB,AAChB,mBAAoB,AACpB,mBAAoB,AACpB,gBAAiB,AACjB,uBAAwB,AACxB,gBAAiB,AACjB,yBAA0B,AACtB,sBAAuB,AACnB,8BAA+B,AACvC,gBAAkB,CAClB","file":"SciChartPerDevice.vue","sourcesContent":["\n.info-field-title[data-v-7535c33a] {\n    font-style: normal;\n    font-weight: 600;\n    font-size: 12px;\n    line-height: 16px;\n\n    padding-right: 20px;\n    color: #272727;\n    margin: 0;\n}\n.info-field-row[data-v-7535c33a] {\n    width: 100%;\n    margin: 0;\n    padding-bottom: 5px;\n}\n.info-field-value[data-v-7535c33a] {\n    font-style: normal;\n    font-weight: normal;\n    font-size: 12px;\n    line-height: 16px;\n\n    color: #272727;\n}\nselect[data-v-7535c33a] {\n    /* border: none; */\n    padding: 5px;\n    width: 100%;\n}\nselect[data-v-7535c33a]:focus {\n    outline: none;\n    border-bottom: 1px solid #0095b2;\n}\noption[data-v-7535c33a] {\n    padding: 4px;\n}\noption[data-v-7535c33a]:checked {\n    background: #347C93;\n    color: white;\n}\n.alarms[data-v-7535c33a] {\n\tmax-width: 300px;\n\tfont-size: 12px;\n\twhite-space: nowrap;\n\tmargin-bottom: 20px;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\tmargin-top: 45px;\n\t-webkit-box-pack: justify;\n\t    -ms-flex-pack: justify;\n\t        justify-content: space-between;\n\ttext-align: right;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1717:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DevicesSelect_vue__ = __webpack_require__(1674);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4382d716_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DevicesSelect_vue__ = __webpack_require__(1720);
function injectStyle (ssrContext) {
  __webpack_require__(1718)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4382d716"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DevicesSelect_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4382d716_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DevicesSelect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1718:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1719);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("3befff28", content, true, {});

/***/ }),

/***/ 1719:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".select-device[data-v-4382d716]{border:1px solid #ccc;border-radius:5px;padding:0 20px;width:100px;height:34px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;color:#555;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.08);box-shadow:inset 0 1px 1px rgba(0,0,0,.08)}.select-device[data-v-4382d716]:hover{border:1px solid #007d95;cursor:pointer}.devices-dropdown-container[data-v-4382d716]{position:fixed;z-index:1;background-color:#f5f5f5;-webkit-box-shadow:0 4px 10px 0 rgba(0,0,0,.2);box-shadow:0 4px 10px 0 rgba(0,0,0,.2);border-radius:5px;width:450px;max-height:50vh;overflow-y:auto}.devices-dropdown-grid[data-v-4382d716]{display:grid;grid-template-columns:repeat(6,auto);margin:10px}.device-card[data-v-4382d716]{padding:5px;height:30px;margin:5px;-webkit-box-shadow:0 4px 5px 0 rgba(0,0,0,.1);box-shadow:0 4px 5px 0 rgba(0,0,0,.1);-ms-flex-item-align:center;text-align:center;border-radius:5px;border:1px #fff;cursor:pointer;background-color:#3cd6b1}.device-card[data-v-4382d716]:hover{background-color:rgba(0,125,149,.1)}.selected-device[data-v-4382d716]{background-image:-webkit-gradient(linear,left top,left bottom,color-stop(0,rgba(0,0,0,.4)));background-image:linear-gradient(rgba(0,0,0,.4) 0 0);color:#fff}.critical-alarm[data-v-4382d716]{background-color:#f66}.mid-low-alarm[data-v-4382d716]{background-color:#ffbd6d}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/Filters/DevicesSelect.vue"],"names":[],"mappings":"AACA,gCACC,sBAAuB,AACvB,kBAAmB,AACnB,eAAgB,AAChB,YAAa,AACb,YAAa,AACb,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,WAAY,AACZ,mDAAuD,AAC/C,0CAA+C,CACvD,AACD,sCACC,yBAAuC,AACvC,cAAgB,CAChB,AACD,6CACC,eAAgB,AAChB,UAAW,AACX,yBAAyC,AACzC,+CAAoD,AAC5C,uCAA4C,AACpD,kBAAmB,AACnB,YAAa,AACb,gBAAiB,AACjB,eAAiB,CACjB,AACD,wCACC,aAAc,AACd,qCAAuC,AACvC,WAAa,CACb,AACD,8BACC,YAAa,AACb,YAAa,AACb,WAAgB,AAChB,8CAAmD,AAC3C,sCAA2C,AACnD,2BAA4B,AAC5B,kBAAmB,AACnB,kBAAmB,AACnB,gBAAkB,AAClB,eAAgB,AAChB,wBAA0B,CAE1B,AACD,oCACC,mCAAyC,CACzC,AACD,kCACE,4FAAqG,AACrG,qDAA0D,AAC3D,UAAa,CACb,AACD,iCACC,qBAA0B,CAC1B,AACD,gCACC,wBAA0B,CAC1B","file":"DevicesSelect.vue","sourcesContent":["\n.select-device[data-v-4382d716] {\n\tborder: solid 1px #ccc;\n\tborder-radius: 5px;\n\tpadding: 0 20px;\n\twidth: 100px;\n\theight: 34px;\n\t-webkit-box-pack: center;\n\t    -ms-flex-pack: center;\n\t        justify-content: center;\n\tcolor: #555;\n\t-webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, .08);\n\t        box-shadow: inset 0 1px 1px rgba(0, 0, 0, .08);\n}\n.select-device[data-v-4382d716]:hover {\n\tborder: solid 1px rgba(0, 125, 149, 1);\n\tcursor: pointer;\n}\n.devices-dropdown-container[data-v-4382d716] {\n\tposition: fixed;\n\tz-index: 1;\n\tbackground-color: rgba(245, 245, 245, 1);\n\t-webkit-box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.2);\n\t        box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.2);\n\tborder-radius: 5px;\n\twidth: 450px;\n\tmax-height: 50vh;\n\toverflow-y: auto;\n}\n.devices-dropdown-grid[data-v-4382d716] {\n\tdisplay: grid;\n\tgrid-template-columns: repeat(6, auto);\n\tmargin: 10px;\n}\n.device-card[data-v-4382d716] {\n\tpadding: 5px;\n\theight: 30px;\n\tmargin: 5px 5px;\n\t-webkit-box-shadow: 0 4px 5px 0 rgba(0, 0, 0, 0.1);\n\t        box-shadow: 0 4px 5px 0 rgba(0, 0, 0, 0.1);\n\t-ms-flex-item-align: center;\n\ttext-align: center;\n\tborder-radius: 5px;\n\tborder: 1px white;\n\tcursor: pointer;\n\tbackground-color: #3CD6B1;\n\t/*font-weight: bolder;*/\n}\n.device-card[data-v-4382d716]:hover {\n\tbackground-color: rgba(0, 125, 149, 0.1);\n}\n.selected-device[data-v-4382d716] {\n  background-image: -webkit-gradient(linear, left top, left bottom, color-stop(0, rgba(0, 0, 0, 0.4)));\n  background-image: linear-gradient(rgba(0, 0, 0, 0.4) 0 0);\n\tcolor: white;\n}\n.critical-alarm[data-v-4382d716] {\n\tbackground-color: #FF6666;\n}\n.mid-low-alarm[data-v-4382d716] {\n\tbackground-color: #FFBD6D;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1720:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"horizontal",staticStyle:{"align-items":"center"}},[_c('div',[(_vm.selectedDeviceIndex !== 0)?_c('div',{staticStyle:{"margin-left":"20px","cursor":"pointer"},on:{"click":function($event){return _vm.changeSelection(_vm.devices[_vm.selectedDeviceIndex - 1])}}},[_vm._m(0)]):_c('div',{staticStyle:{"margin-left":"20px","cursor":"not-allowed"}},[_vm._m(1)])]),_vm._v(" "),_c('div',{staticClass:"horizontal select-device",on:{"click":function($event){return _vm.changeModalState(true)}}},[_c('span',{staticStyle:{"margin":"auto"}},[_vm._v(_vm._s(((_vm.selectedDevice.number) + " (" + (_vm.selectedDevice.numberOfAlarms) + ")")))])]),_vm._v(" "),_c('div',[(_vm.selectedDeviceIndex !== _vm.devices.length - 1)?_c('div',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.changeSelection(_vm.devices[_vm.selectedDeviceIndex + 1])}}},[_vm._m(2)]):_c('div',{staticStyle:{"cursor":"not-allowed"}},[_vm._m(3)])])]),_vm._v(" "),(_vm.modalState)?_c('div',{staticClass:"devices-dropdown-container",attrs:{"id":"devices-dropdown"}},[_c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(function (args) { return _vm.changeModalState(false, args); }),expression:"(args) => changeModalState(false, args)"}],staticClass:"devices-dropdown-grid"},_vm._l((_vm.devices),function(dev){return _c('div',[_c('div',{class:['device-card', { 'mid-low-alarm' : dev.numberOfAlarms > 0 && dev.areCriticalAlarms === false },  { 'critical-alarm' : dev.areCriticalAlarms === true }, { 'selected-device' : dev.id === _vm.selectedDevice.id}],on:{"click":function($event){return _vm.changeSelection(dev)}}},[_c('b',[_vm._v(_vm._s(dev.number))]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"12px"}},[_vm._v("("+_vm._s(dev.numberOfAlarms)+")")])])])}),0)]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin":"0 20px"}},[_c('img',{attrs:{"src":__webpack_require__(1675)}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin":"0 20px"}},[_c('img',{attrs:{"src":__webpack_require__(1675)}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin":"0 20px"}},[_c('img',{attrs:{"src":__webpack_require__(1676)}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin":"0 20px"}},[_c('img',{attrs:{"src":__webpack_require__(1676)}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1721:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"vertical",staticStyle:{"height":"80vh","width":"90vw"}},[_c('div',{staticClass:"horizontal",staticStyle:{"justify-content":"flex-start"}},[_c('div',{staticClass:"info-field horizontal",staticStyle:{"margin":"0 10%"}},[_c('tr',{staticClass:"info-field-row"},[_c('td',{staticClass:"info-field-value",staticStyle:{"padding-left":"5px"}},[_c('datepicker',{attrs:{"dateFrom":_vm.dateFrom,"dateTo":_vm.dateTo,"min":_vm.dateWeekAgo,"max":new Date()},on:{"dateChanged":_vm.dateChanged}})],1)])]),_vm._v(" "),_c('div',{staticClass:"info-field horizontal"},[_c('tr',{staticClass:"info-field-row"},[_c('td',[_c('p',{staticClass:"info-field-title"},[_vm._v(_vm._s(_vm.$t('Device')))])]),_vm._v(" "),_c('td',[_c('devices-select',{attrs:{"system-id":_vm.systemId,"pre-loaded-devices":_vm.devices,"pre-selected-device":_vm.deviceObj,"date-from":_vm.dateFrom,"date-to":_vm.dateTo},on:{"deviceChanged":function (dev) { return _vm.selectedDevice = dev; }}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"horizontal"},[_c('div',{staticClass:"vertical alarms"},_vm._l(([].concat( _vm.tempAllAlarmTypes )),function(alarm){return _c('div',{directives:[{name:"tippy",rawName:"v-tippy",value:({ theme : 'customTheme', placement : 'left', arrow : true, allowHTML: true, content : ("<div style='text-align: left;'><b>(" + (alarm.id) + ") " + (_vm.$t(alarm.description)) + " </b></br></br> " + (alarm.conditions.replaceAll('\n', '</br>')) + "</div>") }),expression:"{ theme : 'customTheme', placement : 'left', arrow : true, allowHTML: true, content : `<div style='text-align: left;'><b>(${alarm.id}) ${$t(alarm.description)} </b></br></br> ${alarm.conditions.replaceAll('\\n', '</br>')}</div>` }"}],key:alarm.id,staticStyle:{"white-space":"nowrap","overflow":"hidden","text-overflow":"ellipsis"}},[_vm._v("\n\t\t\t\t\t\t"+_vm._s(("" + (_vm.$t(alarm.description))))+"\n\t\t\t\t\t")])}),0),_vm._v(" "),_c('div',{staticStyle:{"width":"calc(90vw - 300px)","height":"calc(80vh - 50px)"}},[_c('div',{staticStyle:{"width":"100%","height":"100%","margin-right":"10px","align-self":"center"},attrs:{"id":'scichart-root-' + _vm.sid}})])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1752:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SciChartOneLineAlarmsWeek_vue__ = __webpack_require__(1711);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46d73f44_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SciChartOneLineAlarmsWeek_vue__ = __webpack_require__(1755);
function injectStyle (ssrContext) {
  __webpack_require__(1753)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-46d73f44"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SciChartOneLineAlarmsWeek_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46d73f44_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SciChartOneLineAlarmsWeek_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1753:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1754);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("26610a63", content, true, {});

/***/ }),

/***/ 1754:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"SciChartOneLineAlarmsWeek.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 1755:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"vertical",staticStyle:{"height":"120px","width":"80vw"}},[_c('div',{staticStyle:{"width":"100%","height":"100%","margin-right":"10px","align-self":"center"},attrs:{"id":'scichart-root-' + _vm.sid}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1883:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_grids__ = __webpack_require__(953);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__(952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Systems_SystemStatus__ = __webpack_require__(1679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Modal_vue__ = __webpack_require__(1547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Systems_SystemAlarmsDetailsModal_vue__ = __webpack_require__(1631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_SciChart_vue__ = __webpack_require__(1612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Charts_SciChartOneLineAlarmsWeek_vue__ = __webpack_require__(1752);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Charts_SciChartPerDevice__ = __webpack_require__(1712);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












var context = null;

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    systemName: {
      required: false,
      type: String
    },
    systemId: {
      required: false,
      type: String
    }
  },
  provide: {
    grid: [__WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_grids__["l" /* Sort */], __WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_grids__["i" /* Page */], __WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_grids__["g" /* Filter */], __WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_grids__["m" /* Toolbar */], __WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_grids__["k" /* Search */], __WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_grids__["b" /* CommandColumn */], __WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_grids__["j" /* PdfExport */], __WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_grids__["f" /* ExcelExport */]]
  },
  components: {
    SciChartPerDevice: __WEBPACK_IMPORTED_MODULE_10__components_Charts_SciChartPerDevice__["a" /* default */],
    SystemStatus: __WEBPACK_IMPORTED_MODULE_5__components_Systems_SystemStatus__["a" /* default */],
    Modal: __WEBPACK_IMPORTED_MODULE_6__components_Modal_vue__["a" /* default */],
    SystemAlarmsDetailsModal: __WEBPACK_IMPORTED_MODULE_7__components_Systems_SystemAlarmsDetailsModal_vue__["a" /* default */],
    SciChart: __WEBPACK_IMPORTED_MODULE_8__components_SciChart_vue__["a" /* default */],
    SciChartOneLineAlarmsWeek: __WEBPACK_IMPORTED_MODULE_9__components_Charts_SciChartOneLineAlarmsWeek_vue__["a" /* default */]
  },
  computed: {},
  data: function data() {
    return {
      data: [],
      activeModal: 'NONE',
      activeObject: null,
      activeDay: null,
      activeValue: null,
      allAlarmTypes: [],

      pageSettings: { pageSize: 100, pageSizes: [10, 25, 50, 100] },
      toolbar: [{ text: this.$t('Alarms'), id: 'table-title' }, { text: this.$t('ClearFilter'), id: 'clear-filters', prefixIcon: 'e-cancel', align: 'Right' }, { text: this.$t('Excelexport'), prefixIcon: 'e-excelexport', align: 'Right', id: 'excel-export' }, { text: this.$t('Pdfexport'), prefixIcon: 'e-pdfexport', align: 'Right', id: 'pdf-export' }, { text: this.$t('Csvexport'), prefixIcon: 'e-csvexport', align: 'Right', id: 'csv-export' }, 'Search'],
      wrapSettings: { wrapMode: "Content" },
      selectionOptions: { type: "Multiple" },
      filterOptions: {
        type: "CheckBox"
      },
      customAttributes: { class: "customcss" },
      StatusTemplate: function StatusTemplate() {
        return {
          template: {
            extends: __WEBPACK_IMPORTED_MODULE_5__components_Systems_SystemStatus__["a" /* default */],
            propsData: {
              callback: function callback(data, mode, day, value) {
                context.showModal(data, mode, day, value);
              }
            }
          }
        };
      },
      SciChartTemplate: function SciChartTemplate() {
        return {
          template: __WEBPACK_IMPORTED_MODULE_2_vue__["default"].component("SciChartTemplate", {
            template: "\n              <div style=\"cursor: pointer; margin: 5px\" v-on:click=\"onClick(data)\" content=\"" + context.$t('Details') + "\" v-tippy=\"{ theme : 'customTheme', placement : 'left', arrow : true }\">\n                  <svg width=\"20\" height=\"14\" viewBox=\"0 0 20 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M12.7 7C12.7 8.42016 11.4912 9.57143 10 9.57143C8.50883 9.57143 7.3 8.42016 7.3 7C7.3 5.57984 8.50883 4.42857 10 4.42857C11.4912 4.42857 12.7 5.57984 12.7 7Z\" fill=\"#346F8B\"/><path d=\"M18.905 6.61667C16.9626 2.91687 13.5128 1 10 1C6.48719 1 3.03741 2.91687 1.09502 6.61667C0.968328 6.85798 0.968328 7.14202 1.09502 7.38333C3.03741 11.0831 6.48719 13 10 13C13.5128 13 16.9626 11.0831 18.905 7.38333C19.0317 7.14202 19.0317 6.85798 18.905 6.61667ZM10 11.2857C7.32809 11.2857 4.59825 9.89647 2.91669 7C4.59825 4.10353 7.32809 2.71429 10 2.71429C12.6719 2.71429 15.4018 4.10353 17.0833 7C15.4018 9.89647 12.6719 11.2857 10 11.2857Z\" fill=\"#346F8B\"/></svg>\n              </div>\n            ",
            data: function data() {
              return {
                data: {}
              };
            },

            methods: {
              onClick: function onClick(data) {
                context.showModal(data, 'SCICHART');
              }
            }
          })
        };
      }
    };
  },

  methods: {
    getData: function getData() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.$store.dispatch('set_loading', true);
                _context.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_4__api__["Z" /* getAlarmsOverview */])();

              case 3:
                result = _context.sent;


                _this.data = result.filter(function (x) {
                  return x.systemName == _this.systemName && x.number != 0;
                });

                if (_this.systemName != null) {
                  // this.$refs.grid.filterByColumn(args.currentTarget.id, 'equal', this.systemName)
                  // this.filterOptions.columns.push({ field: 'systemName', matchCase: false, operator: 'equals', value: this.systemName })
                }

                _this.data.forEach(function (el) {
                  el.alarmType = _this.$i18n.t(el.alarmType);
                  el.priority = _this.$i18n.t(el.priority);
                });

                _this.$store.dispatch('set_loading', false);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    showModal: function showModal(data, mode, day, value) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(mode === "SCICHART")) {
                  _context2.next = 4;
                  break;
                }

                // this.activeObject = await getSystemAlarmChartsForWeek(data.systemId, data.alarmTypeId, data.deviceId);
                _this2.activeObject = data;
                _this2.activeModal = mode;
                return _context2.abrupt("return");

              case 4:

                _this2.activeObject = data;
                _this2.activeDay = day;
                _this2.activeValue = value;
                _this2.activeModal = mode;

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    closeModal: function closeModal() {
      this.activeModal = 'NONE';
      this.activeObject = null;
      this.activeDay = null;
      this.activeValue = null;
    },

    dataBound: function dataBound() {
      this.$refs.grid.autoFitColumns();
    },
    toolbarClick: function toolbarClick(args) {
      switch (args.item.id) {
        case "table-alarm-title":
          this.getData();
          break;
        case "table-system-title":
          this.$router.push({
            name: "systems"
          });
          break;
        case "pdf-export":
          this.data.forEach(function (item) {
            item.status.reverse();
          });
          this.$refs.grid.pdfExport();
          break;
        case "csv-export":
          this.data.forEach(function (item) {
            item.status.reverse();
          });
          this.$refs.grid.csvExport();
          break;
        case "excel-export":
          this.data.forEach(function (item) {
            item.status.reverse();
          });
          this.$refs.grid.excelExport();
          break;
        case 'clear-filters':
          this.$refs.grid.clearFiltering();
          break;
      }
    },
    exportComplete: function exportComplete(args) {
      this.data.forEach(function (item) {
        item.status.reverse();
      });
    },
    loadAllAlarmTypes: function loadAllAlarmTypes() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_4__api__["_0" /* getAllAlarmTypes */])();

              case 2:
                _this3.allAlarmTypes = _context3.sent;

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    }
  },
  mounted: function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              context = this;

              this.loadAllAlarmTypes();
              this.getData();

            case 3:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function mounted() {
      return _ref.apply(this, arguments);
    }

    return mounted;
  }()
});

/***/ }),

/***/ 2236:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2237);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("fbfad644", content, true, {});

/***/ }),

/***/ 2237:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".tab-text[data-v-72394d82]{font-size:18px;white-space:nowrap}.unselected[data-v-72394d82]{color:#add4d9}.dismiss-all-button[data-v-72394d82]{white-space:nowrap}.filter-button[data-v-72394d82]{padding:0;padding-left:20px;padding-right:20px}.farm-tab[data-v-72394d82],.filter-button[data-v-72394d82]{background:transparent;border:none;border-right:1px solid #fff}.farm-tab[data-v-72394d82]{padding:24px;padding-bottom:10px;padding-top:10px}.farm-tab[data-v-72394d82]:focus{outline:none}.alarms-headers[data-v-72394d82]{display:-webkit-box;display:-ms-flexbox;display:flex;overflow-x:hidden}.farm-tab[data-v-72394d82]:last-child{border-right:none}.alarms-headers[data-v-72394d82]::-webkit-scrollbar{display:none}.arrow[data-v-72394d82]{background:transparent}.arrow-hint[data-v-72394d82],.arrow[data-v-72394d82]{background:transparent;border:none}label[data-v-72394d82]{margin-right:10px}.checkbox-title[data-v-72394d82]{margin-left:10px;margin-bottom:0;line-height:40px}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/views/System/SettingsAlarms.vue"],"names":[],"mappings":"AACA,2BACE,eAAgB,AAChB,kBAAoB,CACrB,AACD,6BACE,aAAe,CAChB,AACD,qCACE,kBAAoB,CACrB,AACD,gCACE,UAAa,AACb,kBAAmB,AACnB,kBAAoB,CAIrB,AACD,2DAJE,uBAAwB,AACxB,YAAa,AACb,2BAA8B,CAS/B,AAPD,2BACE,aAAc,AACd,oBAAqB,AACrB,gBAAkB,CAInB,AACD,iCACE,YAAc,CACf,AACD,iCACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,iBAAmB,CACpB,AACD,sCACE,iBAAmB,CACpB,AACD,oDACE,YAAc,CACf,AACD,wBACE,sBAAwB,CACzB,AACD,qDAEE,uBAAwB,AACxB,WAAa,CACd,AACD,uBACE,iBAAmB,CACpB,AACD,iCACE,iBAAkB,AAClB,gBAAmB,AACnB,gBAAkB,CACnB","file":"SettingsAlarms.vue","sourcesContent":["\n.tab-text[data-v-72394d82] {\n  font-size: 18px;\n  white-space: nowrap;\n}\n.unselected[data-v-72394d82] {\n  color: #ADD4D9;\n}\n.dismiss-all-button[data-v-72394d82] {\n  white-space: nowrap;\n}\n.filter-button[data-v-72394d82] {\n  padding: 0px;\n  padding-left: 20px;\n  padding-right: 20px;\n  background: transparent;\n  border: none;\n  border-right: 1px solid white;\n}\n.farm-tab[data-v-72394d82] {\n  padding: 24px;\n  padding-bottom: 10px;\n  padding-top: 10px;\n  background: transparent;\n  border: none;\n  border-right: 1px solid white;\n}\n.farm-tab[data-v-72394d82]:focus {\n  outline: none;\n}\n.alarms-headers[data-v-72394d82] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  overflow-x: hidden;\n}\n.farm-tab[data-v-72394d82]:last-child {\n  border-right: none;\n}\n.alarms-headers[data-v-72394d82]::-webkit-scrollbar {\n  display: none;\n}\n.arrow[data-v-72394d82] {\n  background: transparent;\n}\n.arrow[data-v-72394d82],\n.arrow-hint[data-v-72394d82] {\n  background: transparent;\n  border: none;\n}\nlabel[data-v-72394d82] {\n  margin-right: 10px;\n}\n.checkbox-title[data-v-72394d82] {\n  margin-left: 10px;\n  margin-bottom: 0px;\n  line-height: 40px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 2238:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%","height":"100%","min-width":"1500px","padding":"10px"}},[_c('div',{staticStyle:{"display":"flex","flex-direction":"column","flex":"1","height":"100%","min-width":"1500px"}},[_c('modal',{attrs:{"showDialog":_vm.activeModal == 'INFO',"title":_vm.activeObject != null ? _vm.$t('Status') + ' ' + _vm.activeObject.systemName + ' (' + _vm.activeDay + ' ' + _vm.$t('daysAgo') + ')' : ''},on:{"close":_vm.closeModal}},[_c('system-alarms-details-modal',{attrs:{"data":_vm.activeObject,"day":_vm.activeDay,"apiMethodName":'getAlarmsForDetailsModal',"value":_vm.activeValue}})],1),_vm._v(" "),_c('modal',{attrs:{"showDialog":_vm.activeModal == 'SCICHART',"title":_vm.activeObject != null ? _vm.$t('StatusAlarms') : ''},on:{"close":_vm.closeModal}},[(_vm.activeModal === 'SCICHART')?_c('sci-chart-per-device',{attrs:{"device-obj":_vm.activeObject,"sid":5,"initialZoomOut":true,"systemId":_vm.activeObject.systemId,"activeSet":0,"allAlarmTypes":_vm.allAlarmTypes}}):_vm._e()],1),_vm._v(" "),_c('ejs-grid',{ref:"grid",staticStyle:{"position":"relative"},attrs:{"height":"100%","width":"100%","toolbar":_vm.toolbar,"toolbarClick":_vm.toolbarClick,"selectionSettings":_vm.selectionOptions,"allowTextWrap":true,"textWrapSettings":_vm.wrapSettings,"dataBound":_vm.dataBound,"dataSource":_vm.data,"allowPaging":true,"pageSettings":_vm.pageSettings,"allowFiltering":true,"filterSettings":_vm.filterOptions,"allowSorting":true,"allowMultiSorting":true,"allowPdfExport":true,"allowCsvExport":true,"allowExcelExport":true,"showBusyIndicator":true,"excelExportComplete":_vm.exportComplete,"pdfExportComplete":_vm.exportComplete}},[_c('e-columns',[_c('e-column',{attrs:{"field":"number","headerText":_vm.$t('Unit'),"textAlign":"Left","customAttributes":_vm.customAttributes}}),_vm._v(" "),_c('e-column',{attrs:{"field":"type","headerText":_vm.$t('Type'),"textAlign":"Left","customAttributes":_vm.customAttributes}}),_vm._v(" "),_c('e-column',{attrs:{"field":"alarmType","headerText":_vm.$t('AlarmType'),"textAlign":"Left","customAttributes":_vm.customAttributes}}),_vm._v(" "),_c('e-column',{attrs:{"field":"priority","headerText":_vm.$t('Priority'),"textAlign":"Left","customAttributes":_vm.customAttributes}}),_vm._v(" "),_c('e-column',{attrs:{"field":"status","headerText":_vm.$t('Status'),"template":_vm.StatusTemplate,"allowFiltering":false,"allowSorting":false,"customAttributes":_vm.customAttributes,"width":"220px"}}),_vm._v(" "),_c('e-column',{attrs:{"field":"priority","headerText":'',"template":_vm.SciChartTemplate,"textAlign":"Left","customAttributes":_vm.customAttributes,"allowFiltering":false,"width":"100px"}})],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/5.09fbe9a625bf6219525c.js